webpackJsonp([2],{

/***/ 1006:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1013:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1014:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1017:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1020:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1021:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1023:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1024:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1025:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1028:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1029:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1031:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1032:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1033:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1034:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1035:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1036:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1037:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1038:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1039:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1040:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1041:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1042:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1043:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1046:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1047:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1050:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1051:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1052:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1055:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1056:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1057:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1058:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1060:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1061:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1062:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1063:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1064:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1065:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1066:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1067:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1071:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1072:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sllogo.68dd62b.png";

/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1067)

var Component = __webpack_require__(7)(
  /* script */
  null,
  /* template */
  __webpack_require__(1150),
  /* scopeId */
  "data-v-af5f1a62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1020)
__webpack_require__(1019)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(1126),
  /* scopeId */
  "data-v-2faede10",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1028)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(1131),
  /* scopeId */
  "data-v-3ace74a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1007)
__webpack_require__(1006)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1120),
  /* scopeId */
  "data-v-24f547d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1058)
__webpack_require__(1057)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(1146),
  /* scopeId */
  "data-v-7a995061",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1032)
__webpack_require__(1031)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(1133),
  /* scopeId */
  "data-v-3df9694d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1016)
__webpack_require__(1015)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(1124),
  /* scopeId */
  "data-v-2af97c1a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1055)
__webpack_require__(1056)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(1145),
  /* scopeId */
  "data-v-76067459",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1063)
__webpack_require__(1064)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(1148),
  /* scopeId */
  "data-v-982c78ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1022)
__webpack_require__(1023)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(1128),
  /* scopeId */
  "data-v-301e8b03",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1098:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1043)
__webpack_require__(1044)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(1139),
  /* scopeId */
  "data-v-65fcb2b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1029)
__webpack_require__(1030)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1132),
  /* scopeId */
  "data-v-3b8c905f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1100:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1013)
__webpack_require__(1014)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1123),
  /* scopeId */
  "data-v-28d04310",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1101:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1052)
__webpack_require__(1051)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(1143),
  /* scopeId */
  "data-v-7146db98",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1102:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1025)
__webpack_require__(1024)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(1129),
  /* scopeId */
  "data-v-33050525",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1070)
__webpack_require__(1071)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(1152),
  /* scopeId */
  "data-v-d41ef97a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1065)
__webpack_require__(1066)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1149),
  /* scopeId */
  "data-v-a3f90a18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1072)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(1153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1106:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1017)
__webpack_require__(1018)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(1125),
  /* scopeId */
  "data-v-2ee844c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1107:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1021)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1127),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1108:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1068)
__webpack_require__(1069)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1151),
  /* scopeId */
  "data-v-bf9bb224",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1036)
__webpack_require__(1038)
__webpack_require__(1037)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(1136),
  /* scopeId */
  "data-v-5408bca8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1110:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1012)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1122),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1111:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1059)
__webpack_require__(1062)
__webpack_require__(1060)
__webpack_require__(1061)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(1147),
  /* scopeId */
  "data-v-94e71086",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1112:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1026)
__webpack_require__(1027)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1130),
  /* scopeId */
  "data-v-380ef260",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1113:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1035)
__webpack_require__(1034)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(1135),
  /* scopeId */
  "data-v-44baaf0f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1114:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1008)
__webpack_require__(1009)
__webpack_require__(1010)
__webpack_require__(1011)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1121),
  /* scopeId */
  "data-v-25c9fb22",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1045)
__webpack_require__(1046)
__webpack_require__(1047)
__webpack_require__(1048)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(1140),
  /* scopeId */
  "data-v-66b62dc0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1049)
__webpack_require__(1050)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(1142),
  /* scopeId */
  "data-v-71122f54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1041)
__webpack_require__(1042)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1138),
  /* scopeId */
  "data-v-5d0e2903",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1118:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1039)
__webpack_require__(1040)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1137),
  /* scopeId */
  "data-v-559b9ff0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1054)
__webpack_require__(1053)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(1144),
  /* scopeId */
  "data-v-743a7f59",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1120:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), (_vm.plist.length > 0) ? _c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "ta"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.plist), function(item, index) {
    return _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell",
      on: {
        "click": function($event) {}
      }
    }, [_c('span', [_vm._v(_vm._s(item.bill_sdate) + "~" + _vm._s(item.bill_edate))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.channel_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_32 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.platform))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_33 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.ctype))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_34 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.num))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_35 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.atv))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.amount))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.type_text))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell blue",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: '成本日报详情',
            params: {
              issued_app_id: item.issued_app_id
            },
            query: {
              sdate: item.bill_sdate,
              edate: item.bill_edate,
              channel_id: item.channel_id
            }
          })
        }
      }
    }, [_vm._v("查看详情")])])])
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.company.type == 1 ? '企业' : '个人') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("发票类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.invoice_type == 1 ? '普通发票' : '增值发票') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("新增用户\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.num) + "\t")])]), _vm._v(" "), (_vm.bill.offset == 1) ? _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("抵扣金额\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.offset_amount) + "\t")])]) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.company.type == 1) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算金额\t")]) : _vm._e(), _vm._v(" "), (_vm.company.type == 2) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算金额(扣去税点后金额)\t")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.bill_amount) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算金额（人民币大写）\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.big_bill_amount) + "\t")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("乙方公司 ：" + _vm._s(_vm.company.name))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("税号：" + _vm._s(_vm.company.social_credit_code))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[3]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("注册地址：" + _vm._s(_vm.company.company_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("注册电话：" + _vm._s(_vm.company.company_phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[8]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("开户银行 ：" + _vm._s(_vm.company.opening_bank))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("银行 账号：" + _vm._s(_vm.company.receiving_account))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("联系人：" + _vm._s(_vm.company.contact))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[6]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("联系电话：" + _vm._s(_vm.company.phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[7]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("邮寄地址：" + _vm._s(_vm.company.email_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[5]))])])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.plist.length == 0) ? _c('div', [_vm._v("\n\t\t\t暂无对账单\n\t\t")]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_32",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_33",
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_34",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_35",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "gutter",
      "width": "0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "10",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算对账单")])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("游戏名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("渠道名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_32  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("平台")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_33  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("合作方式")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_34  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("计价人数")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_35  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("单价（元/个）")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("应付金额（￥）")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("类型")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("操作")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "10"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "10"
    }
  }, [_vm._v(" ")])])
}]}

/***/ }),

/***/ 1121:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "today"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "seven"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "内部游戏",
      "value": "内部游戏"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外部游戏",
      "value": "外部游戏"
    }
  })], 1), _vm._v(" "), _c('searchApp', {
    staticClass: "xs24",
    attrs: {
      "compare": "issued"
    },
    on: {
      "getid": _vm.changeId
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fieldConfig
    }
  }, [_vm._v("字段选择")])], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), (_vm.cdata.list.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.cdata.list,
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "发行名称",
      "align": "center",
      "min-width": "120px"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center",
        "sortable": "",
        "sort-method": function (a, b) {
          return parseFloat(a[item.key]) - parseFloat(b[item.key])
        }
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(scope) {
          return [(item.key == 'ltv') ? _c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": '截至' + _vm.pdata.edate + '的累计数据',
              "placement": "top-start"
            }
          }, [_c('span', [_vm._v(_vm._s(item.name)), _c('i', {
            staticClass: "el-icon-question"
          })])]) : _c('span', [_vm._v(_vm._s(item.name))])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '整体数据详情',
                params: {
                  issued_app_id: scope.row.issued_app_id
                },
                query: {
                  edate: _vm.pdata.edate,
                  sdate: _vm.pdata.sdate
                }
              })
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 2731992457)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.cdata.list.length == 0) ? _c('div', {
    staticClass: "el-table el-table--fit el-table--striped el-table--enable-row-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80, 200, 500],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "我是标题",
      "size": "580px",
      "visible": _vm.drawer,
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("设置显示字段")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("可选字段")]), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTap(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selectFieldList),
      callback: function($$v) {
        _vm.selectFieldList = $$v
      },
      expression: "selectFieldList"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.selectFieldList), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('i', {
      staticClass: "el-icon-rank"
    }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeSelectField(item)
        }
      }
    })])
  }), 0)], 1)], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-table__body-wrapper is-scrolling-none"
  }, [_c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v("暂无数据")])])])
}]}

/***/ }),

/***/ 1122:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1200px",
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "span": 14
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary",
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "seven"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "min-width": "150px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-input', {
    ref: "input",
    staticClass: "search",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入小程序名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.cdata.list,
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "app_name",
      "label": "发行游戏",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "d_date",
      "label": "日期",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_channel",
      "label": "渠道",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_new",
      "label": "新增UV",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv",
      "label": "UV",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jump_per",
      "label": "跳出率",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.jump_per != null) ? _c('span', [_vm._v(_vm._s(scope.row.jump_per || 0) + "%")]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "day1",
      "label": "1日留存",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.day1 != null) ? _c('span', [_vm._v(_vm._s(scope.row.day1 || 0) + "%")]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "day2",
      "label": "2日留存",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.day2 != null) ? _c('span', [_vm._v(_vm._s(scope.row.day2 || 0) + "%")]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "day3",
      "label": "3日留存",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.day3 != null) ? _c('span', [_vm._v(_vm._s(scope.row.day3 || 0) + "%")]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "day4",
      "label": "4日留存",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.day4 != null) ? _c('span', [_vm._v(_vm._s(scope.row.day4 || 0) + "%")]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "day5",
      "label": "5日留存",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.day5 != null) ? _c('span', [_vm._v(_vm._s(scope.row.day5 || 0) + "%")]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "day6",
      "label": "6日留存",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.day6 != null) ? _c('span', [_vm._v(_vm._s(scope.row.day6 || 0) + "%")]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "day7",
      "label": "7日留存",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.day7 != null) ? _c('span', [_vm._v(_vm._s(scope.row.day7 || 0) + "%")]) : _c('span', [_vm._v("--")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1123:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请输入/选择小程序名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct(item)
        }
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择采集来源"
    },
    model: {
      value: (_vm.pdata.type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "type", $$v)
      },
      expression: "pdata.type"
    }
  }, _vm._l((_vm.config), function(item, index) {
    return _c('el-option', {
      key: index + 1,
      attrs: {
        "label": item,
        "value": index + 1
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "multiple": "",
      "filterable": "",
      "placeholder": "请选择对应公司"
    },
    model: {
      value: (_vm.pdata.company),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "company", $$v)
      },
      expression: "pdata.company"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择对应渠道"
    },
    model: {
      value: (_vm.pdata.channel_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "channel_id", $$v)
      },
      expression: "pdata.channel_id"
    }
  }, _vm._l((_vm.ChannelList), function(item, index) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.ald_channel,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "clearable": "",
      "placeholder": "导量来源"
    },
    model: {
      value: (_vm.pdata.data_source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "data_source", $$v)
      },
      expression: "pdata.data_source"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "矩阵导量",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "广点通导量",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外部渠道导量",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "clearable": "",
      "placeholder": "产品归属"
    },
    model: {
      value: (_vm.pdata.product_belongs),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "product_belongs", $$v)
      },
      expression: "pdata.product_belongs"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "内部矩阵",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外部渠道",
      "value": "2"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请选择状态"
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.pdata.status),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "status", $$v)
      },
      expression: "pdata.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "正常",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已通知下线",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已确认下线",
      "value": "2"
    }
  })], 1), _vm._v(" "), (_vm.dateVal[0] == _vm.dateVal[1]) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success",
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.updateCostHander
    }
  }, [_vm._v("更新成本")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "selfTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-class-name": _vm.tableRowClassName,
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height,
      "default-sort": {
        prop: '_visit_uv_new',
        order: 'descending'
      }
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [(_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
    staticClass: "expandd",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center",
            "width": "208px"
          }
        }), _vm._v(" "), (_vm.pdata.type != 3) ? _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "对应公司",
            "align": "center",
            "width": "100px"
          }
        }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "ald_channel",
            "show-overflow-tooltip": "",
            "label": "对应渠道",
            "align": "center",
            "min-width": "100px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "type",
            "show-overflow-tooltip": "",
            "label": "采集来源",
            "align": "center",
            "min-width": "100px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "atv",
            "label": "单价",
            "align": "center",
            "min-width": "70px",
            "formatter": _vm.fixed2Formatter
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n\t\t\t                         ￥"), _c('span', [_vm._v(_vm._s(scope.row.atv))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "visit_uv_new",
            "label": "买量新增",
            "min-width": "100px",
            "align": "center",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a.visit_uv_new - 0) - (b.visit_uv_new - 0)
            }
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "cost",
            "label": "买量成本",
            "align": "center",
            "min-width": "100px",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a.cost - 0) - (b.cost - 0)
            }
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n\t\t\t                         ￥"), _c('span', [_vm._v(_vm._s(scope.row.cost))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "_visit_uv_new",
            "label": "实际买量新增",
            "min-width": "130px",
            "align": "center",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a._visit_uv_new - 0) - (b._visit_uv_new - 0)
            }
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "min-width": "130px",
            "prop": "_visit_uv",
            "label": "实际活跃用户",
            "align": "center",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a._visit_uv - 0) - (b._visit_uv - 0)
            }
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "_cost",
            "label": "实际买量成本",
            "formatter": _vm.fixed2Formatter,
            "min-width": "130px",
            "align": "center",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a._cost - 0) - (b._cost - 0)
            }
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n\t\t\t                         ￥"), _c('span', [_vm._v(_vm._s(scope.row._cost))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "cost_per",
            "label": "实际买量单价",
            "min-width": "130px",
            "align": "center",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a.cost_per - 0) - (b.cost_per - 0)
            }
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n\t\t\t                         ￥"), _c('span', [_vm._v(_vm._s(scope.row.cost_per))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "update_time",
            "label": "下线时间",
            "align": "center",
            "min-width": "140px",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.update_time != null && (scope.row.status == 0 || scope.row.status == 2)) ? _c('span', [_vm._v(_vm._s(scope.row.update_time))]) : _c('span', [_vm._v("--")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "",
            "label": "操作",
            "fixed": "right",
            "align": "center",
            "width": "290"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.groupid == 4 || _vm.groupid == 0 || _vm.groupid == 1) ? _c('el-button', {
                attrs: {
                  "size": "mini",
                  "type": "primary"
                },
                nativeOn: {
                  "click": function($event) {
                    return _vm.editProduct(scope.row, s.$index)
                  }
                }
              }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (scope.row.status == 0) ? _c('el-button', {
                staticStyle: {
                  "width": "90px"
                },
                attrs: {
                  "size": "mini",
                  "type": "danger"
                },
                nativeOn: {
                  "click": function($event) {
                    return _vm.confirmOff(scope.$index, scope.row)
                  }
                }
              }, [_vm._v("确认下线")]) : (scope.row.status == 1) ? _c('el-button', {
                staticStyle: {
                  "width": "90px"
                },
                attrs: {
                  "size": "mini",
                  "type": "info",
                  "disabled": ""
                }
              }, [_vm._v("正常")]) : (scope.row.status == 2) ? _c('el-button', {
                staticStyle: {
                  "width": "90px"
                },
                attrs: {
                  "size": "mini",
                  "type": "info",
                  "disabled": ""
                }
              }, [_vm._v("已确认下线")]) : _c('el-button', {
                staticStyle: {
                  "width": "90px"
                },
                attrs: {
                  "size": "mini",
                  "type": "info",
                  "disabled": ""
                }
              }, [_vm._v("确认下线")])]
            }
          }], null, true)
        })], 1)]
      }
    }], null, false, 678279218)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_name",
      "show-overflow-tooltip": "",
      "label": "发行游戏",
      "align": "center",
      "min-width": "160px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "show-overflow-tooltip": "",
      "label": "对应公司",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_channel",
      "show-overflow-tooltip": "",
      "label": "对应渠道",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "show-overflow-tooltip": "",
      "label": "采集来源",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "atv",
      "label": "单价",
      "align": "center",
      "min-width": "70px",
      "formatter": _vm.fixed2Formatter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      ￥"), _c('span', [_vm._v(_vm._s(scope.row.atv))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_new",
      "label": "买量新增",
      "min-width": "100px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_new - 0) - (b.visit_uv_new - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost",
      "label": "买量成本",
      "align": "center",
      "min-width": "100px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost - 0) - (b.cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      ￥"), _c('span', [_vm._v(_vm._s(scope.row.cost))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "_visit_uv_new",
      "label": "实际买量新增",
      "min-width": "130px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv_new - 0) - (b._visit_uv_new - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "130px",
      "prop": "_visit_uv",
      "label": "实际活跃用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv - 0) - (b._visit_uv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "_cost",
      "label": "实际买量成本",
      "formatter": _vm.fixed2Formatter,
      "min-width": "130px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._cost - 0) - (b._cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      ￥"), _c('span', [_vm._v(_vm._s(scope.row._cost))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost_per",
      "label": "实际买量单价",
      "min-width": "130px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost_per - 0) - (b.cost_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      ￥"), _c('span', [_vm._v(_vm._s(scope.row.cost_per))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "下线时间",
      "align": "center",
      "min-width": "140px",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.update_time != null && (scope.row.status == 0 || scope.row.status == 2)) ? _c('span', [_vm._v(_vm._s(scope.row.update_time))]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "290"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '更多数据',
                params: {
                  issued_app_id: scope.row.issued_app_id
                },
                query: {
                  sdate: _vm.pdata.sdate,
                  edate: _vm.pdata.edate,
                  getWhich: '买量详情'
                }
              })
            }
          }
        }, [_vm._v("回本详情")]), _vm._v(" "), ((_vm.groupid == 4 || _vm.groupid == 0 || _vm.groupid == 1) && (_vm.dateVal[0] === _vm.dateVal[1])) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editProduct(scope.row, '')
            }
          }
        }, [_vm._v("编辑")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑实际买量",
      "visible": _vm.editDialog,
      "width": "550px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.chooseEditProduct
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际活跃用户"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "step": 1,
      "precision": 0,
      "min": 0,
      "label": "",
      "controls": false
    },
    model: {
      value: (_vm.chooseEditProduct.visit_uv_input),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "visit_uv_input", $$v)
      },
      expression: "chooseEditProduct.visit_uv_input"
    }
  })], 1)], 1), _vm._v(" "), (_vm.chooseEditProduct.type != 5) ? _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际买量新增"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "step": 1,
      "precision": 0,
      "disabled": _vm.chooseEditProduct._visit_uv_new_o != 0,
      "min": 0,
      "label": "",
      "controls": false
    },
    on: {
      "change": _vm.visitUvNewKeyup
    },
    model: {
      value: (_vm.chooseEditProduct.visit_uv_new_input),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "visit_uv_new_input", $$v)
      },
      expression: "chooseEditProduct.visit_uv_new_input"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseEditProduct.type != 5) ? _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际扣量新增"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "step": 1,
      "precision": 0,
      "min": 0,
      "label": "",
      "controls": false
    },
    model: {
      value: (_vm.chooseEditProduct.visit_uv_new_o),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "visit_uv_new_o", $$v)
      },
      expression: "chooseEditProduct.visit_uv_new_o"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseEditProduct.type != 5) ? _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际买量成本"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "disabled": _vm.chooseEditProduct.type != 3,
      "precision": 2,
      "min": 0,
      "label": "",
      "controls": false
    },
    model: {
      value: (_vm.chooseEditProduct.cost_input),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "cost_input", $$v)
      },
      expression: "chooseEditProduct.cost_input"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseEditProduct.type != 3) ? _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "买量单价"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "precision": 2,
      "min": 0,
      "label": "",
      "controls": false
    },
    on: {
      "change": _vm.atvKeyup
    },
    model: {
      value: (_vm.chooseEditProduct.atv),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "atv", $$v)
      },
      expression: "chooseEditProduct.atv"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "采集来源"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择计价方式"
    },
    on: {
      "change": _vm.typeKeyup
    },
    model: {
      value: (_vm.chooseEditProduct.type),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "type", $$v)
      },
      expression: "chooseEditProduct.type"
    }
  }, _vm._l((_vm.config), function(item, index) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": index + 1
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editChooseProduct($event)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1124:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t公司名称：\n\t\t\t"), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择公司名称"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.cp_company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "cp_company_id", $$v)
      },
      expression: "pdata.cp_company_id"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t 结算期：\n\t\t\t"), _c('el-date-picker', {
    attrs: {
      "type": "monthrange",
      "format": "yyyyMM",
      "value-format": "yyyyMM",
      "start-placeholder": "开始月份",
      "end-placeholder": "结束月份"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.d_date),
      callback: function($$v) {
        _vm.d_date = $$v
      },
      expression: "d_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t 分成方式：  \n\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择账单类型"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.bill_type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "bill_type", $$v)
      },
      expression: "pdata.bill_type"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": "汇总",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "1",
    attrs: {
      "label": "原生分成账单",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "利润分成账单",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "icon": "el-icon-download",
      "type": "primary"
    },
    on: {
      "click": _vm.getBillList
    }
  }, [_vm._v("导出预览")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "公司名称",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "结算周期",
      "min-width": "140px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(scope.row.sdate) + "~" + _vm._s(scope.row.edate) + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_cost",
      "label": "结算金额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t￥" + _vm._s(scope.row.total_cost) + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "min-width": "50px",
      "width": "400",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push('/billCpData/summary/' + scope.row.cp_company_id + '?sdate=' + scope.row.sdate + '&edate=' + scope.row.edate)
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "分成账单统计",
      "visible": _vm.billDialog,
      "width": "900px",
      "custom-class": "dialog",
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.billDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm"
  }, [_c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "900px"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "33%"
    }
  })]), _vm._v(" "), _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('td', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "3",
      "rowspan": "1"
    }
  }, [(_vm.pdata.bill_type == 0) ? _c('div', {
    staticClass: "cell"
  }, [_vm._v("汇总分成统计")]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 1) ? _c('div', {
    staticClass: "cell"
  }, [_vm._v("原生分成统计")]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('div', {
    staticClass: "cell"
  }, [_vm._v("利润分成统计")]) : _vm._e()])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("公司名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算金额")])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.billList), function(item, index) {
    return _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('span', [_vm._v(_vm._s(item.sdate) + "~" + _vm._s(item.edate))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.company_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v("￥" + _vm._s(item.total_cost))])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_29 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t合计\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_30 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_31 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.total_cost) + "\n\t\t\t\t\t\t\t\t")])])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.tableToExcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleDown
    }
  }, [_vm._v("导出pdf")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.billDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1125:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 24,
      "span": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-arrow-left",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: '基础数据'
        })
      }
    }
  }), _vm._v(" "), _c('el-radio-group', {
    staticClass: "rgroup ",
    staticStyle: {
      "margin-left": "60px"
    },
    on: {
      "change": _vm.changeGet
    },
    model: {
      value: (_vm.getWhich),
      callback: function($$v) {
        _vm.getWhich = $$v
      },
      expression: "getWhich"
    }
  }, [_c('el-radio-button', {
    staticClass: "radio xs24",
    attrs: {
      "label": "访问分析"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    staticClass: "radio xs24",
    attrs: {
      "label": "来源分析"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    staticClass: "radio xs24",
    attrs: {
      "label": "用户画像"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": _vm.pdata.sdate,
      "end-placeholder": _vm.pdata.edate,
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), (_vm.getWhich == '访问分析') ? _c('el-row', [_c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "20px auto 0",
      "padding": "0 20px",
      "box-sizing": "border-box"
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.select
    },
    model: {
      value: (_vm.pdata.visit),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "visit", $$v)
      },
      expression: "pdata.visit"
    }
  }, _vm._l((_vm.config), function(vv, k) {
    return _c('el-option', {
      key: k,
      attrs: {
        "value": k,
        "label": vv
      }
    })
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.getWhich == '访问分析') ? _c('el-row', {
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getWhich == '来源分析') ? _c('el-row', {
    staticClass: "lyfx",
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px",
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chart1"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px",
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chart2"
    }
  }), _vm._v(">\n    "), _c('div', {
    staticStyle: {
      "margin": "20px",
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chart3"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px",
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chart4"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getWhich == '用户画像') ? _c('el-row', {
    staticClass: "lyfx",
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px",
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "c1"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px",
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "c2"
    }
  }), _vm._v(">\n    "), _c('div', {
    staticStyle: {
      "margin": "20px",
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "c3"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px",
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "c4"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "xs": 12
    }
  }, [(!_vm.collapsed) ? _c('img', {
    staticClass: "logoImg",
    attrs: {
      "src": __webpack_require__(1087)
    },
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }, [_vm._v("小森林")]), _vm._v("\n         |   \n      "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/mainData/index')
      }
    }
  }, [_vm._v(_vm._s(_vm.collapsed ? '' : _vm.sysName))])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "xs": 24,
      "sm": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_vm._v("\n            " + _vm._s(_vm.uName) + "\n          ")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.cpwd($event)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "sm": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    class: [!_vm.collapsed ? 'expanded' : '', 'el-menu-vertical-demo'],
    attrs: {
      "default-active": _vm.dpath,
      "router": "",
      "unique-opened": ""
    },
    on: {
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.menu), function(item, index) {
    return [(item.child) ? _c('el-submenu', {
      key: item.id,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: _vm.iconClass[index]
    }), _vm._v("\n                " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _vm._l((item.child), function(child) {
      return _c('el-menu-item', {
        key: child.id,
        attrs: {
          "index": '/' + child.url
        }
      }, [_vm._v(_vm._s(child.name))])
    })], 2) : _vm._e(), _vm._v(" "), (!item.child && item.url && item.name != '多平台采集') ? _c('el-menu-item', {
      key: item.id,
      attrs: {
        "index": '/' + item.url
      },
      on: {
        "click": function($event) {
          return _vm.$router.push('/' + item.url)
        }
      }
    }, [_c('i', {
      class: _vm.iconClass[index]
    }), _vm._v("\n              " + _vm._s(item.name) + "\n            ")]) : _vm._e(), _vm._v(" "), (!item.child && item.name == '多平台采集') ? _c('el-menu-item', {
      key: item.id,
      attrs: {
        "index": ""
      },
      on: {
        "click": function($event) {
          return _vm.jump(item.url)
        }
      }
    }, [_c('i', {
      class: _vm.iconClass[index]
    }), _vm._v("\n              " + _vm._s(item.name) + "\n            ")]) : _vm._e()]
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "el-submenu item"
    }, [(item.child) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: _vm.iconClass[index]
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.child), function(child) {
      return _c('li', {
        key: child.id,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.url ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push('/' + child.url)
          }
        }
      }, [_vm._v(_vm._s(child.name))])
    }), 0)] : [_c('li', {
      staticClass: "el-submenu",
      on: {
        "click": function($event) {
          return _vm.$router.push('/' + item.url)
        }
      }
    }, [_c('div', {
      staticClass: "el-submenu__title",
      class: _vm.$route.path == item.url ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.url)
        }
      }
    }, [_c('i', {
      class: _vm.iconClass[index]
    })])])]], 2)
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "sm": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.$route.meta.keepAlive) ? _c('keep-alive', [_c('router-view', {
    ref: "myMain"
  })], 1) : _c('router-view', {
    ref: "myMain"
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.updatePwd,
      "width": "400px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.updatePwd = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入原密码",
      "label-width": "120px",
      "prop": "old_password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "show-password": ""
    },
    model: {
      value: (_vm.form.old_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "old_password", $$v)
      },
      expression: "form.old_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请输入新密码",
      "label-width": "120px",
      "prop": "new_password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "show-password": ""
    },
    model: {
      value: (_vm.form.new_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "new_password", $$v)
      },
      expression: "form.new_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "label-width": "120px",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "show-password": ""
    },
    model: {
      value: (_vm.form.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkPass", $$v)
      },
      expression: "form.checkPass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.updatePwd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changePwd
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1127:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入渠道名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入发行游戏名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.pdata.issued_app_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_name", $$v)
      },
      expression: "pdata.issued_app_name"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择对应公司"
    },
    model: {
      value: (_vm.pdata.company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "company_id", $$v)
      },
      expression: "pdata.company_id"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item.company_id,
      attrs: {
        "label": item.company_name,
        "value": item.company_id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择采集来源",
      "clearable": ""
    },
    model: {
      value: (_vm.pdata.type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "type", $$v)
      },
      expression: "pdata.type"
    }
  }, _vm._l((_vm.config), function(item, index) {
    return _c('el-option', {
      key: index + 1,
      attrs: {
        "label": item,
        "value": index + 1
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, -1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.batchProduct
    }
  }, [_vm._v("批量增加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": _vm.downloadTemp
    }
  }, [_vm._v("导入模板下载")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "align": "center",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_name",
      "label": "发行游戏名称",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editProduct(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.app_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "采集公司",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_short_name",
      "label": "对应公司",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_channel",
      "label": "对应渠道",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "创建时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "exchange",
      "label": "是否换量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.exchange == 0) ? _c('span', [_vm._v("否")]) : (scope.row.exchange == 1) ? _c('span', [_vm._v("是")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "采集来源",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('span', [_vm._v("阿拉丁")]) : (scope.row.type == 2) ? _c('span', [_vm._v("微信")]) : (scope.row.type == 3) ? _c('span', [_vm._v("广点通")]) : (scope.row.type == 4) ? _c('span', [_vm._v("内部矩阵")]) : (scope.row.type == 5) ? _c('span', [_vm._v("阿拉丁换量")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "atv",
      "label": "获客单价",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_price",
      "label": "点击单价",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "下线时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status != 1) ? _c('span', [_vm._v(_vm._s(scope.row.update_time))]) : _c('span', [_vm._v(" ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "渠道状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.pdata.kw == '' && _vm.pdata.issued_app_name == '' && _vm.pdata.company == '') ? _c('div', [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd == true ? '新增' : '编辑',
      "visible": _vm.editDialog,
      "width": "550px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发行小游戏",
      "prop": "issued_app_id"
    }
  }, [_c('searchApp', {
    attrs: {
      "compare": "issued",
      "pholder": _vm.form.app_name,
      "platform_id": ''
    },
    on: {
      "getid": function (res) {
        _vm.form.issued_app_id = res
      },
      "getInfo": function (r) {
        _vm.form.app_name = r.name
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "xsl_from",
      "prop": "xsl_from"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "xsl_from"
    },
    model: {
      value: (_vm.form.xsl_from),
      callback: function($$v) {
        _vm.$set(_vm.form, "xsl_from", $$v)
      },
      expression: "form.xsl_from"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对应渠道",
      "prop": "ald_channel"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "输入阿拉丁后台对应渠道"
    },
    model: {
      value: (_vm.form.ald_channel),
      callback: function($$v) {
        _vm.$set(_vm.form, "ald_channel", $$v)
      },
      expression: "form.ald_channel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择对应公司",
      "prop": "company_id"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择对应公司"
    },
    model: {
      value: (_vm.form.company_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_id", $$v)
      },
      expression: "form.company_id"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item.company_id,
      attrs: {
        "label": item.company_name,
        "value": item.company_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对应公司",
      "prop": "company"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "company"
    },
    model: {
      value: (_vm.form.company),
      callback: function($$v) {
        _vm.$set(_vm.form, "company", $$v)
      },
      expression: "form.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "采集来源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.config), function(it, idx) {
    return _c('el-radio', {
      key: idx,
      attrs: {
        "label": idx + 1
      }
    }, [_vm._v(_vm._s(it))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "导量来源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.data_source),
      callback: function($$v) {
        _vm.$set(_vm.form, "data_source", $$v)
      },
      expression: "form.data_source"
    }
  }, [_c('el-radio', {
    key: "1",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("矩阵导量")]), _vm._v(" "), _c('el-radio', {
    key: "2",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("广点通导量")]), _vm._v(" "), _c('el-radio', {
    key: "3",
    attrs: {
      "label": "3"
    }
  }, [_vm._v("外部渠道导量")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否换量"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.exchange),
      callback: function($$v) {
        _vm.$set(_vm.form, "exchange", $$v)
      },
      expression: "form.exchange"
    }
  }, [_c('el-radio', {
    key: "0",
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    key: "1",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品归属"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.product_belongs),
      callback: function($$v) {
        _vm.$set(_vm.form, "product_belongs", $$v)
      },
      expression: "form.product_belongs"
    }
  }, [_c('el-radio', {
    key: "1",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("内部矩阵")]), _vm._v(" "), _c('el-radio', {
    key: "2",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("外部渠道")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "买量来源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.buy_source),
      callback: function($$v) {
        _vm.$set(_vm.form, "buy_source", $$v)
      },
      expression: "form.buy_source"
    }
  }, [_c('el-radio', {
    key: "1",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-radio', {
    key: "2",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("活跃")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "折扣",
      "prop": "discount"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "折扣（0-1）"
    },
    model: {
      value: (_vm.form.discount),
      callback: function($$v) {
        _vm.$set(_vm.form, "discount", $$v)
      },
      expression: "form.discount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "获客单价",
      "prop": "atv"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "atv"
    },
    model: {
      value: (_vm.form.atv),
      callback: function($$v) {
        _vm.$set(_vm.form, "atv", $$v)
      },
      expression: "form.atv"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点击单价",
      "prop": "click_price"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "输入点击单价"
    },
    model: {
      value: (_vm.form.click_price),
      callback: function($$v) {
        _vm.$set(_vm.form, "click_price", $$v)
      },
      expression: "form.click_price"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量增加",
      "visible": _vm.batchDialog,
      "width": "1150px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0) ? _c('el-row', {
      key: index,
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        key: idx,
        attrs: {
          "span": 2
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (this.batchTips == '导入预览') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1128:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-question sicon c1"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("换出日活")]), _vm._v(" "), _c('div', {
    staticClass: "numText t1"
  }, [_vm._v(_vm._s(_vm.visit_uv_out))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon c2"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("换入日活")]), _vm._v(" "), _c('div', {
    staticClass: "numText t2"
  }, [_vm._v(_vm._s(_vm.visit_uv_in))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon c3"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("顺逆差")]), _vm._v(" "), _c('div', {
    staticClass: "numText t3"
  }, [_vm._v(_vm._s(_vm.diff))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(2)
      }
    }
  }, [_vm._v("前天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(31)
      }
    }
  }, [_vm._v("最近31天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyyMMdd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择对应公司"
    },
    model: {
      value: (_vm.pdata.company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "company_id", $$v)
      },
      expression: "pdata.company_id"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item.company_id,
      attrs: {
        "label": item.company_name,
        "value": item.company_id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "selfTable",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [(_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
    staticClass: "expandd",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "",
            "align": "center",
            "width": "48px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "visit_uv_out",
            "show-overflow-tooltip": "",
            "label": "换出日活",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "visit_uv_in",
            "show-overflow-tooltip": "",
            "label": "换入日活",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "diff",
            "show-overflow-tooltip": "",
            "label": "顺逆差",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "",
            "label": "操作",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" ")])]
            }
          }], null, true)
        })], 1)]
      }
    }], null, false, 3102675841)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "换量公司",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_out",
      "label": "换出日活",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_out - 0) - (b.visit_uv_out - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_in",
      "label": "换入日活",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_in - 0) - (b.visit_uv_in - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "diff",
      "label": "顺逆差",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.diff - 0) - (b.diff - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '扣量日报详情',
                params: {
                  company_id: scope.row.company_id
                },
                query: {
                  sdate: _vm.pdata.sdate,
                  edate: _vm.pdata.edate
                }
              })
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1129:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.createBillData
    }
  }, [_vm._v("生成账单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createBillDataOne()
      }
    }
  }, [_vm._v("批量生成账单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createBillDataALl(0)
      }
    }
  }, [_vm._v("一键批量生成账单")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择公司名称"
    },
    model: {
      value: (_vm.pdata.company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "company_id", $$v)
      },
      expression: "pdata.company_id"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.company_id,
      attrs: {
        "label": item.company_name,
        "value": item.company_id
      }
    })
  }), 1), _vm._v("\n       账单周期：   \n\t\t  "), _c('el-date-picker', {
    attrs: {
      "type": "monthrange",
      "range-separator": "至",
      "start-placeholder": "开始月份",
      "end-placeholder": "结束月份",
      "format": "yyyy 年 MM 月",
      "value-format": "yyyyMM"
    },
    on: {
      "change": _vm.monthValChange
    },
    model: {
      value: (_vm.monthVal),
      callback: function($$v) {
        _vm.monthVal = $$v
      },
      expression: "monthVal"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择账单类型",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.pdata.type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "type", $$v)
      },
      expression: "pdata.type"
    }
  }, [_c('el-option', {
    key: "买量",
    attrs: {
      "label": "买量",
      "value": "买量"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "换量",
    attrs: {
      "label": "换量",
      "value": "换量"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "互导",
    attrs: {
      "label": "互导",
      "value": "互导"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.pdata.status),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "status", $$v)
      },
      expression: "pdata.status"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "未审核",
      "name": "0"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已审核",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "负责人审核",
      "name": "2"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "财务审核",
      "name": "3"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已打款",
      "name": "4"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已废除",
      "name": "-1"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "min-width": "50px",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "结算日期",
      "min-width": "120px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.bill_sdate - 0) - (b.bill_sdate - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.bill_sdate) + "~" + _vm._s(scope.row.bill_edate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "公司名称",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "账单类型",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "导量人数",
      "min-width": "50px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.num - 0) - (b.num - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bill_amount",
      "label": "结算金额",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.bill_amount - 0) - (b.bill_amount - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offset",
      "label": "是否抵扣",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.offset == 1 ? '是' : '否'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bill_amount_offset",
      "label": "抵扣后金额",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.bill_amount_offset - 0) - (b.bill_amount_offset - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "账单状态",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.groupid == 0 || _vm.groupid == 1) ? _c('div', [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("未审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("负责人审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("财务审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已打款")]) : _vm._e(), _vm._v(" "), (scope.row.status == -1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已作废 ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.groupid == 4) ? _c('div', [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("未审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("负责人审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("财务审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("已打款")]) : _vm._e(), _vm._v(" "), (scope.row.status == -1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已作废 ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.groupid == 13) ? _c('div', [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("未审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("已审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("负责人审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("财务审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已打款")]) : _vm._e(), _vm._v(" "), (scope.row.status == -1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已作废 ")]) : _vm._e()], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "min-width": "50px",
      "width": "400",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.updateBillData(scope.row)
            }
          }
        }, [_vm._v("更新账单")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '账单详情明细',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  bill_date: scope.row.bill_date
                }
              })
            }
          }
        }, [_vm._v("明细")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.openDealy(scope.row.id)
            }
          }
        }, [_vm._v("操作日志")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80, 200],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '账单生成' : '账单生成',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "750px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择结算公司"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseCompany),
      callback: function($$v) {
        _vm.chooseCompany = $$v
      },
      expression: "chooseCompany"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.company_id,
      attrs: {
        "label": item.company_name,
        "value": item.company_id
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.buildBillData
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '结算' : '结算',
      "visible": _vm.billDialog,
      "top": "5vh",
      "width": "950px",
      "custom-class": "dialog",
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.billDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "ta"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "160"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "120"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "120"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_32",
      "width": "70"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_33",
      "width": "80"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_34",
      "width": "80"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_35",
      "width": "135"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "135"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "gutter",
      "width": "0"
    }
  })]), _vm._v(" "), _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "8",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算对账单")])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("游戏名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("渠道名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_32  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("平台")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_33  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("合作方式")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_34  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("新增人数")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_35  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("单价（元/个）")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("应付金额（￥）")])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.billList), function(item, index) {
    return _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('span', [_vm._v(_vm._s(item.bill_sdate) + "~" + _vm._s(item.bill_edate))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.channel_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_32 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.platform))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_33 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.ctype))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_34 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.num))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_35 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.atv))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.amount))])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "8"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.company.type == 1 ? '企业' : '个人') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("发票类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.invoice_type == 1 ? '普通发票' : '增值发票') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("新增用户\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.num) + "\t")])]), _vm._v(" "), (_vm.bill.offset == 1) ? _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("抵扣金额\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.offset_amount) + "\t")])]) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.company.type == 1) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额\t")]) : _vm._e(), _vm._v(" "), (_vm.company.type == 2) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额(扣去税点后金额)\t")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.bill_amount) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额（人民币大写）\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.big_bill_amount) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "8"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("乙方公司 ：" + _vm._s(_vm.company.name))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("税号：" + _vm._s(_vm.company.social_credit_code))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[3]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("注册地址：" + _vm._s(_vm.company.company_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("注册电话：" + _vm._s(_vm.company.company_phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[8]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("开户银行 ：" + _vm._s(_vm.company.opening_bank))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("银行 账号：" + _vm._s(_vm.company.receiving_account))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系人：" + _vm._s(_vm.company.contact))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[6]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系电话：" + _vm._s(_vm.company.phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[7]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("邮寄地址：" + _vm._s(_vm.company.email_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[5]))])])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.bill.status == 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 1)
      }
    }
  }, [_vm._v("确认审核")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 2)
      }
    }
  }, [_vm._v("负责人审核")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == 2) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 3)
      }
    }
  }, [_vm._v("财务审核")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == 3) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 4)
      }
    }
  }, [_vm._v("财务打款")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == -1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 0)
      }
    }
  }, [_vm._v("确认恢复")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, -1)
      }
    }
  }, [_vm._v("作废")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.tableToExcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleDown
    }
  }, [_vm._v("导出pdf")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.billDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1130:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 日期：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(30)
      }
    }
  }, [_vm._v("最近30天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 平台来源：  \n\t\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源"
    },
    on: {
      "change": _vm.changePlatform
    },
    model: {
      value: (_vm.pdata.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "platform_id", $$v)
      },
      expression: "pdata.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-option', {
      key: v.platform_id,
      attrs: {
        "label": v.platform_name,
        "value": v.platform_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 小游戏名称：  \n\t\t\t\t"), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择小游戏名称"
    },
    model: {
      value: (_vm.pdata.issued_app_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_id", $$v)
      },
      expression: "pdata.issued_app_id"
    }
  }, _vm._l((_vm.applist), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 操作：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.importData(1)
      }
    }
  }, [_vm._v("投放数据导入")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.importData(2)
      }
    }
  }, [_vm._v("发行数据导入")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fieldConfig
    }
  }, [_vm._v("字段选择")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 模板下载：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.downloadTemp(1)
      }
    }
  }, [_vm._v("投放数据导入模板下载")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.downloadTemp(2)
      }
    }
  }, [_vm._v("发行数据导入模板下载")])], 1)]), _vm._v(" "), (_vm.list.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "issued_app_id"
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "issued_app_name",
      "label": "",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false,
            "row-key": "channel_id"
          },
          on: {
            "expand-change": _vm.expandsChannel
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "channel_name",
            "label": "",
            "align": "center",
            "width": "48px"
          }
        }, [_vm._v(" ")]), _vm._v(" "), (_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
          attrs: {
            "type": "expand",
            "prop": "issued_app_name",
            "label": "",
            "align": "center",
            "width": "48px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ss) {
              return [_c('el-table', {
                attrs: {
                  "data": ss.row.exData,
                  "show-header": false,
                  "row-key": "d_date"
                }
              }, [_c('el-table-column', {
                attrs: {
                  "prop": "issued_app_name",
                  "label": "",
                  "align": "center",
                  "width": "48px"
                }
              }, [_vm._v(" ")]), _vm._v(" "), _c('el-table-column', {
                attrs: {
                  "prop": "issued_app_name",
                  "label": "",
                  "align": "center",
                  "width": "48px"
                }
              }, [_vm._v(" ")]), _vm._v(" "), _c('el-table-column', {
                attrs: {
                  "prop": "d_date",
                  "label": "日期",
                  "align": "center",
                  "width": "150px"
                }
              }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
                return _c('el-table-column', {
                  attrs: {
                    "prop": item.key,
                    "label": item.name,
                    "align": "center"
                  },
                  scopedSlots: _vm._u([{
                    key: "default",
                    fn: function(scope) {
                      return [(item.key == 'origin_income') ? _c('span', [_vm._v("--")]) : (["visit_uv_new_per", "visit_uv_new_jump", "visit_uv_jump", "visit_uv_new_back_0", "visit_uv_back_0", "total_back_0"].indexOf(item.key) > -1) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row[item.key] || 0) + "%\n\t\t\t\t\t\t\t\t\t\t\t")]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
                    }
                  }], null, true)
                })
              })], 2)]
            }
          }], null, true)
        }) : _c('el-table-column', {
          attrs: {
            "prop": "channel_name",
            "label": "",
            "align": "center",
            "width": "48px"
          }
        }, [_vm._v(" ")]), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "channel_name",
            "label": "渠道名称",
            "align": "center",
            "width": "150px"
          }
        }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
          return _c('el-table-column', {
            attrs: {
              "prop": item.key,
              "label": item.name,
              "align": "center"
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function(scope) {
                return [(item.key == 'origin_income') ? _c('span', [_vm._v("--")]) : (["visit_uv_new_per", "visit_uv_new_jump", "visit_uv_jump", "visit_uv_new_back_0", "visit_uv_back_0", "total_back_0"].indexOf(item.key) > -1) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row[item.key] || 0) + "%\n\t\t\t\t\t\t\t\t")]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
              }
            }], null, true)
          })
        })], 2)]
      }
    }], null, false, 1342485642)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "",
      "align": "center",
      "width": "48px"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "发行名称",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(scope) {
          return [_c('span', [_vm._v(_vm._s(item.name))])]
        }
      }, {
        key: "default",
        fn: function(scope) {
          return [(["visit_uv_new_per", "visit_uv_new_jump", "visit_uv_jump", "visit_uv_new_back_0", "visit_uv_back_0", "total_back_0"].indexOf(item.key) > -1) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.row[item.key] || 0) + "%\n\t\t\t\t\t")]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
        }
      }], null, true)
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "el-table el-table--fit el-table--striped el-table--enable-row-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "totalBox"
  }, [_c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("合计")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("花费")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("活跃")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("活跃单价")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("新增单价")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "totalBox"
  }, [_c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v(_vm._s(_vm.total.gdt_cost))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v(_vm._s(_vm.total.visit_uv_new))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v(_vm._s(_vm.total.visit_uv))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v(_vm._s(_vm.total.visit_uv_price))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v(_vm._s(_vm.total.visit_uv_new_price))])], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "我是标题",
      "size": "580px",
      "visible": _vm.drawer,
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("设置显示字段")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("可选字段")]), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTap(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selectFieldList),
      callback: function($$v) {
        _vm.selectFieldList = $$v
      },
      expression: "selectFieldList"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.selectFieldList), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('i', {
      staticClass: "el-icon-rank"
    }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeSelectField(item)
        }
      }
    })])
  }), 0)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入",
      "visible": _vm.batchDialog,
      "width": "650px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips == 0 ? '导入预览' : '以下数据导入失败'))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0 && _vm.importType == 1) ? _c('el-row', {
      key: index,
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        key: idx,
        attrs: {
          "span": 4
        }
      }, [_vm._v("\n\t\t\t\t\t" + _vm._s(citem) + "\n\t\t\t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0 && _vm.importType == 2) ? _c('el-row', {
      key: index,
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        key: idx,
        attrs: {
          "span": 6
        }
      }, [_vm._v("\n\t\t\t\t\t" + _vm._s(citem) + "\n\t\t\t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.batchTips == '0') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v("确认")]) : _vm._e(), _vm._v(" "), (_vm.batchTips == '1') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v("知道了")]) : _vm._e()], 1) : _vm._e()], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-table__body-wrapper is-scrolling-none"
  }, [_c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v("暂无数据")])])])
}]}

/***/ }),

/***/ 1131:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入账号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2($event)
      }
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请输入密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2($event)
      }
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1132:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(2)
      }
    }
  }, [_vm._v("前天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.pdata.type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "type", $$v)
      },
      expression: "pdata.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "非矩阵",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "矩阵",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "换量",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchAddProduct
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": _vm.downloadTemp
    }
  }, [_vm._v("导入模板下载")])], 1)], 1)], 1), _vm._v(" "), (_vm.dateVal[0] !== _vm.dateVal[1] && _vm.isFetch) ? _c('el-table', {
    staticClass: "selfTable",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "issued_app_id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height,
      "row-class-name": _vm.tableRowClassName,
      "default-sort": {
        prop: '_visit_uv_new',
        order: 'descending'
      }
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "",
            "align": "center",
            "width": "48px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), (_vm.pdata.type != 3) ? _c('el-table-column', {
          attrs: {
            "prop": "visit_uv_new",
            "label": "预计新增用户",
            "align": "center"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.pdata.type != 3) ? _c('el-table-column', {
          attrs: {
            "prop": "cost",
            "label": "预计花费",
            "align": "center",
            "formatter": _vm.fixed2Formatter
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                    \t￥"), _c('span', [_vm._v(_vm._s(scope.row.cost))])]
            }
          }], null, true)
        }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "_visit_uv_new",
            "label": "实际计价用户",
            "align": "center"
          }
        }), _vm._v(" "), (_vm.pdata.type == 3) ? _c('el-table-column', {
          attrs: {
            "prop": "_visit_uv",
            "label": "实际活跃用户",
            "align": "center"
          }
        }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "_cost",
            "label": "实际花费",
            "align": "center",
            "formatter": _vm.fixed2Formatter
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                    \t￥"), _c('span', [_vm._v(_vm._s(scope.row._cost))])]
            }
          }], null, true)
        }), _vm._v(" "), (_vm.pdata.type != 3) ? _c('el-table-column', {
          attrs: {
            "prop": "cost_per",
            "label": "实际买量单价",
            "align": "center",
            "formatter": _vm.fixed2Formatter
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                    \t￥"), _c('span', [_vm._v(_vm._s(scope.row.cost_per))])]
            }
          }], null, true)
        }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "",
            "label": "",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" ")])]
            }
          }], null, true)
        })], 1)]
      }
    }], null, false, 814283293)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_id",
      "label": "ID",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_name",
      "label": "发行游戏名称",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].visit_uv_new != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_new",
      "label": "预计新增用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_new - 0) - (b.visit_uv_new - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.visit_uv_new))])]
      }
    }], null, false, 884798333)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].cost != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "cost",
      "label": "预计花费",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost - 0) - (b.cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.cost))])]
      }
    }], null, false, 4160565443)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._visit_uv_new != undefined) ? _c('el-table-column', {
    attrs: {
      "prop": "_visit_uv_new",
      "label": "实际计价用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv_new - 0) - (b._visit_uv_new - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(scope.row._visit_uv_new))])]
      }
    }], null, false, 714932911)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._visit_uv != undefined && _vm.pdata.type == 3) ? _c('el-table-column', {
    attrs: {
      "prop": "_visit_uv",
      "label": "实际活跃用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv - 0) - (b._visit_uv - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(scope.row._visit_uv))])]
      }
    }], null, false, 3331388876)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._cost != undefined) ? _c('el-table-column', {
    attrs: {
      "prop": "_cost",
      "label": "实际花费",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._cost - 0) - (b._cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(_vm.fixed2Formatter('', '', scope.row._cost)))])]
      }
    }], null, false, 1363077460)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].cost_per != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "cost_per",
      "label": "实际买量单价",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost_per - 0) - (b.cost_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.cost_per))])]
      }
    }], null, false, 3270957691)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '成本日报详情',
                params: {
                  issued_app_id: scope.row.issued_app_id
                },
                query: {
                  sdate: _vm.pdata.sdate,
                  edate: _vm.pdata.edate
                }
              })
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 919610758)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dateVal[0] === _vm.dateVal[1] && _vm.isFetch) ? _c('el-table', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "issued_app_id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "issued_app_id",
      "label": "ID",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_name",
      "label": "发行游戏名称",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].visit_uv_new != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_new",
      "label": "预计新增用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_new - 0) - (b.visit_uv_new - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.visit_uv_new))])]
      }
    }], null, false, 884798333)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].cost != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "cost",
      "label": "预计花费",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost - 0) - (b.cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.cost))])]
      }
    }], null, false, 4160565443)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._visit_uv_new != undefined) ? _c('el-table-column', {
    attrs: {
      "prop": "_visit_uv_new",
      "label": "实际计价用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv_new - 0) - (b._visit_uv_new - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(scope.row._visit_uv_new))])]
      }
    }], null, false, 714932911)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._visit_uv != undefined && _vm.pdata.type == 3) ? _c('el-table-column', {
    attrs: {
      "prop": "_visit_uv",
      "label": "实际活跃用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv - 0) - (b._visit_uv - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(scope.row._visit_uv))])]
      }
    }], null, false, 3331388876)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0]._cost != undefined) ? _c('el-table-column', {
    attrs: {
      "prop": "_cost",
      "label": "实际花费",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._cost - 0) - (b._cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          class: scope.row.gray ? 'gray-text' : 'red'
        }, [_vm._v(_vm._s(_vm.fixed2Formatter('', '', scope.row._cost)))])]
      }
    }], null, false, 1363077460)
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.list[0].cost_per != undefined && _vm.pdata.type != 3) ? _c('el-table-column', {
    attrs: {
      "prop": "cost_per",
      "label": "实际买量单价",
      "formatter": _vm.fixed2Formatter,
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost_per - 0) - (b.cost_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          \t￥"), _c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.cost_per))])]
      }
    }], null, false, 3270957691)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost_back.day_0",
      "label": "当天回本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return parseFloat(a.cost_back.day_0) - parseFloat(b.cost_back.day_0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost_back.day_3",
      "label": "3天回本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return parseFloat(a.cost_back.day_3) - parseFloat(b.cost_back.day_3)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost_back.day_7",
      "label": "7天回本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return parseFloat(a.cost_back.day_7) - parseFloat(b.cost_back.day_7)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost_back.day_14",
      "label": "14天回本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return parseFloat(a.cost_back.day_14) - parseFloat(b.cost_back.day_14)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '成本日报详情',
                params: {
                  issued_app_id: scope.row.issued_app_id
                },
                query: {
                  sdate: _vm.pdata.sdate,
                  edate: _vm.pdata.edate
                }
              })
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 919610758)
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入",
      "visible": _vm.batchDialog,
      "width": "1000px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips == 0 ? '导入预览' : '导入二次确认'))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0 && _vm.batchTips == '0') ? _c('el-row', {
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, [_vm._l((item), function(citem, idx) {
      return _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), _vm._v(" "), (index > 0) ? _c('el-col', {
      staticClass: "blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "span": 3
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteBatch(index)
        }
      }
    }, [_vm._v("\n       \t\t\t删除\n       \t\t\t\n       \t\t")]) : _vm._e()], 2) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0 && _vm.batchTips == '1') ? _c('el-row', {
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, [_vm._l((item), function(citem, idx) {
      return _c('el-col', {
        attrs: {
          "span": idx < 4 ? 3 : 2
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), _vm._v(" "), (index > 0) ? _c('el-col', {
      staticClass: "blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "span": 2
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteBatch(index)
        }
      }
    }, [_vm._v("\n       \t\t\t删除\n       \t\t\t\n       \t\t")]) : _vm._e()], 2) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v(_vm._s(_vm.batchTips == '0' ? '确认' : '再次确认'))])], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1133:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "icon": "el-icon-arrow-left",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t公司名称：\n\t\t\t"), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择公司名称"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.cp_company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "cp_company_id", $$v)
      },
      expression: "pdata.cp_company_id"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n       结算期：\n\t    "), _c('el-date-picker', {
    attrs: {
      "type": "monthrange",
      "format": "yyyyMM",
      "value-format": "yyyyMM",
      "start-placeholder": "开始月份",
      "end-placeholder": "结束月份"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.d_date),
      callback: function($$v) {
        _vm.d_date = $$v
      },
      expression: "d_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n    \t 分成方式：   \n\t\t "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择账单类型"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.bill_type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "bill_type", $$v)
      },
      expression: "pdata.bill_type"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": "汇总",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "1",
    attrs: {
      "label": "原生分成账单",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "利润分成账单",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "icon": "el-icon-download",
      "type": "primary"
    },
    on: {
      "click": _vm.getBillList
    }
  }, [_vm._v("导出预览")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "结算周期",
      "min-width": "140px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.sdate) + "~" + _vm._s(scope.row.edate) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "结算方式",
      "min-width": "140px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.bill_type == 1) ? _c('span', [_vm._v("\n\t\t\t    \t\t\t原生分成\n\t\t\t    \t\t")]) : _vm._e(), _vm._v(" "), (scope.row.bill_type == 2) ? _c('span', [_vm._v("\n\t\t\t    \t\t\t利润分成\n\t\t\t    \t\t")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_cost",
      "label": "结算金额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t￥" + _vm._s(scope.row.total_cost) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "min-width": "50px",
      "width": "400",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.$router.push('/billCpData/index?cp_company_id=' + _vm.pdata.cp_company_id + '&bill_type=' + scope.row.bill_type + '&d_date=' + scope.row.sdate.substring(0, 6))
            }
          }
        }, [_vm._v("账单明细")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "分成账单统计",
      "visible": _vm.billDialog,
      "width": "900px",
      "custom-class": "dialog",
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.billDialog = $event
      }
    }
  }, [_c('el-form', [_c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "900px"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "33%"
    }
  })]), _vm._v(" "), _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('td', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "3",
      "rowspan": "1"
    }
  }, [(_vm.pdata.bill_type == 0) ? _c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.companyName) + "汇总分成统计")]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 1) ? _c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.companyName) + "原生分成统计")]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.companyName) + "利润分成统计")]) : _vm._e()])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("分成方式")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算金额")])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.billList), function(item, index) {
    return _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('span', [_vm._v(_vm._s(item.sdate) + "~" + _vm._s(item.edate))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [(item.bill_type == 1) ? _c('div', {
      staticClass: "cell"
    }, [_vm._v("原生分成")]) : _vm._e(), _vm._v(" "), (item.bill_type == 2) ? _c('div', {
      staticClass: "cell"
    }, [_vm._v("利润分成")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v("￥" + _vm._s(item.total_cost))])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_29 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t合计\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_30 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_31 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.total_cost) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.tableToExcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleDown
    }
  }, [_vm._v("导出pdf")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.billDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1134:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1135:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏类型"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "type", $$v)
      },
      expression: "pdata.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "请选择小游戏类型",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.product_theme), function(v, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "label": v,
        "value": v
      }
    })
  })], 2), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源",
      "clearable": ""
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, _vm._l((_vm.issued_app_source), function(v, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "label": v,
        "value": v
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入小程序名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, -1)
      }
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1600px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "min-width": "40px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "小程序名称",
      "min-width": "100px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editProduct(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rename",
      "label": "曾用名",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "图标",
      "min-width": "85px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "gameIcon",
          attrs: {
            "src": scope.row.icon,
            "alt": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型",
      "min-width": "60px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source",
      "label": "来源",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "body",
      "label": "主体",
      "min-width": "40px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appid",
      "label": "APPID",
      "min-width": "140px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "邮箱",
      "min-width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "divide",
      "label": "分成方式",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "password",
      "label": "密码",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appsecret",
      "label": "APPSECRET",
      "min-width": "200px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "产品状态",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增产品信息' : '编辑产品信息',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "700px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "小游戏名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "小游戏名称",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "短名称",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "短名称",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.short_name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "short_name", $$v)
      },
      expression: "chooseProduct.short_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "曾用名",
      "prop": "rename"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "曾用名",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.rename),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "rename", $$v)
      },
      expression: "chooseProduct.rename"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "APPID",
      "prop": "appid"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "请输入小游戏appid",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.appid),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "appid", $$v)
      },
      expression: "chooseProduct.appid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "APPSECRET",
      "prop": "appsecret"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "请输入APPSECRET",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.appsecret),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "appsecret", $$v)
      },
      expression: "chooseProduct.appsecret"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "请输入邮箱",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.email),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "email", $$v)
      },
      expression: "chooseProduct.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "请输入密码",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.password),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "password", $$v)
      },
      expression: "chooseProduct.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "游戏图标",
      "prop": "icon"
    }
  }, [_c('UploadImg', {
    attrs: {
      "image": _vm.chooseProduct.icon
    },
    on: {
      "update:image": function($event) {
        _vm.chooseProduct.icon = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "游戏类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.type),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "type", $$v)
      },
      expression: "chooseProduct.type"
    }
  }, _vm._l((_vm.product_theme), function(v, i) {
    return _c('el-radio', {
      key: i,
      attrs: {
        "label": v,
        "value": v
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主体"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.body),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "body", $$v)
      },
      expression: "chooseProduct.body"
    }
  }, _vm._l((_vm.app_body), function(v, i) {
    return _c('el-radio', {
      key: i,
      attrs: {
        "label": v,
        "value": v
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "游戏来源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.source),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "source", $$v)
      },
      expression: "chooseProduct.source"
    }
  }, _vm._l((_vm.issued_app_source), function(v, i) {
    return _c('el-radio', {
      key: i,
      attrs: {
        "label": v,
        "value": v
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分成公司"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择分成公司名称"
    },
    model: {
      value: (_vm.chooseProduct.cp_company_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "cp_company_id", $$v)
      },
      expression: "chooseProduct.cp_company_id"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分成方式"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.divide),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "divide", $$v)
      },
      expression: "chooseProduct.divide"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "原生"
    }
  }, [_vm._v("原生")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "利润"
    }
  }, [_vm._v("利润")])], 1)], 1), _vm._v(" "), (_vm.chooseTags.length > 0) ? _c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "分成占比",
      "prop": "divide_per"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "请输入分成占比",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.divide_per),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "divide_per", $$v)
      },
      expression: "chooseProduct.divide_per"
    }
  }), _vm._v("\n          \t（给到对方的分成占比）\n        ")], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小游戏数据采集账号"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.game_miniprogram_account),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "game_miniprogram_account", $$v)
      },
      expression: "chooseProduct.game_miniprogram_account"
    }
  }, _vm._l((_vm.game_miniprogram_account), function(v, i) {
    return _c('el-radio', {
      key: i,
      attrs: {
        "label": i,
        "value": i
      }
    }, [_vm._v(_vm._s(v))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实时曲线图"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.real_time_chart),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "real_time_chart", $$v)
      },
      expression: "chooseProduct.real_time_chart"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }, [_vm._v("开启")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0",
      "value": "0"
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否是盒子"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.isbox),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "isbox", $$v)
      },
      expression: "chooseProduct.isbox"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }, [_vm._v("盒子")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0",
      "value": "0"
    }
  }, [_vm._v("非盒子")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "平台标识"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "platform_id", $$v)
      },
      expression: "chooseProduct.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-radio', {
      key: i + 1,
      attrs: {
        "label": i + 1,
        "value": i + 1
      }
    }, [_vm._v(_vm._s(v))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1136:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRowWhite",
    staticStyle: {
      "min-width": "1200px",
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n      \t\t 日期：  \n\t          "), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(2)
      }
    }
  }, [_vm._v("前天")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期时间",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "align": "right"
    },
    on: {
      "change": _vm.selectDate
    },
    model: {
      value: (_vm.pdata.sdate),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "sdate", $$v)
      },
      expression: "pdata.sdate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t      \t\t 选择小程序：  \n\t\t         "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入/选择小程序名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct(item)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t      \t\t 选择渠道：  \n\t          "), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入/选择渠道"
    },
    on: {
      "clear": _vm.clearChannel
    },
    model: {
      value: (_vm.chooseChannel.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseChannel, "name", $$v)
      },
      expression: "chooseChannel.name"
    }
  }, _vm._l((_vm.IssuedAldChanneList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.ald_channel,
        "value": item.id
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeChannel(item)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t      \t\t 选择公司：  \n\t          "), _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择对应公司"
    },
    model: {
      value: (_vm.pdata.company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "company_id", $$v)
      },
      expression: "pdata.company_id"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item.company_id,
      attrs: {
        "label": item.company_name,
        "value": item.company_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t      \t\t 选择状态：  \n\t          "), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择状态"
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.pdata.status),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "status", $$v)
      },
      expression: "pdata.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "正常",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已通知下线",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已确认下线",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t      \t\t 用户操作：  \n\t         "), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fieldConfig
    }
  }, [_vm._v("字段选择")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showBatchDialog(1)
      }
    }
  }, [_vm._v("批量通知下线")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showBatchDialog(2)
      }
    }
  }, [_vm._v("批量截止下线")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.downloadTemp(1)
      }
    }
  }, [_vm._v("批量通知下线模板")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.downloadTemp(2)
      }
    }
  }, [_vm._v("批量截止下线模板")])], 1)]), _vm._v(" "), _c('el-row', {
    staticClass: "totalBox"
  }, [_c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("单日总计")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("新增UV")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("UV")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("产品总支出")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("新增占比")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("渠道活跃占比")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("点击单价")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("分发arpu")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("分成后原生arpu")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("总 arpu")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("活跃单日回收")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("最高承受单价")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "totalBox"
  }, [_c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.chooseProduct.name))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.visit_uv_new || 0))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.visit_uv || 0))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.cost))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.new_per))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.uv_per))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.click_price))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.arpu_ff))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.arpu_fc))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.arpu))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.uv_back_0))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.hold_price))])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.cdata.list,
      "stripe": "",
      "row-key": "id",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.handleSelection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "selectable": _vm.selectionDisabled
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_channel",
      "label": "渠道",
      "show-overflow-tooltip": "",
      "min-width": "100",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "公司名称",
      "show-overflow-tooltip": "",
      "min-width": "90",
      "align": "left"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center",
        "sortable": "",
        "sort-method": function (a, b) {
          return parseFloat(a[item.key]) - parseFloat(b[item.key])
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.key == 'atv') ? _c('span', {
            staticClass: "orange",
            on: {
              "click": function($event) {
                return _vm.editAtv(scope.row)
              }
            }
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : (item.key == 'jump_per') ? _c('span', [(scope.row[item.key] != null) ? _c('span', [_vm._v(_vm._s(scope.row[item.key] || 0) + "%")]) : _c('span', [_vm._v("--")])]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "align": "left",
      "width": "330",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showDetail(scope.row)
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), (scope.row.status == 1) ? _c('el-button', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.notifyOff(scope.$index, scope.row, 0)
            }
          }
        }, [_vm._v("通知下线")]) : _vm._e(), _vm._v(" "), (scope.row.status == 0 || scope.row.status == 2) ? _c('el-button', {
          staticStyle: {
            "width": "130px"
          },
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.notifyOff(scope.$index, scope.row, 1)
            }
          }
        }, [_vm._v("已通知 " + _vm._s(scope.row.update_time.split(' ')[0]))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          staticStyle: {
            "width": "130px"
          },
          attrs: {
            "size": "mini",
            "type": "info",
            "disabled": ""
          }
        }, [_vm._v("已截止 " + _vm._s(scope.row.update_time.split(' ')[0]))]) : _vm._e(), _vm._v(" "), (scope.row.status == 0) ? _c('el-button', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.notifyOff(scope.$index, scope.row, 2)
            }
          }
        }, [_vm._v("截止下线")]) : _vm._e()]
      }
    }])
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详情",
      "visible": _vm.detailDialog,
      "width": "95%"
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialog = $event
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_vm._v("\n\t\t\t\t\t\t选择日期：\n\t    \t\t\t"), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal2),
      callback: function($$v) {
        _vm.dateVal2 = $$v
      },
      expression: "dateVal2"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.ddata.list,
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "d_date",
      "label": "日期",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_channel",
      "label": "渠道",
      "align": "left"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return (item.key != 'update_time') ? _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center",
        "sortable": "",
        "sort-method": function (a, b) {
          return parseFloat(a[item.key]) - parseFloat(b[item.key])
        }
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(scope) {
          return [(item.key == 'atv') ? _c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": "双击数字可修改获客单价",
              "placement": "top-start"
            }
          }, [_c('span', [_vm._v(_vm._s(item.name)), _c('i', {
            staticClass: "el-icon-question"
          })])]) : _c('span', [_vm._v(_vm._s(item.name))])]
        }
      }, {
        key: "default",
        fn: function(scope) {
          return [(item.key == 'jump_per') ? _c('span', [(scope.row[item.key] != null) ? _c('span', [_vm._v(_vm._s(scope.row[item.key] || 0) + "%")]) : _c('span', [_vm._v("--")])]) : (item.key == 'atv') ? _c('span', {
            staticClass: "orange"
          }, [(scope.row.isEdit == false) ? _c('span', {
            on: {
              "dblclick": function($event) {
                return _vm.atvDetailEdit(scope)
              }
            }
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : _c('span', [_c('el-input', {
            staticClass: "w50",
            attrs: {
              "placeholder": "输入获客单价",
              "size": "mini",
              "autofocus": true
            },
            on: {
              "change": function($event) {
                return _vm.postAtv('detail')
              }
            },
            model: {
              value: (_vm.chooseDetailAtv.atv),
              callback: function($$v) {
                _vm.$set(_vm.chooseDetailAtv, "atv", $$v)
              },
              expression: "chooseDetailAtv.atv"
            }
          })], 1)]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
        }
      }], null, true)
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑获客单价",
      "visible": _vm.editAtvDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editAtvDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.chooseAtv
    }
  }, [_vm._l((_vm.config), function(it, idx) {
    return _c('el-radio', {
      key: idx,
      attrs: {
        "label": idx + 1
      },
      model: {
        value: (_vm.chooseAtv.type),
        callback: function($$v) {
          _vm.$set(_vm.chooseAtv, "type", $$v)
        },
        expression: "chooseAtv.type"
      }
    }, [_vm._v(_vm._s(it))])
  }), _vm._v(" "), _c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "输入获客单价"
    },
    model: {
      value: (_vm.chooseAtv.atv),
      callback: function($$v) {
        _vm.$set(_vm.chooseAtv, "atv", $$v)
      },
      expression: "chooseAtv.atv"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editAtvDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.postAtv($event)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "edit-channel-discount-dialog",
    attrs: {
      "title": "编辑扣量比例（范围0-1）",
      "visible": _vm.editAldChannelDiscountDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editAldChannelDiscountDialog = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入扣量比例"
    },
    model: {
      value: (_vm.editAldChannelDiscountValue.pr),
      callback: function($$v) {
        _vm.$set(_vm.editAldChannelDiscountValue, "pr", $$v)
      },
      expression: "editAldChannelDiscountValue.pr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editAldChannelDiscountDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.postAldChannelDiscount($event)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "我是标题",
      "size": "580px",
      "visible": _vm.drawer,
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.fieldListChange
    },
    model: {
      value: (_vm.FieldIndex),
      callback: function($$v) {
        _vm.FieldIndex = $$v
      },
      expression: "FieldIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "按字段设置",
      "name": "0"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTap(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selectFieldList),
      callback: function($$v) {
        _vm.selectFieldList = $$v
      },
      expression: "selectFieldList"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.selectFieldList), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('i', {
      staticClass: "el-icon-rank"
    }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeSelectField(item)
        }
      }
    })])
  }), 0)], 1)], 1)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按模块设置",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTapForModel(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _vm._l((_vm.selectFieldListForModel), function(value, key, index) {
    return _c('div', {
      staticClass: "fliedModel"
    }, [_c('div', {
      staticClass: "fliedModelKey"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('draggable', {
      attrs: {
        "move": _vm.onMove
      },
      on: {
        "start": function($event) {
          _vm.isDragging = true
        },
        "end": function($event) {
          _vm.isDragging = false
        }
      },
      model: {
        value: (_vm.selectFieldListForModel[key]),
        callback: function($$v) {
          _vm.$set(_vm.selectFieldListForModel, key, $$v)
        },
        expression: "selectFieldListForModel[key]"
      }
    }, [_c('transition-group', {
      attrs: {
        "type": "transition",
        "tag": "ul"
      }
    }, _vm._l((value), function(item) {
      return _c('li', {
        key: item.key,
        staticClass: "item"
      }, [_c('i', {
        staticClass: "el-icon-rank"
      }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
        staticClass: "el-icon-close",
        on: {
          "click": function($event) {
            return _vm.removeSelectFieldForModel(item, key)
          }
        }
      })])
    }), 0)], 1)], 1)
  })], 2)])])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.batchVal == 1 ? '批量通知下线' : '批量截止下线',
      "visible": _vm.batchDialog,
      "width": "1150px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0) ? _c('el-row', {
      key: index,
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        key: idx,
        attrs: {
          "span": 12
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.batchDialog = false
      }
    }
  }, [_vm._v("知道了")])], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1137:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "total"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("选择日期")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "datePick",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "昨天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("采集发行总体数据")]), _vm._v(" "), _c('el-button', {
    staticClass: "caiji",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.cjClick('get_issued_app_data')
      }
    }
  }, [_vm._v("采集")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("采集渠道分析数据")]), _vm._v(" "), _c('div', {
    staticClass: "mainSelect"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入/选择小程序名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct(item)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "caiji",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.cjClick('get_issued_app_ald_channel_retain_data')
      }
    }
  }, [_vm._v("采集")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("采集发行产品回本数据")]), _vm._v(" "), _c('el-button', {
    staticClass: "caiji",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.cjClick('get_issued_app_cost_back')
      }
    }
  }, [_vm._v("采集")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("采集小花数据监控")]), _vm._v(" "), _c('div', {
    staticClass: "mainSelect"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入/选择小程序名称"
    },
    model: {
      value: (_vm.chooseProduct2.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct2, "name", $$v)
      },
      expression: "chooseProduct2.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct2(item)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "caiji",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.cjClick('get_issued_monitor_data', 'now')
      }
    }
  }, [_vm._v("采集")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "采集",
      "visible": _vm.logDialog,
      "width": "890px"
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog,
      "max-height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "msg",
      "label": "采集记录",
      "width": '800px'
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1138:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "filterable": "",
      "placeholder": "请输入/选择小程序名称"
    },
    on: {
      "clear": function($event) {
        return _vm.clear('issued_app_id')
      }
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct(item)
        }
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择对应公司/渠道"
    },
    on: {
      "clear": function($event) {
        return _vm.clear('channel_id')
      }
    },
    model: {
      value: (_vm.pdata.channel_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "channel_id", $$v)
      },
      expression: "pdata.channel_id"
    }
  }, _vm._l((_vm.companys_chiannelList), function(item, index) {
    return _c('el-option', {
      key: item.channel_id,
      attrs: {
        "label": item.company + '-' + item.ald_channel,
        "value": item.channel_id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择操作人员"
    },
    on: {
      "clear": function($event) {
        return _vm.clear('uid')
      }
    },
    model: {
      value: (_vm.pdata.uid),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "uid", $$v)
      },
      expression: "pdata.uid"
    }
  }, [(_vm.pdata.uid == '') ? _c('el-option', {
    key: "",
    attrs: {
      "label": "请选择操作人员",
      "value": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.users), function(item, index) {
    return _c('el-option', {
      key: item.uid,
      attrs: {
        "label": item.username,
        "value": item.uid
      }
    })
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "游戏名称",
      "align": "center",
      "width": "125px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "对应公司",
      "align": "center",
      "width": "125px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_channel",
      "label": "渠道名称",
      "align": "center",
      "width": "125px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "操作时间",
      "align": "center",
      "min-width": "185px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘",
      "align": "center",
      "min-width": "185px"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1139:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择对应公司"
    },
    model: {
      value: (_vm.pdata.company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "company_id", $$v)
      },
      expression: "pdata.company_id"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item.company_id,
      attrs: {
        "label": item.company_name,
        "value": item.company_id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择产品"
    },
    model: {
      value: (_vm.pdata.issued_app_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_id", $$v)
      },
      expression: "pdata.issued_app_id"
    }
  }, _vm._l((_vm.apps), function(item) {
    return _c('el-option', {
      key: item.issued_app_id,
      attrs: {
        "label": item.name,
        "value": item.issued_app_id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(2)
      }
    }
  }, [_vm._v("前天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(31)
      }
    }
  }, [_vm._v("最近31天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "selfTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "default-sort": {
        prop: 'visit_uv_out',
        order: 'descending'
      },
      "show-summary": "",
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [(_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
    staticClass: "expandd",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "",
            "align": "center",
            "width": "48px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "visit_uv_out",
            "show-overflow-tooltip": "",
            "label": "换出日活",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "visit_uv_in",
            "show-overflow-tooltip": "",
            "label": "换入日活",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "diff",
            "show-overflow-tooltip": "",
            "label": "顺逆差",
            "align": "center"
          }
        })], 1)]
      }
    }], null, false, 1423129300)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "show-overflow-tooltip": "",
      "label": "流量主游戏",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_out",
      "show-overflow-tooltip": "",
      "label": "换出日活",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_out - 0) - (b.visit_uv_out - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_in",
      "show-overflow-tooltip": "",
      "label": "换入日活",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_in - 0) - (b.visit_uv_in - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "diff",
      "show-overflow-tooltip": "",
      "label": "顺逆差",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.diff - 0) - (b.diff - 0)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑实际换量",
      "visible": _vm.editDialog,
      "width": "550px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.chooseEditProduct
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "换出日活"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "step": 1,
      "precision": 0,
      "min": 0,
      "label": "",
      "controls": false
    },
    model: {
      value: (_vm.chooseEditProduct.visit_uv_out),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "visit_uv_out", $$v)
      },
      expression: "chooseEditProduct.visit_uv_out"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "换入日活"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "step": 1,
      "precision": 0,
      "min": 0,
      "label": "",
      "controls": false
    },
    model: {
      value: (_vm.chooseEditProduct.visit_uv_in),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "visit_uv_in", $$v)
      },
      expression: "chooseEditProduct.visit_uv_in"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editChooseProduct($event)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1140:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "today"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "seven"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "请选择小游戏来源",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "内部发行",
      "value": "内部"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外部发行",
      "value": "外部"
    }
  })], 1), _vm._v(" "), _c('searchApp', {
    staticClass: "xs24",
    attrs: {
      "compare": "issued",
      "pholder": _vm.pholder
    },
    on: {
      "getid": _vm.changeId
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fieldConfig
    }
  }, [_vm._v("字段选择")])], 1)], 1)])], 1), _vm._v(" "), (_vm.list.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "d_date",
      "label": "日期",
      "align": "center",
      "min-width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "发行名称",
      "align": "center",
      "min-width": "120px"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center",
        "sortable": "",
        "sort-method": function (a, b) {
          return parseFloat(a[item.key]) - parseFloat(b[item.key])
        }
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(scope) {
          return [(item.key == 'ltv') ? _c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": '截至' + _vm.pdata.edate + '的累计数据',
              "placement": "top-start"
            }
          }, [_c('span', [_vm._v(_vm._s(item.name)), _c('i', {
            staticClass: "el-icon-question"
          })])]) : _c('span', [_vm._v(_vm._s(item.name))])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '更多数据',
                params: {
                  issued_app_id: scope.row.issued_app_id,
                  edate: _vm.pdata.edate,
                  sdate: _vm.pdata.sdate
                }
              })
            }
          }
        }, [_vm._v("更多数据")])]
      }
    }], null, false, 3015281574)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "el-table el-table--fit el-table--striped el-table--enable-row-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80, 200, 500],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  }), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "我是标题",
      "size": "580px",
      "visible": _vm.drawer,
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("设置显示字段")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("可选字段")]), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTap(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selectFieldList),
      callback: function($$v) {
        _vm.selectFieldList = $$v
      },
      expression: "selectFieldList"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.selectFieldList), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('i', {
      staticClass: "el-icon-rank"
    }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeSelectField(item)
        }
      }
    })])
  }), 0)], 1)], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-table__body-wrapper is-scrolling-none"
  }, [_c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v("暂无数据")])])])
}]}

/***/ }),

/***/ 1141:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-autocomplete', {
    staticClass: "inline-input",
    style: (_vm.sstyle),
    attrs: {
      "clearable": "",
      "filterable": "",
      "fetch-suggestions": _vm.SearchId,
      "placeholder": _vm.ptext,
      "suffix-icon": _vm.inputKW != '' ? '' : 'el-icon-search'
    },
    on: {
      "select": _vm.SelectApp,
      "clear": _vm.clear
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "name"
        }, [_vm._v(_vm._s(item['name']))])]
      }
    }]),
    model: {
      value: (_vm.inputKW),
      callback: function($$v) {
        _vm.inputKW = $$v
      },
      expression: "inputKW"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1142:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1200px",
      "padding": "15px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-arrow-left",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/mainData/index'
        })
      }
    }
  }), _vm._v(" "), _c('el-radio-group', {
    staticClass: "rgroup",
    staticStyle: {
      "margin-left": "60px"
    },
    on: {
      "change": _vm.changeGet
    },
    model: {
      value: (_vm.getWhich),
      callback: function($$v) {
        _vm.getWhich = $$v
      },
      expression: "getWhich"
    }
  }, [_c('el-radio-button', {
    staticClass: "radio",
    attrs: {
      "label": "原生广告"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    staticClass: "radio",
    attrs: {
      "label": "买量详情"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    staticClass: "radio",
    attrs: {
      "label": "分发详情"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入小程序名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct(item)
        }
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeGet
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "请选择",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "矩阵",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "非矩阵",
      "value": "0"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": _vm.pdata.sdate,
      "end-placeholder": _vm.pdata.edate,
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getWhich == '原生广告'),
      expression: "getWhich=='原生广告'"
    }],
    staticStyle: {
      "width": "100%",
      "min-width": "1200px",
      "margin-top": "30px"
    },
    attrs: {
      "data": _vm.cdata.list,
      "height": "600",
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "d_date",
      "label": "日期",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_visit_pv",
      "label": "展示数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_click_pv",
      "label": "点击数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_income",
      "label": "原生收入",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_click_per",
      "label": "单次点击收益",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "video_visit_pv",
      "label": "视频广告展示数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "video_click_pv",
      "label": "视频广告点击数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "video_income",
      "label": "视频收入",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "video_click_per",
      "label": "点击率",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "video_click_per",
      "label": "单次点击收益",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getWhich == '买量详情'),
      expression: "getWhich=='买量详情'"
    }],
    staticStyle: {
      "width": "100%",
      "min-width": "1200px",
      "margin-top": "30px"
    },
    attrs: {
      "data": _vm.bdata.list,
      "height": "600",
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "买量产品",
      "align": "center",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "d_date",
      "label": "买量日期",
      "align": "center",
      "min-width": "100",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "买量金额",
      "align": "center",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateBM(s.row.id, s.$index, s.row)
            }
          }
        }, [_vm._v(_vm._s(s.row.expenses_cost))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buy_user",
      "label": "买量用户",
      "align": "center",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateBM(s.row.id, s.$index, s.row)
            }
          }
        }, [_vm._v(_vm._s(s.row.buy_user))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roi",
      "label": "回收预测",
      "align": "center",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "day_0",
      "label": "当天回本",
      "align": "center"
    }
  }), _vm._v(" "), _vm._l((30), function(i) {
    return _c('el-table-column', {
      key: i,
      attrs: {
        "prop": 'day_' + i,
        "label": i + '天回本',
        "align": "center"
      }
    })
  })], 2), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getWhich == '分发详情'),
      expression: "getWhich=='分发详情'"
    }],
    staticStyle: {
      "width": "100%",
      "min-width": "1200px",
      "margin-top": "30px"
    },
    attrs: {
      "data": _vm.mdata.list,
      "height": "800",
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued",
      "label": "是否矩阵",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.issued == 1 ? "矩阵" : "非矩阵"))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_pv",
      "label": "点击次数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "label": "点击人数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "点击成功人数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.clickok_uv || 0))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "income",
      "label": "收入预估",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新买量数据",
      "visible": _vm.updateBuyMoney,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.updateBuyMoney = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.updateGroup
    }
  }, [_c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "买量金额",
      "prop": "expenses_cost"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "autofocus": "",
      "placeholder": "买量金额",
      "clearable": ""
    },
    model: {
      value: (_vm.updateGroup.expenses_cost),
      callback: function($$v) {
        _vm.$set(_vm.updateGroup, "expenses_cost", $$v)
      },
      expression: "updateGroup.expenses_cost"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "买量用户",
      "prop": "buy_user"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "买量用户",
      "clearable": ""
    },
    model: {
      value: (_vm.updateGroup.buy_user),
      callback: function($$v) {
        _vm.$set(_vm.updateGroup, "buy_user", $$v)
      },
      expression: "updateGroup.buy_user"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.updateBuyMoney = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sUpdate
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1143:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), (_vm.plist.length > 0) ? _c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "ta"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.plist), function(item, index) {
    return _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell",
      on: {
        "click": function($event) {}
      }
    }, [_c('span', [_vm._v(_vm._s(item.bill_sdate) + "~" + _vm._s(item.bill_edate))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.channel_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_32 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.platform))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_33 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.ctype))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_34 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.num))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_35 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.atv))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.amount))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.type_text))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell blue",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: '成本日报详情',
            params: {
              issued_app_id: item.issued_app_id
            },
            query: {
              sdate: item.bill_sdate,
              edate: item.bill_edate,
              channel_id: item.channel_id
            }
          })
        }
      }
    }, [_vm._v("查看详情")])])])
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.company.type == 1 ? '企业' : '个人') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("发票类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.invoice_type == 1 ? '普通发票' : '增值发票') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("新增用户\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.num) + "\t")])]), _vm._v(" "), (_vm.bill.offset == 1) ? _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("抵扣金额\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.offset_amount) + "\t")])]) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.company.type == 1) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算金额\t")]) : _vm._e(), _vm._v(" "), (_vm.company.type == 2) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算金额(扣去税点后金额)\t")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.bill_amount) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("结算金额（人民币大写）\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.big_bill_amount) + "\t")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("乙方公司 ：" + _vm._s(_vm.company.name))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("税号：" + _vm._s(_vm.company.social_credit_code))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[3]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("注册地址：" + _vm._s(_vm.company.company_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("注册电话：" + _vm._s(_vm.company.company_phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[8]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("开户银行 ：" + _vm._s(_vm.company.opening_bank))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("银行 账号：" + _vm._s(_vm.company.receiving_account))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("联系人：" + _vm._s(_vm.company.contact))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[6]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("联系电话：" + _vm._s(_vm.company.phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[7]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v("邮寄地址：" + _vm._s(_vm.company.email_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[5]))])])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.plist.length == 0) ? _c('div', [_vm._v("\n\t\t\t暂无对账单\n\t\t")]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_32",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_33",
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_34",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_35",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "gutter",
      "width": "0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "10",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算对账单")])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("游戏名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("渠道名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_32  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("平台")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_33  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("合作方式")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_34  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("计价人数")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_35  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("单价（元/个）")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("应付金额（￥）")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("类型")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("操作")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "10"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "10"
    }
  }, [_vm._v(" ")])])
}]}

/***/ }),

/***/ 1144:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-img"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideShow),
      expression: "hideShow"
    }],
    staticClass: "el-upload-list el-upload-list--picture-card"
  }, [_c('div', {
    staticClass: "el-upload-list__item is-success"
  }, [_c('img', {
    staticClass: "flex-img__image",
    attrs: {
      "src": _vm.image
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "el-upload-list__item-actions"
  }, [_c('span', {
    staticClass: "el-upload-list__item-delete"
  }, [_c('i', {
    staticClass: "el-icon-delete",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleRemove()
      }
    }
  })])])])]), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideShow),
      expression: "!hideShow"
    }],
    staticClass: "image-uploader",
    attrs: {
      "action": _vm.uploadUrl,
      "show-file-list": false,
      "headers": _vm.headMsg,
      "on-success": _vm.imageUploadSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "el-upload-list__item-status-label"
  }, [_c('i', {
    staticClass: "el-icon-upload-success el-icon-check"
  })])
}]}

/***/ }),

/***/ 1145:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isloading),
      expression: "isloading"
    }],
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 日期：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(30)
      }
    }
  }, [_vm._v("最近30天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 游戏来源：  \n\t\t\t\t "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "内部游戏",
      "value": "内部游戏"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外部游戏",
      "value": "外部游戏"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 平台来源：  \n\t\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源"
    },
    on: {
      "change": _vm.changePlatform
    },
    model: {
      value: (_vm.pdata.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "platform_id", $$v)
      },
      expression: "pdata.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-option', {
      key: v.platform_id,
      attrs: {
        "label": v.platform_name,
        "value": v.platform_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 小游戏名称：  \n\t\t\t\t"), _c('searchApp', {
    staticClass: "xs24",
    attrs: {
      "platform_id": _vm.pdata.platform_id.toString(),
      "compare": "issued",
      "pholder": _vm.pholder
    },
    on: {
      "getid": _vm.changeId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 用户操作：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportIncome
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fieldConfig
    }
  }, [_vm._v("字段选择")])], 1)]), _vm._v(" "), (_vm.list.length > 0) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isloading),
      expression: "isloading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "发行名称",
      "align": "center",
      "min-width": "120px"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center",
        "sortable": "",
        "sort-method": function (a, b) {
          return parseFloat(a[item.key]) - parseFloat(b[item.key])
        }
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(scope) {
          return [(item.key == 'ltv') ? _c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": '截至' + _vm.pdata.edate + '的累计数据',
              "placement": "top-start"
            }
          }, [_c('span', [_vm._v(_vm._s(item.name)), _c('i', {
            staticClass: "el-icon-question"
          })])]) : _c('span', [_vm._v(_vm._s(item.name))])]
        }
      }, {
        key: "default",
        fn: function(scope) {
          return [(item.key == 'banner_click_per') ? _c('span', {
            class: parseFloat(scope.row[item.key]) > 15 ? 'red' : ''
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : (item.key == 'total_day_contribution') ? _c('span', {
            class: scope.row.isTop10 == true ? 'red' : ''
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : (item.key == 'origin_day_contribution') ? _c('span', [(scope.row.origin_day_contribution_trend == 1) ? _c('span', {
            staticClass: "red"
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : (scope.row.origin_day_contribution_trend == -1) ? _c('span', {
            staticClass: "green"
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]) : (item.key == 'jump_per') ? _c('span', [(scope.row.jump_per_trend == 1) ? _c('span', {
            staticClass: "red"
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : (scope.row.jump_per_trend == -1) ? _c('span', {
            staticClass: "green"
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                'name': '产品日报详情',
                query: {
                  name: scope.row.issued_app_name,
                  sdate: _vm.pdata.sdate,
                  edate: _vm.pdata.edate
                },
                'params': {
                  issued_app_id: scope.row.issued_app_id
                }
              })
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 986043606)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "el-table el-table--fit el-table--striped el-table--enable-row-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出选择",
      "visible": _vm.checkDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.checkDialog = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleDownload
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "我是标题",
      "size": "580px",
      "visible": _vm.drawer,
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.fieldListChange
    },
    model: {
      value: (_vm.FieldIndex),
      callback: function($$v) {
        _vm.FieldIndex = $$v
      },
      expression: "FieldIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "按字段设置",
      "name": "0"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTap(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selectFieldList),
      callback: function($$v) {
        _vm.selectFieldList = $$v
      },
      expression: "selectFieldList"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.selectFieldList), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('i', {
      staticClass: "el-icon-rank"
    }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeSelectField(item)
        }
      }
    })])
  }), 0)], 1)], 1)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按模块设置",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTapForModel(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _vm._l((_vm.selectFieldListForModel), function(value, key, index) {
    return _c('div', {
      staticClass: "fliedModel"
    }, [_c('div', {
      staticClass: "fliedModelKey"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('draggable', {
      attrs: {
        "move": _vm.onMove
      },
      on: {
        "start": function($event) {
          _vm.isDragging = true
        },
        "end": function($event) {
          _vm.isDragging = false
        }
      },
      model: {
        value: (_vm.selectFieldListForModel[key]),
        callback: function($$v) {
          _vm.$set(_vm.selectFieldListForModel, key, $$v)
        },
        expression: "selectFieldListForModel[key]"
      }
    }, [_c('transition-group', {
      attrs: {
        "type": "transition",
        "tag": "ul"
      }
    }, _vm._l((value), function(item) {
      return _c('li', {
        key: item.key,
        staticClass: "item"
      }, [_c('i', {
        staticClass: "el-icon-rank"
      }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
        staticClass: "el-icon-close",
        on: {
          "click": function($event) {
            return _vm.removeSelectFieldForModel(item, key)
          }
        }
      })])
    }), 0)], 1)], 1)
  })], 2)])])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-table__body-wrapper is-scrolling-none"
  }, [_c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v("暂无数据")])])])
}]}

/***/ }),

/***/ 1146:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n    \t\t\t  公司名称：   \n\t\t\t"), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择公司名称"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.cp_company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "cp_company_id", $$v)
      },
      expression: "pdata.cp_company_id"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n       结算期：   \n\t     "), _c('el-date-picker', {
    attrs: {
      "type": "month",
      "format": "yyyyMM",
      "value-format": "yyyyMM",
      "placeholder": "选择月"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.d_date),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "d_date", $$v)
      },
      expression: "pdata.d_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n    \t 分成方式：   \n\t\t "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择账单类型"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.bill_type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "bill_type", $$v)
      },
      expression: "pdata.bill_type"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "label": "原生分成账单",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "利润分成账单",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.batchProduct
    }
  }, [_vm._v("导入")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": _vm.downloadTemp
    }
  }, [_vm._v("导入模板下载")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [(_vm.pdata.cp_company_id != '' && _vm.plist.length > 0) ? _c('el-button', {
    attrs: {
      "size": "medium",
      "icon": "el-icon-download",
      "type": "primary"
    },
    on: {
      "click": _vm.getBillList
    }
  }, [_vm._v("导出预览")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/billCpData/summary')
      }
    }
  }, [_vm._v("分成汇总")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "bill_cp_data_id",
      "label": "ID",
      "min-width": "50px",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "结算周期",
      "min-width": "140px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "公司名称",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "游戏名称",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appid",
      "label": "appid",
      "align": "center",
      "min-width": "140px"
    }
  }), _vm._v(" "), (_vm.pdata.bill_type == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "other_cost",
      "label": "其他费用",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_income",
      "label": "原生收入",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('el-table-column', {
    attrs: {
      "prop": "sell_income",
      "label": "分发收入",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('el-table-column', {
    attrs: {
      "prop": "export_cost",
      "label": "导量成本",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('el-table-column', {
    attrs: {
      "prop": "profit",
      "label": "利润",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "divide_per",
      "label": "结算比例",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tax_point",
      "label": "应扣税点",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.tax_point) + "%")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_cost",
      "label": "结算金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "min-width": "50px",
      "width": "400",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.updateCPBillData(scope.row)
            }
          }
        }, [_vm._v("更新账单")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          }
        }, [_vm._v("明细")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.editRemark(scope.row)
            }
          }
        }, [_vm._v("备注")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.openDealy(scope.row.bill_cp_data_id)
            }
          }
        }, [_vm._v("操作日志")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, _vm._l((_vm.plist), function(item) {
    return (item.remark != '' && item.remark != '') ? _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n    \t\t" + _vm._s(item.remark) + "\n    \t\t\n    \t")]) : _vm._e()
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '结算' : '结算',
      "visible": _vm.billDialog,
      "top": "5vh",
      "width": _vm.pdata.bill_type == 1 ? '950px' : '1150px',
      "custom-class": "dialog",
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.billDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    style: (_vm.pdata.bill_type == 1 ? 'width: 900px;' : 'width:1100px'),
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [(_vm.pdata.bill_type == 1) ? _c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "145"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "100"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "155"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_32",
      "width": "70"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_33",
      "width": "110"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_34",
      "width": "110"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_35",
      "width": "105"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "105"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "145"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "155"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "160"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_32",
      "width": "90"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_33",
      "width": "110"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_34",
      "width": "110"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_35",
      "width": "105"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "75"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "60"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "90"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 1) ? _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('td', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "8",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("产品结算对账单")])])]), _vm._v(" "), _c('tr', {}, [_c('td', {
    staticClass: "el-table_3_column_28  is-right  ",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "colspan": "8",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算单编号：" + _vm._s(_vm.bill_no))])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("游戏名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("appid")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_32  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("其他费用")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_33  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("原生收入/利润")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_34  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算比例")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_35  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("应扣税点")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算金额")])])])]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('td', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "10",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("产品结算对账单")])])]), _vm._v(" "), _c('tr', {}, [_c('td', {
    staticClass: "el-table_3_column_28  is-right  ",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "colspan": "10",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算单编号：" + _vm._s(_vm.bill_no))])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28  is-left  ",
    attrs: {
      "colspan": "10",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算单明细:")])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("游戏名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("appid")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_32  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("原生收入")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_33  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("分发收入")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_34  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("导量成本")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_35  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("利润")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算比例")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("税点")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算金额")])])])]) : _vm._e(), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.billList), function(item, index) {
    return (_vm.pdata.bill_type == 1) ? _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('span', [_vm._v(_vm._s(item.date))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.appid))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_32 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.other_cost))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_33 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.origin_income))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_34 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.divide_per))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_35 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.tax_point) + "%")])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.total_cost))])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.billList), function(item, index) {
    return (_vm.pdata.bill_type == 2) ? _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('span', [_vm._v(_vm._s(item.date))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.appid))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_32 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.origin_income))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_33 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.sell_income))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_34 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.export_cost))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_35 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.profit))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.divide_per))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.tax_point) + "%")])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.total_cost))])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
    }
  }, [_vm._v(" ")])]), _vm._v(" "), (_vm.pdata.bill_type == 1) ? _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_29 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t总计\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_30 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_31 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_32 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.other_cost.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_33 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.origin_income.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_34 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_35 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.total_cost.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_29 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t总计\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_30 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_31 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_32 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_33 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.sell_income.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_34 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_35 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.profit.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.total_cost.toFixed(2)) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.pdata.bill_type == '1' ? '结算金额 =（原生收入 * 结算比例 + 其他费用（按月）*（1 - 应扣税点））' : '结算金额=利润*结算比例*（1-税点）') + "\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._l((_vm.plist), function(item) {
    return (item.remark != '' && item.remark != null) ? _c('tr', [_c('td', {
      staticClass: "el-table_3_column_28_column_36 is-left ",
      staticStyle: {
        "text-align": "left",
        "padding-left": "10px"
      },
      attrs: {
        "rowspan": "1",
        "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.remark) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    staticStyle: {
      "color": "#f2f2f2"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t以上金额确认无误，请盖章后寄回\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '8' : '10'
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("公司名称 ：" + _vm._s(_vm.company.name))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("收款银行：" + _vm._s(_vm.company.opening_bank))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("银行账号：" + _vm._s(_vm.company.receiving_account))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系人：" + _vm._s(_vm.company.contact))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[3]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系电话 ：" + _vm._s(_vm.company.phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("邮寄地址：" + _vm._s(_vm.company.email_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[5]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-left ",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": _vm.pdata.bill_type == 1 ? '4' : '6'
    }
  }, [_vm._v(_vm._s(_vm.wecompany[6]))])])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.tableToExcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleDown
    }
  }, [_vm._v("导出pdf")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.billDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "备注",
      "visible": _vm.remarkDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.remarkDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.remarkRules,
      "label-width": "140px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入备注信息",
      "prop": "ramark"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.remarkForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.remarkForm, "remark", $$v)
      },
      expression: "remarkForm.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.remarkDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveRemark
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入",
      "visible": _vm.batchDialog,
      "width": "650px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips == 0 ? '导入预览' : '以下数据已存在，是否覆盖'))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0) ? _c('el-row', {
      key: index,
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        key: idx,
        attrs: {
          "span": 6
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v(_vm._s(_vm.batchTips == '0' ? '确认' : '再次确认'))])], 1) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.cpEditDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.cpEditDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.editFormRules,
      "label-width": "220"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.pdata.bill_type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "其它费用（原生分成）",
      "prop": "other_cost"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.editForm.other_cost),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "other_cost", $$v)
      },
      expression: "editForm.other_cost"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原生收入",
      "prop": "origin_income"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.editForm.origin_income),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "origin_income", $$v)
      },
      expression: "editForm.origin_income"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结算比例",
      "prop": "divide_per"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.editForm.divide_per),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "divide_per", $$v)
      },
      expression: "editForm.divide_per"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.pdata.bill_type == 2) ? _c('el-form-item', {
    attrs: {
      "label": "分发收入（利润分成）",
      "prop": "sell_income"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.editForm.sell_income),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sell_income", $$v)
      },
      expression: "editForm.sell_income"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.pdata.bill_type == 2) ? _c('el-form-item', {
    attrs: {
      "label": "导量成本（利润分成）\t",
      "prop": "export_cost"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.editForm.export_cost),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "export_cost", $$v)
      },
      expression: "editForm.export_cost"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cpEditDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveCPBillData
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1147:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "today"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "seven"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 平台来源：  \n\t\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getField()
      }
    },
    model: {
      value: (_vm.pdata.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "platform_id", $$v)
      },
      expression: "pdata.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-option', {
      key: v.platform_id,
      attrs: {
        "label": v.platform_name,
        "value": v.platform_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t\t 小游戏名称：  \n\t\t\t\t\t"), _c('searchApp', {
    staticClass: "xs24",
    attrs: {
      "compare": "issued",
      "pholder": _vm.pholder
    },
    on: {
      "getid": _vm.changeId
    }
  })], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "gutter": 10
    }
  }, _vm._l((_vm.cardParams), function(item, index) {
    return _c('el-col', {
      attrs: {
        "xs": 24,
        "sm": 8,
        "md": 6,
        "lg": 6,
        "xl": 3
      }
    }, [_c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.cardParams[index].isLoading),
        expression: "cardParams[index].isLoading"
      }],
      staticClass: "card"
    }, [(_vm.cardIndex > index) ? _c('div', [_c('div', {
      staticClass: "cdName"
    }, [_c('b', [_vm._v(_vm._s(_vm.card[_vm.cardParams[index].name].title))]), _c('span', [_vm._v("最近7天   合计：" + _vm._s(_vm.card[_vm.cardParams[index].name].total))])]), _vm._v(" "), _c('div', {
      staticClass: "today"
    }, [_vm._v("昨天："), _c('span', [_vm._v(_vm._s(_vm.card[_vm.cardParams[index].name].yesterday))]), _vm._v(" "), (index == 0 || index == 1) ? _c('b', [_vm._v("人")]) : (index == 7) ? _c('b', [_vm._v("%")]) : _c('b', [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "yestoday"
    }, [_vm._v("\n\t\t  \t\t\t\t\t对比前天：\n\t\t  \t\t\t\t\t"), _c('span', {
      class: _vm.card[_vm.cardParams[index].name].compare_day > 0 ? 'up' : 'down'
    }, [(_vm.card[_vm.cardParams[index].name].compare_day > 0) ? _c('i', {
      staticClass: "el-icon-top"
    }) : _vm._e(), _vm._v(" "), (_vm.card[_vm.cardParams[index].name].compare_day < 0) ? _c('i', {
      staticClass: "el-icon-bottom"
    }) : _vm._e(), _vm._v(" "), _c('b', {
      class: _vm.card[_vm.cardParams[index].name].compare_day == 0 ? 'none' : ''
    }, [(_vm.card[_vm.cardParams[index].name].compare_day == 0) ? _c('i', {
      staticClass: "el-icon-minus"
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm.card[_vm.cardParams[index].name].compare_day) + "%")])])]), _vm._v(" "), _c('div', {
      staticClass: "yestoday"
    }, [_vm._v("\n\t\t  \t\t\t\t\t对比上周：\n\t\t  \t\t\t\t\t"), _c('span', {
      class: _vm.card[_vm.cardParams[index].name].compare_week > 0 ? 'up' : 'down'
    }, [(_vm.card[_vm.cardParams[index].name].compare_week > 0) ? _c('i', {
      staticClass: "el-icon-top"
    }) : _vm._e(), _vm._v(" "), (_vm.card[_vm.cardParams[index].name].compare_week < 0) ? _c('i', {
      staticClass: "el-icon-bottom"
    }) : _vm._e(), _vm._v(" "), _c('b', {
      class: _vm.card[_vm.cardParams[index].name].compare_week == 0 ? 'none' : ''
    }, [(_vm.card[_vm.cardParams[index].name].compare_week == 0) ? _c('i', {
      staticClass: "el-icon-minus"
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm.card[_vm.cardParams[index].name].compare_week) + "%")])])])]) : _vm._e()])])
  }), 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "gutter": 10
    }
  }, _vm._l((_vm.chartParams), function(item, index) {
    return _c('el-col', {
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 24,
        "lg": index == 0 ? 24 : 12,
        "xl": index == 0 ? 24 : 12
      }
    }, [_c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.chartParams[index].isLoading),
        expression: "chartParams[index].isLoading"
      }],
      staticClass: "card"
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "height": "500px"
      },
      attrs: {
        "id": 'option_' + item.name
      }
    })])])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1148:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary",
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")]), _vm._v("\n\t\t\t\t 日期：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(2)
      }
    }
  }, [_vm._v("前天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(30)
      }
    }
  }, [_vm._v("最近30天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 日期筛选：  \n\t\t\t\t"), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 游戏来源：  \n\t\t\t\t "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "内部游戏",
      "value": "内部游戏"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外部游戏",
      "value": "外部游戏"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 平台来源：  \n\t\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源"
    },
    on: {
      "change": _vm.changePlatform
    },
    model: {
      value: (_vm.pdata.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "platform_id", $$v)
      },
      expression: "pdata.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-option', {
      key: v.platform_id,
      attrs: {
        "label": v.platform_name,
        "value": v.platform_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 小游戏名称：  \n\t\t\t\t"), _c('searchApp', {
    staticClass: "xs24",
    attrs: {
      "platform_id": _vm.pdata.platform_id.toString(),
      "compare": "issued",
      "pholder": _vm.pholder
    },
    on: {
      "getid": _vm.changeId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportIncome
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fieldConfig
    }
  }, [_vm._v("字段选择")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "background": "#fff"
    }
  }, [(_vm.list.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "d_date",
      "label": "日期",
      "align": "center",
      "min-width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "发行名称",
      "align": "center",
      "min-width": "120px"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center",
        "sortable": "",
        "sort-method": function (a, b) {
          return parseFloat(a[item.key]) - parseFloat(b[item.key])
        }
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "el-table el-table--fit el-table--striped el-table--enable-row-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "el-table__body-wrapper is-scrolling-none"
  }, [_c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v("暂无数据")])])])]) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出选择",
      "visible": _vm.checkDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.checkDialog = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")])], 1)], 1), _vm._v(" "), (_vm.activeType == 0) ? _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist0), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeType == 1) ? _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist1), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeType == 2) ? _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist2), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeType == 3) ? _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist3), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeType == 4) ? _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist4), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleDownload
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "我是标题",
      "size": "580px",
      "visible": _vm.drawer,
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.fieldListChange
    },
    model: {
      value: (_vm.FieldIndex),
      callback: function($$v) {
        _vm.FieldIndex = $$v
      },
      expression: "FieldIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "按字段设置",
      "name": "0"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTap(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selectFieldList),
      callback: function($$v) {
        _vm.selectFieldList = $$v
      },
      expression: "selectFieldList"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.selectFieldList), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('i', {
      staticClass: "el-icon-rank"
    }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeSelectField(item)
        }
      }
    })])
  }), 0)], 1)], 1)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按模块设置",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTapForModel(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _vm._l((_vm.selectFieldListForModel), function(value, key, index) {
    return _c('div', {
      staticClass: "fliedModel"
    }, [_c('div', {
      staticClass: "fliedModelKey"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('draggable', {
      attrs: {
        "move": _vm.onMove
      },
      on: {
        "start": function($event) {
          _vm.isDragging = true
        },
        "end": function($event) {
          _vm.isDragging = false
        }
      },
      model: {
        value: (_vm.selectFieldListForModel[key]),
        callback: function($$v) {
          _vm.$set(_vm.selectFieldListForModel, key, $$v)
        },
        expression: "selectFieldListForModel[key]"
      }
    }, [_c('transition-group', {
      attrs: {
        "type": "transition",
        "tag": "ul"
      }
    }, _vm._l((value), function(item) {
      return _c('li', {
        key: item.key,
        staticClass: "item"
      }, [_c('i', {
        staticClass: "el-icon-rank"
      }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
        staticClass: "el-icon-close",
        on: {
          "click": function($event) {
            return _vm.removeSelectFieldForModel(item, key)
          }
        }
      })])
    }), 0)], 1)], 1)
  })], 2)])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRowWhite",
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(30)
      }
    }
  }, [_vm._v("最近30天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "disabled": _vm.loading
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportIncome
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t\t\t 平台来源：  \n\t\t\t\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源",
      "clearable": ""
    },
    on: {
      "change": _vm.changePlatform
    },
    model: {
      value: (_vm.pdata.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "platform_id", $$v)
      },
      expression: "pdata.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-option', {
      key: v.platform_id,
      attrs: {
        "label": v.platform_name,
        "value": v.platform_id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height,
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.3)",
      "header-cell-class-name": _vm.getHeaderCellClassName,
      "cell-class-name": _vm.cellClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "发行名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "虚拟结算",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "huanliang_in",
      "label": "换入量",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.huanliang_in - 0) - (b.huanliang_in - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "量级*单价",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("换入量")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.huanliang_in) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "huanliang_out",
      "label": "换出量",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.huanliang_out - 0) - (b.huanliang_out - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "量级*单价",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("换出量")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.huanliang_out) + "\n\t\t\t      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "matrix_buy_cost",
      "label": "矩阵买量",
      "align": "center",
      "min-width": "110px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.matrix_buy_cost - 0) - (b.matrix_buy_cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.matrix_buy_cost) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "matrix_sell_income",
      "label": "矩阵卖量",
      "align": "center",
      "min-width": "110px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.matrix_sell_income - 0) - (b.matrix_sell_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.matrix_sell_income) + "\n\t\t\t    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "现金结算",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "origin_income",
      "label": "流量主",
      "align": "center",
      "min-width": "90px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.origin_income - 0) - (b.origin_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.origin_income) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_divide_income",
      "label": "流量主分成后",
      "align": "center",
      "min-width": "160px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.origin_divide_income - 0) - (b.origin_divide_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.origin_divide_income) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "channel_sell_income",
      "label": "渠道卖量",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.channel_sell_income - 0) - (b.channel_sell_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.channel_sell_income) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "channel_buy_cost",
      "label": "渠道买量",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.channel_buy_cost - 0) - (b.channel_buy_cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.channel_buy_cost) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gdt_buy_cost",
      "label": "广点通",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.gdt_buy_cost - 0) - (b.gdt_buy_cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.gdt_buy_cost) + "\n\t\t\t    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "合计（含矩阵）",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "total_income_contain_matrix",
      "label": "收入",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_income_contain_matrix - 0) - (b.total_income_contain_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_income_contain_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_cost_contain_matrix",
      "label": "成本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_cost_contain_matrix - 0) - (b.total_cost_contain_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "成本日报-实际花费",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("成本")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_cost_contain_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_profit_contain_matrix",
      "label": "利润",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_profit_contain_matrix - 0) - (b.total_profit_contain_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "收入合计-买量成本",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("利润")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t      \t￥"), _c('span', {
          class: scope.row.total_profit_contain_matrix > 0 ? '' : 'red'
        }, [_vm._v(_vm._s(scope.row.total_profit_contain_matrix))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "合计（不含矩阵）",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "total_income_no_matrix",
      "label": "收入",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_income_no_matrix - 0) - (b.total_income_no_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_income_no_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_cost_no_matrix",
      "label": "成本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_cost_no_matrix - 0) - (b.total_cost_no_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "成本日报-实际花费",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("成本")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_cost_no_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_profit_no_matrix",
      "label": "利润",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_profit_no_matrix - 0) - (b.total_profit_no_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "收入合计-买量成本",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("利润")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t      \t￥"), _c('span', {
          class: scope.row.total_profit_no_matrix >= 0 ? '' : 'red'
        }, [_vm._v(_vm._s(scope.row.total_profit_no_matrix))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出选择",
      "visible": _vm.checkDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.checkDialog = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleDownload
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 1151:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1200px",
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('div', {
    staticClass: "mainSelect"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入/选择小程序名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct(item)
        }
      }
    })
  }), 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1152:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRowWhite",
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportIncome
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t\t 平台来源：  \n\t\t\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源"
    },
    on: {
      "change": _vm.changePlatform
    },
    model: {
      value: (_vm.pdata.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "platform_id", $$v)
      },
      expression: "pdata.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-option', {
      key: v.platform_id,
      attrs: {
        "label": v.platform_name,
        "value": v.platform_id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height,
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.3)",
      "header-cell-class-name": _vm.getHeaderCellClassName,
      "cell-class-name": _vm.cellClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "d_date",
      "label": "日期",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "虚拟结算",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "huanliang_in",
      "label": "换入量",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.huanliang_in - 0) - (b.huanliang_in - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "量级*单价",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("换入量")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.huanliang_in) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "huanliang_out",
      "label": "换出量",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.huanliang_out - 0) - (b.huanliang_out - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "量级*单价",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("换出量")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.huanliang_out) + "\n\t\t\t      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "matrix_buy_cost",
      "label": "矩阵买量",
      "align": "center",
      "min-width": "110px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.matrix_buy_cost - 0) - (b.matrix_buy_cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.matrix_buy_cost) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "matrix_sell_income",
      "label": "矩阵卖量",
      "align": "center",
      "min-width": "110px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.matrix_sell_income - 0) - (b.matrix_sell_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.matrix_sell_income) + "\n\t\t\t    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "现金结算",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "origin_income",
      "label": "流量主",
      "align": "center",
      "min-width": "100px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.origin_income - 0) - (b.origin_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.origin_income) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_divide_income",
      "label": "流量主分成后",
      "align": "center",
      "min-width": "120px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.origin_divide_income - 0) - (b.origin_divide_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.origin_divide_income) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "channel_sell_income",
      "label": "渠道卖量",
      "align": "center",
      "sortable": "",
      "min-width": "100px",
      "sort-method": function (a, b) {
        return (a.channel_sell_income - 0) - (b.channel_sell_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.channel_sell_income) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "channel_buy_cost",
      "label": "渠道买量",
      "align": "center",
      "sortable": "",
      "min-width": "100px",
      "sort-method": function (a, b) {
        return (a.channel_buy_cost - 0) - (b.channel_buy_cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.channel_buy_cost) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gdt_buy_cost",
      "label": "广点通",
      "align": "center",
      "sortable": "",
      "min-width": "100px",
      "sort-method": function (a, b) {
        return (a.gdt_buy_cost - 0) - (b.gdt_buy_cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.gdt_buy_cost) + "\n\t\t\t    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "合计（含矩阵）",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "total_income_contain_matrix",
      "label": "收入",
      "align": "center",
      "min-width": "100px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_income_contain_matrix - 0) - (b.total_income_contain_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_income_contain_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_cost_contain_matrix",
      "label": "成本",
      "align": "center",
      "min-width": "100px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_cost_contain_matrix - 0) - (b.total_cost_contain_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "成本日报-实际花费",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("成本")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_cost_contain_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_profit_contain_matrix",
      "label": "利润",
      "align": "center",
      "min-width": "100px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_profit_contain_matrix - 0) - (b.total_profit_contain_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "收入合计-买量成本",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("利润")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t      \t￥"), _c('span', {
          class: scope.row.total_profit_contain_matrix > 0 ? '' : 'red'
        }, [_vm._v(_vm._s(scope.row.total_profit_contain_matrix))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "合计（不含矩阵）",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "total_income_no_matrix",
      "label": "收入",
      "align": "center",
      "min-width": "100px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_income_no_matrix - 0) - (b.total_income_no_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_income_no_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_cost_no_matrix",
      "label": "成本",
      "align": "center",
      "min-width": "100px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_cost_no_matrix - 0) - (b.total_cost_no_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "成本日报-实际花费",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("成本")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_cost_no_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_profit_no_matrix",
      "label": "利润",
      "align": "center",
      "min-width": "100px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_profit_no_matrix - 0) - (b.total_profit_no_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "收入合计-买量成本",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("利润")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t      \t￥"), _c('span', {
          class: scope.row.total_profit_no_matrix >= 0 ? '' : 'red'
        }, [_vm._v(_vm._s(scope.row.total_profit_no_matrix))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: '收入日报详情',
                'query': {
                  'sdate': scope.row.d_date.substring(0, 4) + '-' + scope.row.d_date.substring(4, 6) + '-' + scope.row.d_date.substring(6, 8),
                  'edate': scope.row.d_date.substring(0, 4) + '-' + scope.row.d_date.substring(4, 6) + '-' + scope.row.d_date.substring(6, 8),
                  platform_id: _vm.pdata.platform_id
                }
              })
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出选择",
      "visible": _vm.checkDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.checkDialog = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleDownload
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1153:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-question sicon c1"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("总访问人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText t1"
  }, [_vm._v(_vm._s(((_vm.cdata.total.visit_uv || '0') + '').replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,')))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card xs24",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon c2"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("总新增访问")]), _vm._v(" "), _c('div', {
    staticClass: "numText t2"
  }, [_vm._v(_vm._s(((_vm.cdata.total.visit_uv_new || '0') + '').replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,')))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 16,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "seven"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 8,
      "xs": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('searchApp', {
    staticClass: "xs24",
    attrs: {
      "compare": "issued",
      "pholder": _vm.pholder
    },
    on: {
      "getid": _vm.changeId
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "xs24",
    staticStyle: {
      "min-width": "1200px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.cdata.list,
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "app_name",
      "label": "小游戏名称",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv",
      "label": "访问人数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_new",
      "label": "新增访问人数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "share_uv",
      "label": "分享人数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '基础更多',
                params: {
                  edate: _vm.pdata.edate,
                  sdate: _vm.pdata.sdate,
                  app_id: scope.row.app_id
                }
              })
            }
          }
        }, [_vm._v("更多数据")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setCookie = setCookie;
exports.getCookie = getCookie;
exports.delCookie = delCookie;
function setCookie(c_name, value, expire, domain) {
    var date = new Date();
    date.setSeconds(date.getSeconds() + expire);

    document.cookie = c_name + "=" + escape(value) + "; expires=" + date.toGMTString() + ";" + domain;
}

function getCookie(c_name) {
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            var c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) c_end = document.cookie.length;
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
}

function delCookie(c_name) {
    setCookie(c_name, "", -1, "path=/;domain=" + (location.hostname == 'localhost' ? 'localhost' : '.y7y.net'));
}

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _html2canvas = __webpack_require__(1073);

var _html2canvas2 = _interopRequireDefault(_html2canvas);

var _jspdf = __webpack_require__(1074);

var _jspdf2 = _interopRequireDefault(_jspdf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function downloadPDF(ele, pdfName) {

    var eleW = ele.offsetWidth;
    var eleH = ele.offsetHeight;
    var eleOffsetTop = ele.offsetTop;
    var eleOffsetLeft = ele.offsetLeft;

    var canvas = document.createElement("canvas");
    var abs = 0;

    var win_in = document.documentElement.clientWidth || document.body.clientWidth;
    var win_out = window.innerWidth;

    if (win_out > win_in) {
        abs = (win_out - win_in) / 2;
    }
    canvas.width = eleW * 2;
    canvas.height = eleH * 2;

    var context = canvas.getContext("2d");
    context.scale(2, 2);
    context.translate(-eleOffsetLeft - abs, -eleOffsetTop);

    (0, _html2canvas2.default)(ele, {
        dpi: 300,

        useCORS: true }).then(function (canvas) {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;

        var pageHeight = contentWidth / 592.28 * 841.89;

        var leftHeight = contentHeight;

        var position = 0;

        var imgWidth = 595.28;
        var imgHeight = 595.28 / contentWidth * contentHeight;
        var pageData = canvas.toDataURL('image/jpeg', 1.0);
        var pdf = new _jspdf2.default('', 'pt', 'a4');

        if (leftHeight < pageHeight) {
            pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        } else {
            while (leftHeight > 0) {
                pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
                leftHeight -= pageHeight;
                position -= 841.89;

                if (leftHeight > 0) {
                    pdf.addPage();
                }
            }
        }

        pdf.save(pdfName);
    });
}
exports.default = {
    downloadPDF: downloadPDF
};

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(1090);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(1088);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(1089);

var _Home2 = _interopRequireDefault(_Home);

var _totalData = __webpack_require__(1114);

var _totalData2 = _interopRequireDefault(_totalData);

var _totalDataDetail = __webpack_require__(1115);

var _totalDataDetail2 = _interopRequireDefault(_totalDataDetail);

var _totalDetail = __webpack_require__(1116);

var _totalDetail2 = _interopRequireDefault(_totalDetail);

var _basicData = __webpack_require__(1105);

var _basicData2 = _interopRequireDefault(_basicData);

var _basicDetail = __webpack_require__(1106);

var _basicDetail2 = _interopRequireDefault(_basicDetail);

var _channelControl = __webpack_require__(1107);

var _channelControl2 = _interopRequireDefault(_channelControl);

var _channelData = __webpack_require__(1108);

var _channelData2 = _interopRequireDefault(_channelData);

var _pList = __webpack_require__(1113);

var _pList2 = _interopRequireDefault(_pList);

var _channelDataList = __webpack_require__(1109);

var _channelDataList2 = _interopRequireDefault(_channelDataList);

var _channelDataListDetail = __webpack_require__(1110);

var _channelDataListDetail2 = _interopRequireDefault(_channelDataListDetail);

var _gdtDataList = __webpack_require__(1112);

var _gdtDataList2 = _interopRequireDefault(_gdtDataList);

var _list = __webpack_require__(1118);

var _list2 = _interopRequireDefault(_list);

var _productDaily = __webpack_require__(1095);

var _productDaily2 = _interopRequireDefault(_productDaily);

var _productDailyDetail = __webpack_require__(1096);

var _productDailyDetail2 = _interopRequireDefault(_productDailyDetail);

var _incomeDaily = __webpack_require__(1103);

var _incomeDaily2 = _interopRequireDefault(_incomeDaily);

var _incomeDailyDetail = __webpack_require__(1104);

var _incomeDailyDetail2 = _interopRequireDefault(_incomeDailyDetail);

var _costDaily = __webpack_require__(1099);

var _costDaily2 = _interopRequireDefault(_costDaily);

var _costDailyDetail = __webpack_require__(1100);

var _costDailyDetail2 = _interopRequireDefault(_costDailyDetail);

var _dataList = __webpack_require__(1102);

var _dataList2 = _interopRequireDefault(_dataList);

var _dataDetail = __webpack_require__(1101);

var _dataDetail2 = _interopRequireDefault(_dataDetail);

var _dataList3 = __webpack_require__(1092);

var _dataList4 = _interopRequireDefault(_dataList3);

var _dataDetail3 = __webpack_require__(1091);

var _dataDetail4 = _interopRequireDefault(_dataDetail3);

var _statisticsList = __webpack_require__(1094);

var _statisticsList2 = _interopRequireDefault(_statisticsList);

var _statisticsDetail = __webpack_require__(1093);

var _statisticsDetail2 = _interopRequireDefault(_statisticsDetail);

var _exchangeDaily = __webpack_require__(1097);

var _exchangeDaily2 = _interopRequireDefault(_exchangeDaily);

var _exchangeDailyDetail = __webpack_require__(1098);

var _exchangeDailyDetail2 = _interopRequireDefault(_exchangeDailyDetail);

var _costLog = __webpack_require__(1117);

var _costLog2 = _interopRequireDefault(_costLog);

var _dataBoard = __webpack_require__(1111);

var _dataBoard2 = _interopRequireDefault(_dataBoard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '登录',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '404',
    hidden: true
}, {
    path: 'http://beta-sdk-api.y7y.net/index.php?s=/platform',
    component: _2.default,
    name: 'out',
    hidden: true
}, {
    path: '/',
    leaf: true,
    component: _Home2.default,
    redirect: '/mainData/index',
    name: '整体数据',
    iconCls: 'el-icon-message',
    children: [{ path: 'dataBoard/index', component: _dataBoard2.default, name: '数据汇总' }, { path: 'mainData/index', component: _totalData2.default, name: '整体数据2' }, { path: 'mainData/index/:issued_app_id', component: _totalDataDetail2.default, name: '整体数据详情' }, { path: '/totalDetail/:issued_app_id', component: _totalDetail2.default, name: '更多数据' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '基础数据',
    iconCls: 'el-icon-message',
    children: [{ path: 'baseData/index', component: _basicData2.default, name: '基础数据2' }, { path: '/basicDetail', component: _basicDetail2.default, name: '基础更多' }, { path: 'productDaily/index', component: _productDaily2.default, name: '产品日报', meta: { keepAlive: true } }, { path: 'productDaily/detail/:issued_app_id', component: _productDailyDetail2.default, name: '产品日报详情', meta: { keepAlive: true } }, { path: 'incomeDaily/index', component: _incomeDaily2.default, name: '收入日报', meta: { keepAlive: true } }, { path: 'incomeDaily/detail', component: _incomeDailyDetail2.default, name: '收入日报详情', meta: { keepAlive: true } }, { path: 'costDaily/index', component: _costDaily2.default, name: '成本日报' }, { path: 'costDaily/index/:issued_app_id', component: _costDailyDetail2.default, name: '成本日报详情' }, { path: 'exchange/index', component: _exchangeDaily2.default, name: '扣量日报' }, { path: 'exchange/detail/:company_id', component: _exchangeDailyDetail2.default, name: '扣量日报详情' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '成本账单',
    iconCls: 'el-icon-message',
    children: [{ path: 'billIssuedData/index', component: _dataList2.default, name: '账单列表' }, { path: 'billData/detail/:index_id', component: _dataDetail2.default, name: '账单详情明细' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '分成账单',
    iconCls: 'el-icon-message',
    children: [{ path: 'billCpData/index', component: _dataList4.default, name: '账单列表' }, { path: 'billCpData/detail/:index_id', component: _dataDetail4.default, name: '账单详情明细' }, { path: 'billCpData/summary', component: _statisticsList2.default, name: '分成账单统计' }, { path: 'billCpData/summary/:id', component: _statisticsDetail2.default, name: '分成账单统计详情' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '渠道数据',
    iconCls: 'el-icon-message',
    children: [{ path: 'issuedAldChannel/index', component: _channelControl2.default, name: '渠道管理' }, { path: 'issuedAldData/index', component: _channelData2.default, name: '渠道分析' }, { path: 'issuedAldData/list/:issued_app_id', component: _channelDataList2.default, name: '渠道数据分析列表' }, { path: 'issuedAldData/list/detail/:issued_app_id', component: _channelDataListDetail2.default, name: '渠道数据分析列表详情' }, { path: 'issuedAldChannelGdt/index', component: _gdtDataList2.default, name: '广点通渠道回收' }]
}, {
    path: '/',
    component: _Home2.default,
    leaf: true,
    name: '账号管理',
    iconCls: 'el-icon-message',
    children: [{ path: 'issuedApp/index', component: _pList2.default, name: '账号管理2' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '脚本列表',
    iconCls: 'el-icon-message',
    children: [{ path: '/python/index', component: _list2.default, name: '脚本列表2' }],
    redirect: { name: '404' }
}, {
    path: '/',
    component: _Home2.default,
    name: '日志管理',
    iconCls: 'el-icon-message',
    children: [{ path: '/log/cost', component: _costLog2.default, name: '成本日志' }],
    redirect: { name: '404' }
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(30);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(62);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(484);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(485);

var getters = _interopRequireWildcard(_getters);

var _cookie = __webpack_require__(138);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10,
    groupid: (0, _cookie.getCookie)('groupid')
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    },
    SETGROUPID: function SETGROUPID(state, groupid) {
        state.groupid = groupid;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    config: {},
    applist: [],
    vlist: [],
    plist: [],
    mutations: mutations
});

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1033)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(1134),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1141),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var props = {
  compare: { type: String, default: "name" },
  pholder: { type: String, default: "" },
  sstyle: { type: String, default: "width:200px" },
  platform_id: { type: String, default: "2" }
};
exports.default = {
  props: props,
  data: function data() {
    return {
      inputKW: this.pholder,
      applist: [],
      compares: this.compare,
      ptext: "请输入小程序名称"
    };
  },

  watch: {
    pholder: function pholder(val) {
      this.inputKW = val;
    },
    compare: function compare(val) {
      this.compares = val;
    },

    platform_id: {
      handler: function handler(n, o) {
        if (n != o) {
          this.inputKW = '';
          this.$emit("getid", "");
        }
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    SearchId: function SearchId(str, cb) {
      var _this = this;

      if (str === null) {
        str = '';
      }
      if (this.compares == "name") {
        (0, _api.getAppid)(str, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            cb(res.data.list);
          }
        });
      } else if (this.compares == "issued") {

        (0, _api.getIssuedAppList)("page=1&perpage=1000&kw=" + str + '&platform_id=' + this.platform_id, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this.applist = res.data;
            var applist = _this.applist;
            var results = str ? applist.filter(_this.createFilter(str)) : applist;

            cb(results);
          }
        });
      }
    },
    createFilter: function createFilter(str) {
      return function (res) {
        return res.name.toLowerCase().indexOf(str.toLowerCase()) === 0;
      };
    },
    SelectApp: function SelectApp(s) {
      this.inputKW = s.name;
      this.$emit("getid", s.id);
      this.$emit("getInfo", s);
    },
    clear: function clear() {
      this.$emit("getid", "");
    }
  }
};

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  data: function data() {
    var _this2 = this;

    var nPass = function nPass(rule, value, callback) {
      if (value == "") {
        callback(new Error("新密码不能为空!"));
      } else if (value.length < 6) {
        callback(new Error("密码长度不能低于6位"));
      } else {
        callback();
      }
    };
    var vPass = function vPass(rule, value, callback) {
      if (value == "") {
        callback(new Error("确认密码不能为空!"));
      } else if (value !== _this2.form.new_password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        old_password: [{ required: true, message: "原密码不能为空", trigger: "change" }],
        new_password: [{ required: true, validator: nPass, trigger: "blur" }],
        checkPass: [{ validator: vPass, required: true, trigger: "blur" }]
      },
      screenWidth: document.body.clientWidth,
      sysName: "买量后台",
      collapsed: false,
      uName: "",
      menu: [],
      iconClass: ["el-icon-message", "el-icon-document", "el-icon-menu", "el-icon-tickets", "el-icon-news", "el-icon-upload", "el-icon-date", "el-icon-star-on"],
      dpath: "/plist",

      updatePwd: false,
      form: { old_password: "", new_password: "" }
    };
  },
  created: function created() {
    var that = this;
    document.onkeydown = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.updatePwd) {
        that.changePwd();
        return false;
      }
    };
  },

  methods: {
    goHome: function goHome() {
      window.location.href = 'https://home.yxcg.net/';
    },
    jump: function jump(url) {
      window.location.href = url + '&xtoken=' + this.$cookie.getCookie("login");
    },
    cpwd: function cpwd() {
      this.form = { old_password: "", new_password: "" };
      this.updatePwd = true;
    },
    changePwd: function changePwd() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          (0, _api.scpwd)(_this3.form, _this3.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this3.updatePwd = false;
              _this3.$router.push({ path: "/login" });
            } else {
              _this3.$message.error(res.msg);
            }
          });
        }
      });
    },
    onSubmit: function onSubmit() {
      console.log("submit!");
    },
    handleopen: function handleopen() {
      console.log("handleopen");
    },
    handleclose: function handleclose() {},

    handleselect: function handleselect(a, b) {},

    logout: function logout() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {}).then(function () {
        _this.$router.push("/login");
      }).catch(function () {});
    },

    collapse: function collapse() {
      this.collapsed = !this.collapsed;
    },
    showMenu: function showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName("submenu-hook-" + i)[0].style.display = status ? "block" : "none";
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    var that = this;

    if (this.$route.path.indexOf('/costDaily/') >= 0) {
      this.dpath = '/costDaily/index';
    } else if (this.$route.path.indexOf('/productDaily/') >= 0) {
      this.dpath = '/productDaily/index';
    } else if (this.$route.path.indexOf('/issuedAldData/') >= 0) {
      this.dpath = '/issuedAldData/index';
    } else {
      this.dpath = this.$route.path;
    }
    console.log(this.dpath);

    if (this.$cookie.getCookie("user")) {
      this.uName = decodeURIComponent(this.$cookie.getCookie("user"));
    }

    (0, _api.sconfig)(this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this4.$store.config = res.data;
      }
    });
    (0, _api.smenu)(this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this4.menu = res.data;
      }
    });
    var _this = this;
    window.onresize = function () {
      return function () {
        if (_this.$route.path == "/mainData/index" || _this.$route.path == "/baseData/index" || _this.$route.path == "/issuedChannelData/index") {
          if (_this.$refs.myMain.timer) {
            clearTimeout(_this.$refs.myMain.timer);
          }
          _this.$refs.myMain.timer = setTimeout(function () {
            _this.$refs.myMain.chartColumn.resize();
          }, 200);
        }
      }();
    };
  }
};

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = __webpack_require__(62);

var _api = __webpack_require__(8);

var _cookie = __webpack_require__(138);

exports.default = {
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: ''
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this2.logining = true;
          var loginParams = { username: _this2.ruleForm2.account, password: _this2.ruleForm2.checkPass };
          (0, _api.slogin)(loginParams).then(function (res) {
            _this2.logining = false;
            var msg = res.msg,
                code = res.code,
                data = res.data;

            if (code !== 200) {
              _this2.$message({
                message: msg,
                type: 'error'
              });
            } else {
              (0, _cookie.setCookie)('login', data.token, 60 * 60 * 24, "path=/;domain=" + (location.hostname == 'localhost' ? 'localhost' : location.hostname.replace(/([a-zA-Z0-9\-])+\./, '.')));
              (0, _cookie.setCookie)('user', encodeURIComponent(_this2.ruleForm2.account), 60 * 60 * 24, "path=/;domain=" + (location.hostname == 'localhost' ? 'localhost' : location.hostname.replace(/([a-zA-Z0-9\-])+\./, '.')));
              (0, _cookie.setCookie)('groupid', data.group_id, 60 * 60 * 24, "path=/;domain=" + (location.hostname == 'localhost' ? 'localhost' : location.hostname.replace(/([a-zA-Z0-9\-])+\./, '.')));
              _this2.$store.dispatch('setGroupId', data.group_id);
              _this2.$router.push({ path: '/' });
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  created: function created() {}
};

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  components: {},
  data: function data() {
    return {
      rules: {},
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        bill_issued_data_id: 0,
        bill_date: ''
      },
      plist: [],
      company: '',
      wecompany: [],
      bill: '',
      formLabelWidth: "100px",

      plog: [],
      logDialog: false

    };
  },

  watch: {},
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getBillDataDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.company = res.data.company;
          _this.bill = res.data.bill;
          _this.wecompany = res.data.wecompany;
          if (res.data.list && res.data.list.length > 0) {
            _this.plist = res.data.list;
            _this.plist.sort(_this.compareStatus);
          }
        }
      });
    },

    compareStatus: function compareStatus(val1, val2) {
      return val1.type_val - val2.type_val;
    }
  },
  created: function created() {
    var that = this;
  },
  mounted: function mounted() {

    this.pdata.bill_issued_data_id = this.$route.params.index_id;
    this.pdata.bill_date = this.$route.query.bill_date;
    this.getList();
  }
};

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(72);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(54);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

var _htmlToPdf = __webpack_require__(139);

var _htmlToPdf2 = _interopRequireDefault(_htmlToPdf);

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

var _vuex = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  data: function data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入企业/个人名称", trigger: "blur" }],
        opening_bank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        receiving_account: [{ required: true, message: "请输入收款账号", trigger: "blur" }]
      },
      editFormRules: {
        other_cost: [{ required: true, message: "请输入其它费用（原生分成）", trigger: "blur" }],
        origin_income: [{ required: true, message: "请输入原生收入", trigger: "blur" }],
        divide_per: [{ required: true, message: "请输入结算比例", trigger: "blur" }],
        sell_income: [{ required: true, message: "请输入分成收入（利润分成）", trigger: "blur" }],
        export_cost: [{ required: true, message: "请输入导量成本（利润分成）", trigger: "blur" }]
      },
      remarkRules: {
        remark: [{ required: true, message: "备注不能为空", trigger: "blur" }]
      },
      pdata: {
        page: 1,
        perpage: 20,
        status: "",
        cp_company_id: "",
        bill_type: '1',
        d_date: new Date().getMonth() + 1 < 10 ? new Date().getFullYear().toString() + '0' + (new Date().getMonth() + 1) : new Date().getFullYear().toString() + (new Date().getMonth() + 1).toString()
      },
      plist: [],
      company_a: '',
      company_b: '',
      bill_no: '',
      billList: [],
      company: '',
      wecompany: [],
      bill: '',
      companyList: [],
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [],
      logDialog: false,

      headMsg: {
        token: ""
      },
      imageUrl: "",
      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      },
      selectProduct: [],
      prWidth: 0,
      editForm: {},
      billDialog: false,
      height: 710,
      batchForm: [],
      url: _api.baseUrl + "billCpData/preview",
      headers: {
        'token': this.$cookie.getCookie("login")
      },
      batchDialog: false,
      batchTips: 0,
      batchPreDate: '',
      cpEditDialog: false,
      total: {
        other_cost: 0,
        origin_income: 0,
        total_cost: 0,
        profit: 0,
        sell_income: 0 },
      remarkDialog: false,
      remarkForm: {
        bill_cp_data_id: '',
        remark: ''

      }
    };
  },

  watch: {
    "pdata.stype": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    "pdata.status": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    "pdata.kw": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    "pdata.company_id": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    "pdata.date": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    }

  },
  methods: (_methods = {
    batchProduct: function batchProduct() {
      this.batchDialog = true;
      this.batchTips = 0;
      this.batchPreDate = '';
    },
    downloadTemp: function downloadTemp() {
      window.location.href = '/static/bill.csv';
    },
    batchSuccess: function batchSuccess(response, file, fileList) {
      if (response.code == 200) {
        this.batchForm = response.data;
        this.batchPreDate = this.batchForm[1][0].split('-')[0].substring(0, 6);
      }
    },
    batchCalcel: function batchCalcel() {
      this.batchDialog = false;
      this.batchForm = [];
      this.batchTips = 0;
    },
    batchSubmit: function batchSubmit() {
      var _this = this;

      var p = { "confirm": this.batchTips, "import_data": this.batchForm };
      (0, _api.batchCPAdd)(p, this.$cookie.getCookie("login")).then(function (response) {
        if (response.code == 200) {
          debugger;
          if (response.data.length > 1) {
            _this.batchForm = response.data;
            _this.batchTips = "1";
          } else {
            _this.$message({ message: "导入成功", type: "success" });
            _this.batchDialog = false;
            _this.batchForm = [];
            _this.pdata.d_date = _this.batchPreDate;
            _this.getList();
          }
        } else {
          _this.$message.error('导入失败');
        }
      });
    },
    handleDown: function handleDown() {
      _htmlToPdf2.default.downloadPDF(document.querySelector('#ta'), this.company.name + "结算对账单");
    },
    getSummaries: function getSummaries(param) {
      var _this2 = this;

      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 1 || index === 2 || index === 3 || index === 4) {
          sums[index] = '-';
          return;
        }
        if (_this2.pdata.bill_type == 1) {
          if (index === 7 || index === 8) {
            sums[index] = '-';
            return;
          }
        }
        if (_this2.pdata.bill_type == 2) {
          if (index === 9) {
            sums[index] = '-';
            return;
          }
          if (index === 10) {
            sums[index] = '-';
            return;
          }
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = '￥' + sums[index].toFixed(2);
        } else {
          sums[index] = '-';
        }
      });

      return sums;
    },
    handleDownload: function handleDownload() {
      var _this3 = this;

      var that = this;
      var arr = [];
      var arrHd = ["开始日期", "结束日期", "游戏名称", "渠道名称", "平台", "合作方式", "新增人数", "单价(元/个)", "应收金额"];
      var arrFval = ["bill_sdate", "bill_edate", "product_name", "channel_name", "platform", "type", "num", "unit", "bill_amount"];

      that.billList.forEach(function (v, i) {
        v.bill_amount = v.num * v.unit;
      });
      console.log(that.billList);
      if (that.billList == "") {
        return false;
      }

      console.log(arrHd);
      console.log(arrFval);
      __webpack_require__.e/* require.ensure */(0).then((function () {
        var _require = __webpack_require__(118),
            export_json_to_excel = _require.export_json_to_excel,
            export_table_to_excel = _require.export_table_to_excel;

        var tHeader = arrHd;
        var filterVal = arrFval;
        var list = _this3.billList;

        var data = _this3.formatJson(filterVal, list);
        data.push([""]);
        data.push([""]);
        data.push(["结算类型", _this3.company.type == 1 ? "企业" : "个人"]);
        data.push(["发票类型", _this3.bill.invoice_type == 1 ? '普通发票' : '增值发票']);
        data.push(["新增用户", _this3.bill.num]);
        data.push(["税点", _this3.bill.tax_point + '%']);
        data.push([_this3.company.type == 1 ? "结算金额" : "结算金额(扣去税点后金额)", _this3.bill.bill_amount]);
        data.push(["结算金额（人民币大写）", _this3.bill.big_bill_amount]);
        data.push([""]);
        data.push([""]);
        data.push(["甲方公司:" + _this3.company.name, null, null, null, _this3.wecompany[0]]);
        data.push(["税号:" + _this3.company.social_credit_code, null, null, null, _this3.wecompany[3]]);
        data.push(["注册地址:" + _this3.company.company_addr, null, null, null, _this3.wecompany[4]]);
        data.push(["注册电话:" + _this3.company.company_phone, null, null, null, _this3.wecompany[8]]);
        data.push(["开户银行:" + _this3.company.opening_bank, null, null, null, _this3.wecompany[1]]);
        data.push(["银行账号:" + _this3.company.receiving_account, null, null, null, _this3.wecompany[2]]);
        data.push(["联系人:" + _this3.company.contact, null, null, null, _this3.wecompany[6]]);
        data.push(["联系电话:" + _this3.company.phone, null, null, null, _this3.wecompany[7]]);
        data.push(["邮寄地址:" + _this3.company.email_addr, null, null, null, _this3.wecompany[5]]);

        export_json_to_excel(tHeader, data, _this3.company.name + "结算对账单");
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    search: function search() {
      this.getList();
    },
    createBillData: function createBillData() {
      this.editDialog = true;
    },
    updateCPBillData: function updateCPBillData(s, index) {
      this.cpEditDialog = true;
      this.editForm = {
        bill_cp_data_id: s.bill_cp_data_id,
        other_cost: s.other_cost,
        origin_income: s.origin_income,
        divide_per: s.divide_per,
        sell_income: s.sell_income,
        export_cost: s.export_cost
      };
    },
    saveCPBillData: function saveCPBillData() {
      var _this4 = this;

      (0, _api.CPEdit)(this.editForm, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this4.cpEditDialog = false;
          _this4.$notify({
            title: '通知',
            message: "编辑成功",
            type: 'success'
          });
          _this4.getList();
        } else {
          _this4.$message.error(res.msg);
        }
      });
    },
    editRemark: function editRemark(s) {
      this.remarkDialog = true;
      this.remarkForm.remark = s.remark;
      this.remarkForm.bill_cp_data_id = s.bill_cp_data_id;
    },
    saveRemark: function saveRemark() {
      var _this5 = this;

      (0, _api.CPRemark)(this.remarkForm, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this5.remarkDialog = false;
          _this5.$notify({
            title: '通知',
            message: "备注成功",
            type: 'success'
          });
          _this5.getList();
        } else {
          _this5.$message.error(res.msg);
        }
      });
    },
    getList: function getList() {
      var _this6 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getCPBillDataList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this6.plist = res.data.list;
            _this6.maxPage = res.data.max_page;
            if (_this6.pdata.cp_company_id != '') {
              _this6.company_a = res.data.company_a;
              _this6.company_b = res.data.company_b;
              _this6.bill_no = res.data.bill_no;
              _this6.total = {
                other_cost: 0,
                origin_income: 0,
                total_cost: 0,
                profit: 0,
                sell_income: 0
              };
              _this6.plist.forEach(function (v, i) {
                _this6.total.origin_income += parseFloat(v.origin_income);
                _this6.total.total_cost += parseFloat(v.total_cost);
                if (_this6.pdata.bill_type == 1) {
                  _this6.total.other_cost += parseFloat(v.other_cost);
                }
                if (_this6.pdata.bill_type == 2) {

                  _this6.total.sell_income += parseFloat(v.sell_income);
                  console.log(v.sell_income);
                  console.log(_this6.total.sell_income);
                  _this6.total.profit += parseFloat(v.profit);
                }
              });
            }
          } else {
            _this6.plist = [];
            _this6.maxPage = 1;
          }
        }
      });
    },
    getBillList: function getBillList(status, company_id, id) {
      this.billDialog = true;
      this.company = this.company_a;
      this.wecompany = this.company_b;
      this.billList = this.plist;
    },
    openDealy: function openDealy(id) {
      var _this7 = this;

      var p = 'type=bill_cp_data&index_id=' + id;
      (0, _api.sclog)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this7.logDialog = true;
          _this7.plog = res.data;
        } else {
          _this7.$message.error(res.msg);
        }
      });
    },
    getConfig: function getConfig() {
      var _this8 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(function () {
          _this8.getConfig();
        }, 50);
      }
    }
  }, (0, _defineProperty3.default)(_methods, "search", function search() {
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "SizeChange", function SizeChange(v) {
    this.pdata.perpage = v;
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "CurrentChange", function CurrentChange(v) {
    this.pdata.page = v;
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "base64", function base64(s) {
    return window.btoa(unescape(encodeURIComponent(s)));
  }), (0, _defineProperty3.default)(_methods, "format", function format(s, c) {
    return s.replace(/{(\w+)}/g, function (m, p) {
      return c[p];
    });
  }), (0, _defineProperty3.default)(_methods, "tableToExcel", function tableToExcel() {
    var uri = 'data:application/vnd.ms-excel;base64,';
    var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"' + 'xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>' + '<x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets>' + '</x:ExcelWorkbook></xml><![endif]-->' + ' <style type="text/css">' + 'table td {' + 'width: auto;' + 'height: 30px;' + ' text-align: center;' + 'background-color: #ffffff;' + 'color: #000000;' + ' }' + 'table th {' + 'width: auto;' + 'height: 30px;' + ' text-align: center;' + 'background-color: #ffffff;' + 'color: #000000;' + ' }' + '</style>' + '</head><body ><table class="excelTable" border="1" cellspacing="1" cellpadding="1">{table}</table></body></html>';
    var tableid = document.getElementById('ta');

    var ctx = { worksheet: this.company.name + "结算对账单" || 'Worksheet', table: tableid.innerHTML };
    console.log(uri + this.base64(this.format(template, ctx)));

    this.base64ToFile(uri + this.base64(this.format(template, ctx)));
  }), (0, _defineProperty3.default)(_methods, "base64ToFile", function base64ToFile(base) {
    var arr = base.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    if (window.navigator.msSaveBlob) {
      try {
        var blobObject = new Blob([u8arr], { type: mime });
        window.navigator.msSaveBlob(blobObject, this.company.name + '.xls');
      } catch (e) {
        console.log(e);
      }
    } else {
      var url = window.URL.createObjectURL(new Blob([u8arr], { type: mime }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.company.name + '.xls');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }), (0, _defineProperty3.default)(_methods, "getCPCompany", function getCPCompany() {
    var _this9 = this;

    (0, _api.getCPCompanyList)('', this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        if (res.data && res.data.list.length > 0) {
          _this9.companyList = res.data.list;
        }
      }
    });
  }), _methods),
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['groupid'])),
  created: function created() {

    console.log((0, _jquery2.default)(window).height() - 200);
    this.height = (0, _jquery2.default)(window).height() - 400;
  },
  mounted: function mounted() {
    this.pdata.cp_company_id = this.$route.query.cp_company_id;
    this.pdata.bill_type = this.$route.query.bill_type;
    this.pdata.d_date = this.$route.query.d_date;
    this.getList();
    this.getCPCompany();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(72);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(54);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

var _htmlToPdf = __webpack_require__(139);

var _htmlToPdf2 = _interopRequireDefault(_htmlToPdf);

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

var _vuex = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  data: function data() {
    return {

      pdata: {
        cp_company_id: "",
        bill_type: '0',
        sdate: new Date().getMonth() + 1 < 10 ? new Date().getFullYear().toString() + '0' + (new Date().getMonth() + 1) : new Date().getFullYear().toString() + (new Date().getMonth() + 1).toString(),
        edate: new Date().getMonth() + 1 < 10 ? new Date().getFullYear().toString() + '0' + (new Date().getMonth() + 1) : new Date().getFullYear().toString() + (new Date().getMonth() + 1).toString()
      },
      d_date: [new Date().getMonth() + 1 < 10 ? new Date().getFullYear().toString() + '0' + (new Date().getMonth() + 1) : new Date().getFullYear().toString() + (new Date().getMonth() + 1).toString(), new Date().getMonth() + 1 < 10 ? new Date().getFullYear().toString() + '0' + (new Date().getMonth() + 1) : new Date().getFullYear().toString() + (new Date().getMonth() + 1).toString()],
      plist: [],
      companyName: '',
      billList: [],
      companyList: [],

      prWidth: 0,

      billDialog: false,
      height: 710,

      total: {
        total_cost: 0
      }

    };
  },

  watch: {

    "pdata.cp_company_id": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    }

  },
  methods: (_methods = {
    handleDown: function handleDown() {
      var billname;
      if (this.pdata.bill_type == 1) {
        billname = '原生分成';
      } else if (this.pdata.bill_type == 2) {
        billname = '利润分成';
      }
      if (this.pdata.bill_type == 0) {
        billname = '汇总分成';
      }
      _htmlToPdf2.default.downloadPDF(document.querySelector('#ta'), this.companyName + this.pdata.sdate + "~" + this.pdata.edate + billname + "分成统计");
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 1 || index === 3 || index === 4) {
          sums[index] = '-';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = '￥' + sums[index].toFixed(2);
        } else {
          sums[index] = '-';
        }
      });

      return sums;
    },
    search: function search() {
      this.getList();
    },
    createBillData: function createBillData() {
      this.editDialog = true;
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      this.pdata.sdate = this.d_date[0];
      this.pdata.edate = this.d_date[1];

      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getbillCpDatasummaryDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this.plist = res.data.list;
            _this.maxPage = res.data.max_page;
            _this.total = {
              total_cost: 0
            };
            _this.plist.forEach(function (v, i) {
              _this.total.total_cost += v.total_cost - 0;
            });
            _this.total.total_cost = _this.total.total_cost.toFixed(2);
          } else {
            _this.plist = [];
            _this.maxPage = 1;
          }
        }
      });
      (0, _api.getCPCompanyList)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data && res.data.list.length > 0) {
            _this.companyList = res.data.list;
            _this.companyList.forEach(function (v, i) {
              if (v.id == _this.pdata.cp_company_id) {
                _this.companyName = v.name;
              }
            });
          }
        }
      });
    },
    getBillList: function getBillList(status, company_id, id) {
      this.billDialog = true;
      this.company = this.company_a;
      this.wecompany = this.company_b;
      this.billList = this.plist;
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    }
  }, (0, _defineProperty3.default)(_methods, "search", function search() {
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "base64", function base64(s) {
    return window.btoa(unescape(encodeURIComponent(s)));
  }), (0, _defineProperty3.default)(_methods, "format", function format(s, c) {
    return s.replace(/{(\w+)}/g, function (m, p) {
      return c[p];
    });
  }), (0, _defineProperty3.default)(_methods, "tableToExcel", function tableToExcel() {
    var uri = 'data:application/vnd.ms-excel;base64,';
    var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"' + 'xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>' + '<x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets>' + '</x:ExcelWorkbook></xml><![endif]-->' + ' <style type="text/css">' + 'table td {' + 'width: auto;' + 'height: 30px;' + ' text-align: center;' + 'background-color: #ffffff;' + 'color: #000000;' + ' }' + 'table th {' + 'width: auto;' + 'height: 30px;' + ' text-align: center;' + 'background-color: #ffffff;' + 'color: #000000;' + ' }' + '</style>' + '</head><body ><table class="excelTable" border="1" cellspacing="1" cellpadding="1">{table}</table></body></html>';
    var tableid = document.getElementById('ta');
    var billname;
    if (this.pdata.bill_type == 1) {
      billname = '原生分成';
    } else if (this.pdata.bill_type == 2) {
      billname = '利润分成';
    }
    if (this.pdata.bill_type == 0) {
      billname = '汇总分成';
    }
    var ctx = { worksheet: this.companyName + billname + "账单统计" || 'Worksheet', table: tableid.innerHTML };
    console.log(uri + this.base64(this.format(template, ctx)));

    this.base64ToFile(uri + this.base64(this.format(template, ctx)));
  }), (0, _defineProperty3.default)(_methods, "base64ToFile", function base64ToFile(base) {
    var billname;
    if (this.pdata.bill_type == 1) {
      billname = '原生分成';
    } else if (this.pdata.bill_type == 2) {
      billname = '利润分成';
    }
    if (this.pdata.bill_type == 0) {
      billname = '汇总分成';
    }
    var arr = base.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    if (window.navigator.msSaveBlob) {
      try {
        var blobObject = new Blob([u8arr], { type: mime });
        window.navigator.msSaveBlob(blobObject, this.companyName + this.pdata.sdate + "~" + this.pdata.edate + billname + '账单统计.xls');
      } catch (e) {
        console.log(e);
      }
    } else {
      var url = window.URL.createObjectURL(new Blob([u8arr], { type: mime }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.companyName + this.pdata.sdate + "~" + this.pdata.edate + billname + '账单统计.xls');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }), _methods),
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['groupid'])),
  created: function created() {

    console.log((0, _jquery2.default)(window).height() - 200);
    this.height = (0, _jquery2.default)(window).height() - 400;
  },
  mounted: function mounted() {
    this.pdata.sdate = this.$route.query.sdate;
    this.pdata.edate = this.$route.query.edate;
    this.pdata.cp_company_id = this.$route.params.id;
    this.d_date = [this.pdata.sdate, this.pdata.edate];
    this.getList();
    this.getConfig();

    this.prWidth = document.getElementById("section").offsetWidth;
  }
};

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(72);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(54);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

var _htmlToPdf = __webpack_require__(139);

var _htmlToPdf2 = _interopRequireDefault(_htmlToPdf);

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

var _vuex = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {},
	data: function data() {
		return {
			pdata: {
				cp_company_id: "",
				bill_type: '0',
				sdate: new Date().getMonth() + 1 < 10 ? new Date().getFullYear().toString() + '0' + (new Date().getMonth() + 1) : new Date().getFullYear().toString() + (new Date().getMonth() + 1).toString(),
				edate: new Date().getMonth() + 1 < 10 ? new Date().getFullYear().toString() + '0' + (new Date().getMonth() + 1) : new Date().getFullYear().toString() + (new Date().getMonth() + 1).toString()
			},
			d_date: [new Date().getMonth() + 1 < 10 ? new Date().getFullYear().toString() + '0' + (new Date().getMonth() + 1) : new Date().getFullYear().toString() + (new Date().getMonth() + 1).toString(), new Date().getMonth() + 1 < 10 ? new Date().getFullYear().toString() + '0' + (new Date().getMonth() + 1) : new Date().getFullYear().toString() + (new Date().getMonth() + 1).toString()],
			plist: [],
			billList: [],
			company: '',
			companyList: [],
			config: [],
			prWidth: 0,
			billDialog: false,
			height: 710,
			total: {
				total_cost: 0
			}

		};
	},

	watch: {
		"pdata.kw": {
			handler: function handler(n, o) {
				this.getList();
			},

			deep: true
		},
		"pdata.company_id": {
			handler: function handler(n, o) {
				this.getList();
			},

			deep: true
		}

	},
	methods: (_methods = {
		handleDown: function handleDown() {
			var billname;
			if (this.pdata.bill_type == 1) {
				billname = '原生分成';
			} else if (this.pdata.bill_type == 2) {
				billname = '利润分成';
			}
			if (this.pdata.bill_type == 0) {
				billname = '汇总分成';
			}
			_htmlToPdf2.default.downloadPDF(document.querySelector('#ta'), this.pdata.sdate + "~" + this.pdata.edate + billname + "账单统计");
		},
		getSummaries: function getSummaries(param) {
			var columns = param.columns,
			    data = param.data;

			var sums = [];
			columns.forEach(function (column, index) {
				if (index === 0) {
					sums[index] = '合计';
					return;
				}
				if (index === 1 || index === 3 || index === 4) {
					sums[index] = '-';
					return;
				}
				var values = data.map(function (item) {
					return Number(item[column.property]);
				});
				if (!values.every(function (value) {
					return isNaN(value);
				})) {
					sums[index] = values.reduce(function (prev, curr) {
						var value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);
					sums[index] = '￥' + sums[index].toFixed(2);
				} else {
					sums[index] = '-';
				}
			});

			return sums;
		},
		search: function search() {
			this.getList();
		},
		getList: function getList() {
			var _this = this;

			var p = "";
			this.pdata.sdate = this.d_date[0];
			this.pdata.edate = this.d_date[1];
			for (var k in this.pdata) {
				if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
			}
			(0, _api.getbillCpDataSummary)(p, this.$cookie.getCookie("login")).then(function (res) {
				if (res.code == 200) {
					if (res.data.list && res.data.list.length > 0) {
						_this.plist = res.data.list;
						_this.maxPage = res.data.max_page;
						_this.total = {
							total_cost: 0
						};
						_this.plist.forEach(function (v, i) {
							_this.total.total_cost += v.total_cost - 0;
						});
						_this.total.total_cost = _this.total.total_cost.toFixed(2);
					} else {
						_this.plist = [];
						_this.maxPage = 1;
					}
				}
			});
		},
		getBillList: function getBillList(status, company_id, id) {
			this.billDialog = true;
			this.billList = this.plist;
		},
		getConfig: function getConfig() {
			var _this2 = this;

			if (this.$store.config) {
				this.config = this.$store.config.product_theme;
				this.tags = this.$store.config.product_tag;
				this.option = this.$store.config.product_placement;
			} else {
				setTimeout(function () {
					_this2.getConfig();
				}, 50);
			}
		}
	}, (0, _defineProperty3.default)(_methods, "search", function search() {
		this.getList();
	}), (0, _defineProperty3.default)(_methods, "base64", function base64(s) {
		return window.btoa(unescape(encodeURIComponent(s)));
	}), (0, _defineProperty3.default)(_methods, "format", function format(s, c) {
		return s.replace(/{(\w+)}/g, function (m, p) {
			return c[p];
		});
	}), (0, _defineProperty3.default)(_methods, "tableToExcel", function tableToExcel() {
		var uri = 'data:application/vnd.ms-excel;base64,';
		var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"' + 'xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>' + '<x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets>' + '</x:ExcelWorkbook></xml><![endif]-->' + ' <style type="text/css">' + 'table td {' + 'width: auto;' + 'height: 30px;' + ' text-align: center;' + 'background-color: #ffffff;' + 'color: #000000;' + ' }' + 'table th {' + 'width: auto;' + 'height: 30px;' + ' text-align: center;' + 'background-color: #ffffff;' + 'color: #000000;' + ' }' + '</style>' + '</head><body ><table class="excelTable" border="1" cellspacing="1" cellpadding="1">{table}</table></body></html>';
		var tableid = document.getElementById('ta');

		var ctx = {
			worksheet: this.company.name + "结算对账单" || 'Worksheet',
			table: tableid.innerHTML
		};
		console.log(uri + this.base64(this.format(template, ctx)));

		this.base64ToFile(uri + this.base64(this.format(template, ctx)));
	}), (0, _defineProperty3.default)(_methods, "base64ToFile", function base64ToFile(base) {
		var arr = base.split(',');
		var mime = arr[0].match(/:(.*?);/)[1];
		var bstr = atob(arr[1]);
		var n = bstr.length;
		var u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		if (window.navigator.msSaveBlob) {
			try {
				var blobObject = new Blob([u8arr], {
					type: mime
				});
				window.navigator.msSaveBlob(blobObject, this.company.name + '.xls');
			} catch (e) {
				console.log(e);
			}
		} else {
			var url = window.URL.createObjectURL(new Blob([u8arr], {
				type: mime
			}));
			var link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', this.company.name + '.xls');
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
		}
	}), (0, _defineProperty3.default)(_methods, "getCPCompany", function getCPCompany() {
		var _this3 = this;

		(0, _api.getCPCompanyList)('', this.$cookie.getCookie("login")).then(function (res) {
			if (res.code == 200) {
				if (res.data && res.data.list.length > 0) {
					_this3.companyList = res.data.list;
				}
			}
		});
	}), _methods),
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['groupid'])),
	created: function created() {

		console.log((0, _jquery2.default)(window).height() - 200);
		this.height = (0, _jquery2.default)(window).height() - 400;
	},
	mounted: function mounted() {
		this.getList();
		this.getCPCompany();
		this.getConfig();
		this.prWidth = document.getElementById("section").offsetWidth;
	}
};

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(71);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(54);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(185);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(184);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _methods;

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

var _vuedraggable = __webpack_require__(116);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'productDaily',
	components: {
		draggable: _vuedraggable2.default
	},
	data: function data() {
		return {
			isloading: false,
			height: 1500,
			chartColumn: null,
			pholder: "",
			pdata: {
				page: '1',
				perpage: '999',
				issued_app_id: "",
				kw: "",
				platform_id: 1,
				sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
				edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
			},
			tText: "请选择创意类型",
			plist: [],
			maxPage: 1,
			config: [],
			editDialog: false,
			checkDialog: false,
			issued_app_source: [],
			get_issued_app_platform: [],
			checklist: [{
				"name": "发行名称",
				"value": "issued_app_name"
			}, {
				"name": "活跃用户",
				"value": "visit_uv"
			}, {
				"name": "注册用户",
				"value": "visit_uv_new"
			}, {
				"name": "分享率",
				"value": "share_per"
			}, {
				"name": "裂变率",
				"value": "fission_rate"
			}, {
				"name": "banner点击率",
				"value": "banner_click_per"
			}, {
				"name": "流量主",
				"value": "origin_income"
			}, {
				"name": "流量主arpu",
				"value": "origin_day_contribution"
			}, {
				"name": "跳出率",
				"value": "jump_per"
			}, {
				"name": "渠道卖量",
				"value": "channel_sell_income"
			}, {
				"name": "矩阵卖量",
				"value": "matrix_sell_income"
			}, {
				"name": "分发arpu",
				"value": "distribution_day_contribution"
			}, {
				"name": "总arpu",
				"value": "total_day_contribution"
			}, {
				"name": "广点通",
				"value": "gdt_buy_cost"
			}, {
				"name": "渠道买量",
				"value": "channel_buy_cost"
			}, {
				"name": "收入（含矩阵）",
				"value": "total_income_contain_matrix"
			}, {
				"name": "利润",
				"value": "total_profit_contain_matrix"
			}, {
				"name": "CP分成",
				"value": "total_profit_contain_matrix_cp"
			}],
			checks: [],
			isIndeterminate: false,
			checkAll: false,
			group: {},

			dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
			pickerOptions: {
				shortcuts: [{
					text: "昨天",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24);
						picker.$emit("pick", [start, start]);
					}
				}, {
					text: "最近一周",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
						picker.$emit("pick", [start, end]);
					}
				}, {
					text: "最近一个月",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit("pick", [start, end]);
					}
				}, {
					text: "最近三个月",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit("pick", [start, end]);
					}
				}]
			},
			list: [],
			drawer: false,

			fieldList: {
				'用户数据': [{
					"name": "活跃用户",
					"key": "visit_uv",
					"isCheck": false
				}, {
					"name": "访问次数",
					"key": "visit_pv",
					"isCheck": false
				}, {
					"name": "注册用户",
					"key": "visit_uv_new",
					"isCheck": false
				}, {
					"name": "累计注册用户",
					"key": "visit_total",
					"isCheck": false
				}, {
					"name": "新增用户占比",
					"key": "visit_uv_new_per",
					"isCheck": false
				}, {
					"name": "人均访问次数",
					"key": "visit_uv_cnt",
					"isCheck": false
				}, {
					"name": "人均停留时长",
					"key": "stay_time_uv",
					"isCheck": false
				}, {
					"name": "次均停留时长",
					"key": "stay_time_avg",
					"isCheck": false
				}],
				'分享数据': [{
					"name": "分享次数",
					"key": "share_pv",
					"isCheck": false
				}, {
					"name": "分享用户数",
					"key": "share_uv",
					"isCheck": false
				}, {
					"name": "分享率",
					"key": "share_per",
					"isCheck": false
				}, {
					"name": "会话新增",
					"key": "session_new",
					"isCheck": false
				}, {
					"name": "裂变率",
					"key": "fission_rate",
					"isCheck": false
				}, {
					"name": "分享用户人均分享次数",
					"key": "share_uv_cnt",
					"isCheck": false
				}, {
					"name": "日活人均分享次数",
					"key": "share_visit_uv_cnt",
					"isCheck": false
				}],
				'流量主数据': [{
					"name": "banner人均曝光次数",
					"key": "banner_show_cnt",
					"isCheck": false
				}, {
					"name": "banner点击率",
					"key": "banner_click_per",
					"isCheck": false
				}, {
					"name": "视频人均曝光次数",
					"key": "video_show_cnt",
					"isCheck": false
				}, {
					"name": "视频点击率",
					"key": "video_click_per",
					"isCheck": false
				}, {
					"name": "千次曝光收入",
					"key": "ecpm",
					"isCheck": false
				}, {
					"name": "流量主arpu",
					"key": "origin_day_contribution",
					"isCheck": false
				}, {
					"name": "发行分成流量主收入",
					"key": "origin_divide_income",
					"isCheck": false
				}, {
					"name": "分成后单日活贡献",
					"key": "origin_divide_day_contribution",
					"isCheck": false
				}],
				'分发数据': [{
					"name": "跳出率",
					"key": "jump_per",
					"isCheck": false
				}, {
					"name": "换入活跃",
					"key": "huanliang_in",
					"isCheck": false
				}, {
					"name": "换出活跃",
					"key": "huanliang_out",
					"isCheck": false
				}, {
					"name": "分发收入（含矩阵）",
					"key": "distribution_income",
					"isCheck": false
				}, {
					"name": "arpu（含矩阵）",
					"key": "distribution_day_contribution",
					"isCheck": false
				}, {
					"name": "分发收入（不含矩阵）",
					"key": "nonmatrix_income",
					"isCheck": false
				}, {
					"name": "arpu（不含矩阵）",
					"key": "nonmatrix_day_contribution",
					"isCheck": false
				}, {
					"name": "总arpu",
					"key": "total_day_contribution",
					"isCheck": false
				}],
				'收支数据': [{
					"name": "LTV",
					"key": "ltv",
					"isCheck": false
				}, {
					"name": "流量主",
					"key": "origin_income",
					"isCheck": false
				}, {
					"name": "渠道卖量",
					"key": "channel_sell_income",
					"isCheck": false
				}, {
					"name": "矩阵卖量",
					"key": "matrix_sell_income",
					"isCheck": false
				}, {
					"name": "渠道买量",
					"key": "channel_buy_cost",
					"isCheck": false
				}, {
					"name": "矩阵买量",
					"key": "matrix_buy_cost",
					"isCheck": false
				}, {
					"name": "广点通",
					"key": "gdt_buy_cost",
					"isCheck": false
				}, {
					"name": "CP分成",
					"key": "total_profit_contain_matrix_cp",
					"isCheck": false
				}, {
					"name": "收入(含矩阵)",
					"key": "total_income_contain_matrix",
					"isCheck": false
				}, {
					"name": "成本(含矩阵)",
					"key": "total_cost_contain_matrix",
					"isCheck": false
				}, {
					"name": "利润(含矩阵)",
					"key": "total_profit_contain_matrix",
					"isCheck": false
				}, {
					"name": "收入(不含矩阵)",
					"key": "total_income_no_matrix",
					"isCheck": false
				}, {
					"name": "成本(不含矩阵)",
					"key": "total_cost_no_matrix",
					"isCheck": false
				}, {
					"name": "利润(不含矩阵)",
					"key": "total_profit_no_matrix",
					"isCheck": false
				}]
			},
			selectFieldList: [],
			selectFieldListForModel: {
				'用户数据': [],
				'分享数据': [],
				'流量主数据': [],
				'分发数据': [],
				'收支数据': []
			},
			showFieldList: [],
			FieldIndex: 0
		};
	},

	watch: {
		dateVal: {
			handler: function handler(n, o) {
				if (n[0]) {
					this.pdata.sdate = n[0];
					this.pdata.edate = n[1];
					this.getList();
				}
			},

			deep: true
		}
	},
	methods: (_methods = {
		changePlatform: function changePlatform() {
			this.$cookie.setCookie("platform_id", this.pdata.platform_id);
			this.getField();
		},
		fieldListChange: function fieldListChange(tab, event) {
			var _this = this;
			console.log(tab.name);
			this.FieldIndex = tab.name;
			this.setFieldList();
		},
		setFieldList: function setFieldList() {
			var _this = this;
			for (var key in _this.fieldList) {
				_this.fieldList[key].forEach(function (v, i) {
					v.isCheck = false;
				});
			}
			if (this.FieldIndex == 0) {
				this.selectFieldList.forEach(function (vv, ii) {
					for (var key in _this.fieldList) {
						_this.fieldList[key].forEach(function (v, i) {
							if (vv.key == v.key) {
								v.isCheck = true;
							}
						});
					}
				});
				this.showFieldList = JSON.parse((0, _stringify2.default)(this.selectFieldList));
			} else if (this.FieldIndex == 1) {
				for (var key in this.selectFieldListForModel) {

					this.selectFieldListForModel[key].forEach(function (vv, ii) {
						_this.fieldList[key].forEach(function (v, i) {

							if (vv.key == v.key) {

								v.isCheck = true;
							}
						});
					});
				}
				var tempArr = [];
				for (var key in this.selectFieldListForModel) {
					this.selectFieldListForModel[key].forEach(function (v, i) {
						tempArr.push(v);
					});
				}
				this.showFieldList = JSON.parse((0, _stringify2.default)(tempArr));
			}
			this.getList();
		},
		getSelectField: function getSelectField() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var _this, p, data;

				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this = _this2;
								p = "position=product_daily_index";
								_context.next = 4;
								return (0, _api.getValidProductPlatform)(p, _this2.$cookie.getCookie("login"));

							case 4:
								data = _context.sent;

								if (data.code == 200) {
									if (!_this2.$cookie.getCookie("platform_id")) {
										_this2.pdata.platform_id = data.data[0].platform_id;
									}

									_this2.get_issued_app_platform = data.data;
								}

								_this2.getField();

							case 7:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		},
		getField: function getField() {
			var _this3 = this;

			console.log(this.pdata.platform_id);
			var _this = this;
			var p = "position=product_daily_index";
			(0, _api.getfieldFilter)(p, this.$cookie.getCookie("login")).then(function (res) {

				_this3.FieldIndex = res.data.content.FieldIndex;

				console.log(res.data.content);
				if (res.data.content.FieldList == null || res.data.content.FieldList.length == 0) {
					if (_this3.pdata.platform_id == 1) {
						res.data.content.FieldList = ['visit_uv', 'visit_uv_new', 'retain_day1', 'banner_click_per', 'origin_day_contribution', 'jump_per', 'ltv'];
					} else if (_this3.pdata.platform_id == 2) {
						res.data.content.FieldList = ['visit_uv_totle', 'visit_uv', 'visit_uv_new', 'retain_day1', 'origin_day_contribution', 'stay_time_uv', 'visit_uv_cnt', 'click_screen_record_rate', 'ltv'];
					} else {
						res.data.content.FieldList = ['visit_uv_totle', 'visit_uv', 'visit_uv_new', 'retain_day1', 'origin_day_contribution', 'stay_time_uv', 'visit_uv_cnt', 'ltv'];
					}
				}

				_this.selectFieldList = [];
				_this.selectFieldListForModel = {
					'用户数据': [],
					'分享数据': [],
					'流量主数据': [],
					'分发数据': [],
					'收支数据': []
				};
				_this.showFieldList = [];
				_this.list = [];


				res.data.content.FieldList.forEach(function (vv, ii) {
					for (var key in _this.fieldList) {
						_this.fieldList[key].forEach(function (v, i) {
							if (vv == v.key) {
								v.isCheck = true;
								_this.selectFieldList.push(v);
							}
						});
					}
				});
				for (var key in res.data.content.FieldListForModel) {
					res.data.content.FieldListForModel[key].forEach(function (vv, ii) {
						_this.fieldList[key].forEach(function (v, i) {

							if (vv == v.key) {
								v.isCheck = true;
								_this.selectFieldListForModel[key].push(v);
							}
						});
					});
				}

				if (_this3.FieldIndex == 0) {
					_this3.showFieldList = JSON.parse((0, _stringify2.default)(_this3.selectFieldList));
				} else if (_this3.FieldIndex == 1) {
					var tempArr = [];
					for (var key in _this3.selectFieldListForModel) {

						_this3.selectFieldListForModel[key].forEach(function (v, i) {
							tempArr.push(v);
						});
					}
					_this3.showFieldList = JSON.parse((0, _stringify2.default)(tempArr));
				}
				_this3.getList();
			});
		},
		saveSelectField: function saveSelectField() {
			var _this4 = this;

			var tempArr = [];
			var tempArrModel = {
				'用户数据': [],
				'分享数据': [],
				'流量主数据': [],
				'分发数据': [],
				'收支数据': []
			};
			this.selectFieldList.forEach(function (v, i) {
				tempArr.push(v.key);
			});

			for (var key in this.selectFieldListForModel) {

				this.selectFieldListForModel[key].forEach(function (v, i) {
					tempArrModel[key].push(v.key);
				});
			}
			var content = {
				FieldIndex: this.FieldIndex,
				FieldList: tempArr,
				FieldListForModel: tempArrModel
			};

			var p = {
				position: 'product_daily_index',
				content: content
			};
			(0, _api.postfieldFilter)(p, this.$cookie.getCookie("login")).then(function (res) {
				_this4.drawer = false;
				_this4.showFieldList = JSON.parse((0, _stringify2.default)(_this4.selectFieldList));
				_this4.getField();
			});
		},
		removeSelectField: function removeSelectField(obj) {
			var _this5 = this;

			this.removeArrForObjName(this.selectFieldList, obj);

			var _loop = function _loop(key) {
				_this5.fieldList[key].some(function (item, index) {
					if (item.name == obj.name) {

						_this5.fieldList[key][index].isCheck = false;
					}
				});
			};

			for (var key in this.fieldList) {
				_loop(key);
			}
		},
		removeSelectFieldForModel: function removeSelectFieldForModel(obj, key) {
			var _this6 = this;

			var _this = this;
			this.removeArrForArrObjName(this.selectFieldListForModel, obj, key);

			this.fieldList[key].some(function (item, index) {
				if (item.name == obj.name) {

					_this6.fieldList[key][index].isCheck = false;
				}
			});
		},
		onMove: function onMove(_ref) {
			var relatedContext = _ref.relatedContext,
			    draggedContext = _ref.draggedContext;

			var relatedElement = relatedContext.item;
			var draggedElement = draggedContext.item;
		},
		fieldConfig: function fieldConfig() {
			this.drawer = true;
			this.setFieldList();
		},
		fliedTap: function fliedTap(key, index) {
			var _this7 = this;

			this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
			var result = this.selectFieldList.some(function (item) {
				if (item.name == _this7.fieldList[key][index].name) {
					return true;
				}
			});
			if (this.fieldList[key][index].isCheck) {
				if (!result) {
					this.selectFieldList.push(this.fieldList[key][index]);
				}
			} else {
				if (result) {
					this.removeArrForObjName(this.selectFieldList, this.fieldList[key][index]);
				}
			}
		},
		fliedTapForModel: function fliedTapForModel(key, index) {
			var _this8 = this;

			this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
			var result;
			for (var key2 in this.selectFieldListForModel) {
				result = this.selectFieldListForModel[key2].some(function (item) {
					if (item.name == _this8.fieldList[key][index].name) {

						return true;
					}
				});
				if (result) {
					break;
				}
			}

			if (this.fieldList[key][index].isCheck) {
				if (!result) {
					this.selectFieldListForModel[key].push(this.fieldList[key][index]);
				}
			} else {
				if (result) {

					this.removeArrForArrObjName(this.selectFieldListForModel, this.fieldList[key][index], key);
				}
			}
		},
		removeArrForObjName: function removeArrForObjName(_arr, _obj) {
			var length = _arr.length;
			for (var i = 0; i < length; i++) {
				if (_arr[i].name == _obj.name) {
					_arr.splice(i, 1);
					return _arr;
				}
			}
		},
		removeArrForArrObjName: function removeArrForArrObjName(obj, _obj, key) {
			console.log(obj);
			var length = obj[key].length;
			for (var i = 0; i < length; i++) {
				if (obj[key][i].name == _obj.name) {
					obj[key].splice(i, 1);
					console.log(obj);
					return obj;
				}
			}
		},
		handleCheckAllChange: function handleCheckAllChange(val) {
			this.checks = val ? this.checklist : [];
			this.isIndeterminate = false;
		},
		handleCheckedChange: function handleCheckedChange(value) {

			var checkedCount = value.length;
			this.checkAll = checkedCount === this.checklist.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.checklist.length;
			this.checks = value;
		},
		exportIncome: function exportIncome() {
			if (this.loading == true) {
				this.$message({
					message: "暂时无法导出，请稍后！",
					type: "warning"
				});
				return false;
			} else {
				this.checkDialog = true;
			}
		},
		handleDownload: function handleDownload() {
			var _this9 = this;

			var that = this;
			var arr = [];
			var arrHd = this.checks.map(function (v, i) {
				return v.name;
			});
			var arrFval = this.checks.map(function (v, i) {
				return v.value;
			});


			if (that.List == "") {
				return false;
			}

			console.log(arrHd);
			console.log(arrFval);
			__webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
				var _require = __webpack_require__(118),
				    export_json_to_excel = _require.export_json_to_excel,
				    export_table_to_excel = _require.export_table_to_excel;

				var tHeader = arrHd;
				var filterVal = arrFval;
				var list = _this9.list;

				var data = _this9.formatJson(filterVal, list);

				export_json_to_excel(tHeader, data, _this9.pdata.sdate + '~' + _this9.pdata.edate + "产品日报");
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		},
		formatJson: function formatJson(filterVal, jsonData) {
			return jsonData.map(function (v) {
				return filterVal.map(function (j) {
					return v[j];
				});
			});
		},
		changeDate: function changeDate(s) {
			this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10)];
		},
		getSummaries: function getSummaries(param) {
			var columnIdx = ['distribution_income', 'nonmatrix_income', 'nonmatrix_day_contribution', 'origin_income', 'channel_sell_income', 'matrix_sell_income', 'channel_buy_cost', 'matrix_buy_cost', 'gdt_buy_cost', 'total_profit_contain_matrix_cp', 'total_income_contain_matrix', 'total_cost_contain_matrix', 'total_profit_contain_matrix', 'total_income_no_matrix', 'total_cost_no_matrix', 'total_profit_no_matrix'];
			var columns = param.columns,
			    data = param.data;

			var sums = [];
			columns.forEach(function (column, index) {

				if (columnIdx.indexOf(column.property) == -1) {
					sums[index] = '-';
					return;
				}

				var values = data.map(function (item) {
					return Number(item[column.property]);
				});
				if (!values.every(function (value) {
					return isNaN(value);
				})) {
					sums[index] = values.reduce(function (prev, curr) {
						var value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);
					sums[index] = sums[index].toFixed(2) + ' 元';
				} else {
					sums[index] = 'N/A';
				}
			});

			return sums;
		},
		getConfig: function getConfig() {
			var _this10 = this;

			if (this.$store.config) {

				this.issued_app_source = this.$store.config.issued_app_source;
			} else {
				setTimeout(function () {
					_this10.getConfig();
				}, 50);
			}
		},
		getList: function getList() {
			var _this11 = this;

			this.isloading = true;
			var p = "";
			for (var k in this.pdata) {
				if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
			}
			(0, _api.getProductDaily)(p, this.$cookie.getCookie("login")).then(function (res) {
				_this11.isloading = false;
				if (res.code == 200) {
					if (res.data.list && res.data.list.length > 0) {

						_this11.list = res.data.list;
						_this11.list2 = _this11.arrSort(JSON.parse((0, _stringify2.default)(res.data.list)), 'total_day_contribution');

						_this11.list2 = _this11.list2.slice(0, 10);
						console.log(_this11.list2);
						_this11.list2.forEach(function (v, i) {
							for (var j = 0; j < _this11.list.length; j++) {
								if (_this11.list[j].issued_app_id == v.issued_app_id) {
									_this11.list[j].isTop10 = true;
									break;
								}
							}
						});
						_this11.maxPage = parseInt(res.data.count / _this11.pdata.perpage) + 1;
					} else {
						_this11.list = [];
						_this11.maxPage = 1;
					}
				}
			});
		},
		arrSort: function arrSort(arr, str) {
			return arr.sort(function (a, b) {
				return b[str] - a[str];
			});
		},
		SizeChange: function SizeChange(v) {
			this.pdata.perpage = v;
			this.getList();
		},
		CurrentChange: function CurrentChange(v) {
			this.pdata.page = v;
			this.getList();
		}
	}, (0, _defineProperty3.default)(_methods, "changeDate", function changeDate(s) {
		this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
	}), (0, _defineProperty3.default)(_methods, "changeId", function changeId(res) {
		this.pdata.issued_app_id = res;
		this.getList();
	}), _methods),

	created: function created() {

		this.height = window.innerHeight;
	},
	mounted: function mounted() {
		var _this = this;
		(0, _jquery2.default)(".content-container").scroll(function () {
			console.log((0, _jquery2.default)(".content-container").scrollTop());
			if ((0, _jquery2.default)(".content-container").scrollTop() > 150) {

				_this.height = window.innerHeight - 154;
			}
		});

		if ((0, _keys2.default)(this.$route.params).length > 0) {
			this.pdata.sdate = this.$route.params.sdate;
			this.pdata.edate = this.$route.params.edate;
			this.pdata.app_id = this.$route.params.app_id;
			this.pholder = this.$route.params.name;
		}
		if (this.$cookie.getCookie("platform_id")) {
			this.pdata.platform_id = parseInt(this.$cookie.getCookie("platform_id"));
		}

		this.getConfig();
		this.getSelectField();
		console.log(this.$options);
	}
};

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(71);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(54);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(185);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(184);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _methods;

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

var _vuedraggable = __webpack_require__(116);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		draggable: _vuedraggable2.default
	},
	data: function data() {
		return {
			height: 1500,
			chartColumn: null,
			pholder: "",
			pdata: {
				page: 1,
				perpage: 20,
				issued_app_id: "",
				platform_id: "",
				kw: "",
				sdate: new Date(new Date().getTime() - 3600 * 1000 * 90 * 24).toISOString().slice(0, 10),
				edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
			},
			activeType: '0',
			tText: "请选择创意类型",
			get_issued_app_platform: [],
			plist: [],
			maxPage: 1,
			config: [],
			editDialog: false,
			checkDialog: false,
			checklist0: [{
				"name": "日期",
				"value": "d_date"
			}, {
				"name": "活跃用户",
				"value": "visit_uv"
			}, {
				"name": "访问次数",
				"value": "visit_pv"
			}, {
				"name": "注册用户",
				"value": "visit_uv_new"
			}, {
				"name": "累计注册用户",
				"value": "visit_total"
			}, {
				"name": "新增用户占比",
				"value": "visit_uv_new_per"
			}, {
				"name": "人均访问次数",
				"value": "visit_uv_cnt"
			}, {
				"name": "人均停留时长",
				"value": "stay_time_uv"
			}, {
				"name": "次均停留时长",
				"value": "stay_time_avg"
			}, {
				"name": "新增其他小程序",
				"value": "other_miniprogram"
			}, {
				"name": "次日留存",
				"value": "retain_day1"
			}, {
				"name": "3日留存",
				"value": "retain_day3"
			}, {
				"name": "7日留存",
				"value": "retain_day7"
			}, {
				"name": "分享次数",
				"value": "share_pv"
			}, {
				"name": "分享用户数",
				"value": "share_uv"
			}, {
				"name": "分享率",
				"value": "share_per"
			}, {
				"name": "会话新增",
				"value": "session_new"
			}, {
				"name": "裂变率",
				"value": "fission_rate"
			}, {
				"name": "分享用户人均分享次数",
				"value": "share_uv_cnt"
			}, {
				"name": "日活用户人均分享次数",
				"value": "share_visit_uv_cnt"
			}, {
				"name": "banner人均曝光次数",
				"value": "banner_show_cnt"
			}, {
				"name": "banner点击率",
				"value": "banner_click_per"
			}, {
				"name": "视频人均曝光次数",
				"value": "video_show_cnt"
			}, {
				"name": "视频点击率",
				"value": "video_click_per"
			}, {
				"name": "千次曝光收入",
				"value": "ecpm"
			}, {
				"name": "流量主收入",
				"value": "origin_income"
			}, {
				"name": "流量主单日活贡献",
				"value": "origin_day_contribution"
			}, {
				"name": "发行分成流量主收入",
				"value": "origin_divide_income"
			}, {
				"name": "分成后单日活贡献",
				"value": "origin_divide_day_contribution"
			}, {
				"name": "跳出率",
				"value": "jump_per"
			}, {
				"name": "换入活跃",
				"value": "huanliang_in"
			}, {
				"name": "换出日跃",
				"value": "huanliang_out"
			}, {
				"name": "分发收入（含矩阵）",
				"value": "distribution_income"
			}, {
				"name": "arpu（含矩阵）",
				"value": "distribution_day_contribution"
			}, {
				"name": "分发收入（不含矩阵）",
				"value": "nonmatrix_income"
			}, {
				"name": "arpu（不含矩阵）",
				"value": "nonmatrix_day_contribution"
			}, {
				"name": "流量主",
				"value": "origin_income"
			}, {
				"name": "渠道卖量",
				"value": "channel_sell_income"
			}, {
				"name": "矩阵卖量",
				"value": "matrix_sell_income"
			}, {
				"name": "渠道买量",
				"value": "channel_buy_cost"
			}, {
				"name": "广点通",
				"value": "gdt_buy_cost"
			}, {
				"name": "矩阵买量",
				"value": "matrix_buy_cost"
			}, {
				"name": "收入（含矩阵）",
				"value": "total_income_contain_matrix"
			}, {
				"name": "成本（含矩阵）",
				"value": "total_cost_contain_matrix"
			}, {
				"name": "利润（含矩阵）",
				"value": "total_profit_contain_matrix"
			}, {
				"name": "收入（不含矩阵）",
				"value": "total_income_no_matrix"
			}, {
				"name": "成本（不含矩阵）",
				"value": "total_cost_no_matrix"
			}, {
				"name": "利润（不含矩阵）",
				"value": "total_profit_no_matrix"
			}],
			checks: [],
			isIndeterminate: false,
			checkAll: false,

			group: {},

			dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 90 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
			pickerOptions: {
				shortcuts: [{
					text: "昨天",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24);
						picker.$emit("pick", [start, start]);
					}
				}, {
					text: "最近一周",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
						picker.$emit("pick", [start, end]);
					}
				}, {
					text: "最近一个月",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit("pick", [start, end]);
					}
				}, {
					text: "最近三个月",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit("pick", [start, end]);
					}
				}]
			},
			list: [],

			drawer: false,
			fieldList: {
				'用户数据': [{
					"name": "活跃用户",
					"key": "visit_uv",
					"isCheck": false
				}, {
					"name": "访问次数",
					"key": "visit_pv",
					"isCheck": false
				}, {
					"name": "注册用户",
					"key": "visit_uv_new",
					"isCheck": false
				}, {
					"name": "累计注册用户",
					"key": "visit_total",
					"isCheck": false
				}, {
					"name": "新增用户占比",
					"key": "visit_uv_new_per",
					"isCheck": false
				}, {
					"name": "人均访问次数",
					"key": "visit_uv_cnt",
					"isCheck": false
				}, {
					"name": "人均停留时长",
					"key": "stay_time_uv",
					"isCheck": false
				}, {
					"name": "次均停留时长",
					"key": "stay_time_avg",
					"isCheck": false
				}, {
					"name": "次日留存",
					"key": "retain_day1",
					"isCheck": false
				}, {
					"name": "3日留存",
					"key": "retain_day3",
					"isCheck": false
				}, {
					"name": "7日留存",
					"key": "retain_day7",
					"isCheck": false
				}],
				'分享数据': [{
					"name": "分享次数",
					"key": "share_pv",
					"isCheck": false
				}, {
					"name": "分享用户数",
					"key": "share_uv",
					"isCheck": false
				}, {
					"name": "分享率",
					"key": "share_per",
					"isCheck": false
				}, {
					"name": "会话新增",
					"key": "session_new",
					"isCheck": false
				}, {
					"name": "裂变率",
					"key": "fission_rate",
					"isCheck": false
				}, {
					"name": "分享用户人均分享次数",
					"key": "share_uv_cnt",
					"isCheck": false
				}, {
					"name": "日活人均分享次数",
					"key": "share_visit_uv_cnt",
					"isCheck": false
				}],
				'流量主数据': [{
					"name": "banner人均曝光次数",
					"key": "banner_show_cnt",
					"isCheck": false
				}, {
					"name": "banner点击率",
					"key": "banner_click_per",
					"isCheck": false
				}, {
					"name": "视频人均曝光次数",
					"key": "video_show_cnt",
					"isCheck": false
				}, {
					"name": "视频点击率",
					"key": "video_click_per",
					"isCheck": false
				}, {
					"name": "千次曝光收入",
					"key": "ecpm",
					"isCheck": false
				}, {
					"name": "流量主arpu",
					"key": "origin_day_contribution",
					"isCheck": false
				}, {
					"name": "发行分成流量主收入",
					"key": "origin_divide_income",
					"isCheck": false
				}, {
					"name": "分成后单日活贡献",
					"key": "origin_divide_day_contribution",
					"isCheck": false
				}],
				'分发数据': [{
					"name": "跳出率",
					"key": "jump_per",
					"isCheck": false
				}, {
					"name": "换入活跃",
					"key": "huanliang_in",
					"isCheck": false
				}, {
					"name": "换出活跃",
					"key": "huanliang_out",
					"isCheck": false
				}, {
					"name": "分发收入（含矩阵）",
					"key": "distribution_income",
					"isCheck": false
				}, {
					"name": "arpu（含矩阵）",
					"key": "distribution_day_contribution",
					"isCheck": false
				}, {
					"name": "分发收入（不含矩阵）",
					"key": "nonmatrix_income",
					"isCheck": false
				}, {
					"name": "arpu（不含矩阵）",
					"key": "nonmatrix_day_contribution",
					"isCheck": false
				}, {
					"name": "总arpu",
					"key": "total_day_contribution",
					"isCheck": false
				}],
				'收支数据': [{
					"name": "流量主",
					"key": "origin_income",
					"isCheck": false
				}, {
					"name": "渠道卖量",
					"key": "channel_sell_income",
					"isCheck": false
				}, {
					"name": "矩阵卖量",
					"key": "matrix_sell_income",
					"isCheck": false
				}, {
					"name": "渠道买量",
					"key": "channel_buy_cost",
					"isCheck": false
				}, {
					"name": "矩阵买量",
					"key": "matrix_buy_cost",
					"isCheck": false
				}, {
					"name": "广点通",
					"key": "gdt_buy_cost",
					"isCheck": false
				}, {
					"name": "CP分成",
					"key": "total_profit_contain_matrix_cp",
					"isCheck": false
				}, {
					"name": "收入(含矩阵)",
					"key": "total_income_contain_matrix",
					"isCheck": false
				}, {
					"name": "成本(含矩阵)",
					"key": "total_cost_contain_matrix",
					"isCheck": false
				}, {
					"name": "利润(含矩阵)",
					"key": "total_profit_contain_matrix",
					"isCheck": false
				}, {
					"name": "收入(不含矩阵)",
					"key": "total_income_no_matrix",
					"isCheck": false
				}, {
					"name": "成本(不含矩阵)",
					"key": "total_cost_no_matrix",
					"isCheck": false
				}, {
					"name": "利润(不含矩阵)",
					"key": "total_profit_no_matrix",
					"isCheck": false
				}]
			},
			selectFieldList: [],
			selectFieldListForModel: {
				'用户数据': [],
				'分享数据': [],
				'流量主数据': [],
				'分发数据': [],
				'收支数据': []
			},
			showFieldList: [],
			FieldIndex: 0
		};
	},

	watch: {
		dateVal: {
			handler: function handler(n, o) {
				if (n[0]) {
					this.pdata.sdate = n[0];
					this.pdata.edate = n[1];
					this.getList();
				}
			},

			deep: true
		},
		pdata: {
			handler: function handler(n, o) {
				if (n[0]) {
					this.getList();
				}
			},

			deep: true
		}
	},
	methods: (_methods = {
		changePlatform: function changePlatform() {
			this.$cookie.setCookie("platform_id", this.pdata.platform_id);

			this.getField();
		},
		fieldListChange: function fieldListChange(tab, event) {
			var _this = this;
			console.log(tab.name);
			this.FieldIndex = tab.name;
			this.setFieldList();
		},
		setFieldList: function setFieldList() {
			var _this = this;
			for (var key in _this.fieldList) {
				_this.fieldList[key].forEach(function (v, i) {
					v.isCheck = false;
				});
			}
			if (this.FieldIndex == 0) {
				this.selectFieldList.forEach(function (vv, ii) {
					for (var key in _this.fieldList) {
						_this.fieldList[key].forEach(function (v, i) {
							if (vv.key == v.key) {
								v.isCheck = true;
							}
						});
					}
				});
				this.showFieldList = JSON.parse((0, _stringify2.default)(this.selectFieldList));
			} else if (this.FieldIndex == 1) {
				for (var key in this.selectFieldListForModel) {

					this.selectFieldListForModel[key].forEach(function (vv, ii) {
						_this.fieldList[key].forEach(function (v, i) {

							if (vv.key == v.key) {

								v.isCheck = true;
							}
						});
					});
				}
				var tempArr = [];
				for (var key in this.selectFieldListForModel) {
					this.selectFieldListForModel[key].forEach(function (v, i) {
						tempArr.push(v);
					});
				}
				this.showFieldList = JSON.parse((0, _stringify2.default)(tempArr));
			}
			this.getList();
		},
		getSelectField: function getSelectField() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var _this, p;

				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this = _this2;
								p = "position=product_daily_detail";


								(0, _api.getfieldFilter)(p, _this2.$cookie.getCookie("login")).then(function (res) {
									console.log(res.data.content);
									_this2.FieldIndex = res.data.content.FieldIndex;
									if (res.data.content.FieldList == null || res.data.content.FieldList.length == 0) {
										res.data.content.FieldList = ['issued_app_name', 'visit_uv', 'visit_uv_new', 'retain_day1', 'banner_click_per', 'origin_day_contribution', 'jump_per', 'distribution_day_contribution'];
									}
									_this.selectFieldList = [];
									_this.selectFieldListForModel = {
										'用户数据': [],
										'分享数据': [],
										'流量主数据': [],
										'分发数据': [],
										'收支数据': []
									};
									_this.showFieldList = [];
									_this.list = [];

									res.data.content.FieldList.forEach(function (vv, ii) {
										for (var key in _this.fieldList) {
											_this.fieldList[key].forEach(function (v, i) {
												if (vv == v.key) {
													v.isCheck = true;
													_this.selectFieldList.push(v);
												}
											});
										}
									});
									for (var key in res.data.content.FieldListForModel) {
										res.data.content.FieldListForModel[key].forEach(function (vv, ii) {
											_this.fieldList[key].forEach(function (v, i) {

												if (vv == v.key) {
													v.isCheck = true;
													_this.selectFieldListForModel[key].push(v);
												}
											});
										});
									}

									if (_this2.FieldIndex == 0) {
										_this2.showFieldList = JSON.parse((0, _stringify2.default)(_this2.selectFieldList));
									} else if (_this2.FieldIndex == 1) {
										var tempArr = [];
										for (var key in _this2.selectFieldListForModel) {

											_this2.selectFieldListForModel[key].forEach(function (v, i) {
												tempArr.push(v);
											});
										}
										_this2.showFieldList = JSON.parse((0, _stringify2.default)(tempArr));
									}
									_this2.getList();
								});

							case 3:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		},
		saveSelectField: function saveSelectField() {
			var _this3 = this;

			var tempArr = [];
			var tempArrModel = {
				'用户数据': [],
				'分享数据': [],
				'流量主数据': [],
				'分发数据': [],
				'收支数据': []
			};
			this.selectFieldList.forEach(function (v, i) {
				tempArr.push(v.key);
			});

			for (var key in this.selectFieldListForModel) {

				this.selectFieldListForModel[key].forEach(function (v, i) {
					tempArrModel[key].push(v.key);
				});
			}
			var content = {
				FieldIndex: this.FieldIndex,
				FieldList: tempArr,
				FieldListForModel: tempArrModel
			};

			var p = {
				position: 'product_daily_detail',
				content: content
			};
			(0, _api.postfieldFilter)(p, this.$cookie.getCookie("login")).then(function (res) {
				_this3.drawer = false;
				_this3.showFieldList = JSON.parse((0, _stringify2.default)(_this3.selectFieldList));
				_this3.getSelectField();
			});
		},
		removeSelectField: function removeSelectField(obj) {
			var _this4 = this;

			this.removeArrForObjName(this.selectFieldList, obj);

			var _loop = function _loop(key) {
				_this4.fieldList[key].some(function (item, index) {
					if (item.name == obj.name) {

						_this4.fieldList[key][index].isCheck = false;
					}
				});
			};

			for (var key in this.fieldList) {
				_loop(key);
			}
		},
		removeSelectFieldForModel: function removeSelectFieldForModel(obj, key) {
			var _this5 = this;

			var _this = this;
			this.removeArrForArrObjName(this.selectFieldListForModel, obj, key);

			this.fieldList[key].some(function (item, index) {
				if (item.name == obj.name) {

					_this5.fieldList[key][index].isCheck = false;
				}
			});
		},
		onMove: function onMove(_ref) {
			var relatedContext = _ref.relatedContext,
			    draggedContext = _ref.draggedContext;

			var relatedElement = relatedContext.item;
			var draggedElement = draggedContext.item;
		},
		fieldConfig: function fieldConfig() {
			this.drawer = true;
		},
		fliedTap: function fliedTap(key, index) {
			var _this6 = this;

			this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
			var result = this.selectFieldList.some(function (item) {
				if (item.name == _this6.fieldList[key][index].name) {
					return true;
				}
			});
			if (this.fieldList[key][index].isCheck) {
				if (!result) {
					this.selectFieldList.push(this.fieldList[key][index]);
				}
			} else {
				if (result) {
					this.removeArrForObjName(this.selectFieldList, this.fieldList[key][index]);
				}
			}
		},
		fliedTapForModel: function fliedTapForModel(key, index) {
			var _this7 = this;

			this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
			var result;
			for (var key2 in this.selectFieldListForModel) {
				result = this.selectFieldListForModel[key2].some(function (item) {
					if (item.name == _this7.fieldList[key][index].name) {

						return true;
					}
				});
				if (result) {
					break;
				}
			}

			if (this.fieldList[key][index].isCheck) {
				if (!result) {
					this.selectFieldListForModel[key].push(this.fieldList[key][index]);
				}
			} else {
				if (result) {

					this.removeArrForArrObjName(this.selectFieldListForModel, this.fieldList[key][index], key);
				}
			}
		},
		removeArrForObjName: function removeArrForObjName(_arr, _obj) {
			var length = _arr.length;
			for (var i = 0; i < length; i++) {
				if (_arr[i].name == _obj.name) {
					_arr.splice(i, 1);
					return _arr;
				}
			}
		},
		removeArrForArrObjName: function removeArrForArrObjName(obj, _obj, key) {
			console.log(obj);
			var length = obj[key].length;
			for (var i = 0; i < length; i++) {
				if (obj[key][i].name == _obj.name) {
					obj[key].splice(i, 1);
					console.log(obj);
					return obj;
				}
			}
		},
		handleCheckAllChange: function handleCheckAllChange(val) {

			this.checks = val ? this.checklist0 : [];
			this.isIndeterminate = false;
		},
		handleCheckedChange: function handleCheckedChange(value) {
			var checkedCount = value.length;

			this.checkAll = checkedCount === this.checklist0.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.checklist0.length;

			this.checks = value;
		},
		exportIncome: function exportIncome() {
			if (this.loading == true) {
				this.$message({
					message: "暂时无法导出，请稍后！",
					type: "warning"
				});
				return false;
			} else {
				this.checks = [];
				this.isIndeterminate = false;
				this.checkAll = false;
				this.checkDialog = true;
			}
		},
		handleDownload: function handleDownload() {
			var _this8 = this;

			var that = this;
			var arr = [];
			var arrHd = this.checks.map(function (v, i) {
				return v.name;
			});
			var arrFval = this.checks.map(function (v, i) {
				return v.value;
			});


			if (that.List == "") {
				return false;
			}

			console.log(arrHd);
			console.log(arrFval);
			__webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
				var _require = __webpack_require__(118),
				    export_json_to_excel = _require.export_json_to_excel,
				    export_table_to_excel = _require.export_table_to_excel;

				var tHeader = arrHd;
				var filterVal = arrFval;
				var list = _this8.list;

				var data = _this8.formatJson(filterVal, list);

				export_json_to_excel(tHeader, data, _this8.pdata.sdate + '~' + _this8.pdata.edate + "产品日报");
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		},
		formatJson: function formatJson(filterVal, jsonData) {
			return jsonData.map(function (v) {
				return filterVal.map(function (j) {
					return v[j];
				});
			});
		},
		handleClick: function handleClick(tab, event) {
			this.activeType = tab.index;
			console.log(tab, event);
		},
		changeDate: function changeDate(s) {
			this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 90 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10)];
		},
		getSummaries: function getSummaries(param) {
			var columnIdx = ['distribution_income', 'nonmatrix_income', 'nonmatrix_day_contribution', 'origin_income', 'channel_sell_income', 'matrix_sell_income', 'channel_buy_cost', 'matrix_buy_cost', 'gdt_buy_cost', 'total_profit_contain_matrix_cp', 'total_income_contain_matrix', 'total_cost_contain_matrix', 'total_profit_contain_matrix', 'total_income_no_matrix', 'total_cost_no_matrix', 'total_profit_no_matrix'];
			var columns = param.columns,
			    data = param.data;

			var sums = [];
			columns.forEach(function (column, index) {

				if (columnIdx.indexOf(column.property) == -1) {
					sums[index] = '-';
					return;
				}

				var values = data.map(function (item) {
					return Number(item[column.property]);
				});
				if (!values.every(function (value) {
					return isNaN(value);
				})) {
					sums[index] = values.reduce(function (prev, curr) {
						var value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);
					sums[index] = sums[index].toFixed(2) + ' 元';
				} else {
					sums[index] = 'N/A';
				}
			});

			return sums;
		},
		goback: function goback() {
			this.$router.back(-1);
		},
		getList: function getList() {
			var _this9 = this;

			var p = "";
			for (var k in this.pdata) {
				if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
			}
			(0, _api.getProductDailyDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
				if (res.code == 200) {
					if (res.data.list && res.data.list.length > 0) {
						_this9.list = res.data.list;
					} else {
						_this9.list = [];
					}
				}
			});
		},
		SizeChange: function SizeChange(v) {
			this.pdata.perpage = v;
			this.getList();
		},
		CurrentChange: function CurrentChange(v) {
			this.pdata.page = v;
			this.getList();
		}
	}, (0, _defineProperty3.default)(_methods, "changeDate", function changeDate(s) {
		this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
	}), (0, _defineProperty3.default)(_methods, "changeId", function changeId(res) {
		this.pdata.issued_app_id = res;
		this.getList();
	}), (0, _defineProperty3.default)(_methods, "fetch_issued_app_platform", function fetch_issued_app_platform() {
		var _this10 = this;

		var _this = this;
		var p = "position=product_daily_detail";
		(0, _api.getValidProductPlatform)(p, this.$cookie.getCookie("login")).then(function (res) {

			if (res.code == 200) {

				if (!_this10.$cookie.getCookie("platform_id")) {
					_this10.pdata.platform_id = res.data[0].platform_id;
				}

				_this10.get_issued_app_platform = res.data;
			}
		});
	}), _methods),

	created: function created() {

		this.height = window.innerHeight;
	},
	mounted: function mounted() {
		var _this = this;
		(0, _jquery2.default)(".content-container").scroll(function () {
			console.log((0, _jquery2.default)(".content-container").scrollTop());
			if ((0, _jquery2.default)(".content-container").scrollTop() > 150) {

				_this.height = window.innerHeight - 154;
			}
		});
	},
	activated: function activated() {

		this.pdata.issued_app_id = this.$route.params.issued_app_id;
		if (this.$route.query && (0, _keys2.default)(this.$route.query).length > 0) {
			this.pholder = this.$route.query.name;
		}
		if (this.$cookie.getCookie("platform_id")) {
			this.pdata.platform_id = parseInt(this.$cookie.getCookie("platform_id"));
		}
		this.pdata.sdate = this.$route.query.sdate;
		this.pdata.edate = this.$route.query.edate;
		this.dateVal = [this.pdata.sdate, this.pdata.edate];
		this.getSelectField();
		this.fetch_issued_app_platform();
	}
};

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(71);

var _keys2 = _interopRequireDefault(_keys);

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      pdata: {
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        company_id: ''
      },
      loading: false,
      companys: [],
      maxPage: 1,
      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      list: [],
      visit_uv_out: 0,
      visit_uv_in: 0,
      diff: 0
    };
  },

  watch: {
    'pdata.company_id': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    expands: function expands(r, es) {
      var _this = this;

      this.loading = true;
      var isshou = false;
      if (es.length > 0) {
        es.forEach(function (v) {
          if (v.issued_app_id == r.issued_app_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = "company_id=" + r.company_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];

        (0, _api.getExchangeDailyDay)(p, this.$cookie.getCookie("login")).then(function (res) {
          _this.loading = false;
          if (res.code == 200) {
            if (res.data && res.data.length > 0) {
              r.exData = res.data;
              _this.$forceUpdate();
            }
          }
        });
      } else {
        this.loading = false;
      }
    },
    getList: function getList() {
      var _this2 = this;

      this.loading = true;
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getExchangeDaily)(p, this.$cookie.getCookie("login")).then(function (res) {
        _this2.loading = false;
        _this2.list = res.data;
        _this2.visit_uv_out = 0;
        _this2.visit_uv_in = 0;
        _this2.diff = 0;
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            res.data.forEach(function (v, i) {
              _this2.visit_uv_in = _this2.visit_uv_in + parseInt(v.visit_uv_in);
              _this2.visit_uv_out = _this2.visit_uv_out + parseInt(v.visit_uv_out);
              _this2.diff = _this2.diff + parseInt(v.diff);
              v.keyid = 'key' + i;
              v.exData = [];
            });
            _this2.list = res.data;
          } else {
            _this2.list = [];
          }
        }
      });
    },
    getCompany: function getCompany() {
      var _this3 = this;

      var p = "";

      (0, _api.getIssuedAldCompany)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          if (res.data && res.data.length > 0) {
            _this3.companys = res.data;
          } else {
            _this3.companys = [];
          }
        }
      });
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    }
  },

  mounted: function mounted() {

    if ((0, _keys2.default)(this.$route.params).length > 0) {
      this.pdata.sdate = this.$route.params.sdate;
      this.pdata.edate = this.$route.params.edate;
    }
    this.getList();
    this.getCompany();
  }
};

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(72);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(8);

var _vuex = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      pdata: {
        company_id: "",
        issued_app_id: "",

        sdate: new Date(new Date().getTime() - 3600 * 1000 * 2 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        status: ""
      },
      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 2 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      loading: false,
      list: [],
      companys: [],
      apps: [],
      maxPage: 1,
      editDialog: false,
      chooseEditProduct: {
        "visit_uv_out": '',
        "visit_uv_in": ''
      },
      toggleRowExpansionNum: '',
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      }
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];

          this.getList();
        }
      },

      deep: true
    },
    'pdata.company_id': {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    'pdata.issued_app_id': {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    }
  },
  methods: {
    goback: function goback() {
      this.$router.back(-1);
    },
    expands: function expands(r, es) {
      var _this = this;

      this.loading = true;
      var isshou = false;
      if (es.length > 0) {
        es.forEach(function (v) {
          if (v.issued_app_id == r.issued_app_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = "issued_app_id=" + r.issued_app_id + "&company_id=" + r.company_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];

        (0, _api.getExchangeDailyDetailDay)(p, this.$cookie.getCookie("login")).then(function (res) {
          _this.loading = false;
          if (res.code == 200) {
            if (res.data && res.data.length > 0) {
              r.exData = res.data;
              _this.$forceUpdate();
            }
          } else {
            _this.loading = false;
          }
        });
      } else {
        this.loading = false;
      }
    },
    getList: function getList() {
      var _this2 = this;

      this.loading = true;
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getExchangeDailyDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
        _this2.loading = false;
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            res.data.forEach(function (x, i) {
              x.keyid = 'key' + i;
              x.exData = [];
            });
            _this2.list = res.data;
          } else {
            _this2.list = [];
          }

          setTimeout(function () {
            if (_this2.toggleRowExpansionNum !== '') {
              document.getElementsByClassName('el-table__expand-icon')[_this2.toggleRowExpansionNum].click();
            }
          }, 500);
        }
      });
    },
    getCompany: function getCompany() {
      var _this3 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getExchangeCompany)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            _this3.companys = res.data;
          } else {
            _this3.companys = [];
          }
        }
      });
      (0, _api.getExchangeApp)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          if (res.data && res.data.length > 0) {
            _this3.apps = res.data;
          } else {
            _this3.apps = [];
          }
        }
      });
    },
    editProduct: function editProduct(row, type, s) {
      if (s !== '') {
        this.toggleRowExpansionNum = s;
      } else {
        this.toggleRowExpansionNum = '';
      }
      this.editDialog = true;
      if (row.index_id == undefined) {
        this.chooseEditProduct = {
          "company_id": row.company_id,
          "issued_app_id": row.issued_app_id,
          "visit_uv_out": row.visit_uv_out,
          "visit_uv_in": row.visit_uv_in
        };
      } else {
        this.chooseEditProduct = {
          "index_id": row.index_id,
          "visit_uv_out": row.visit_uv_out,
          "visit_uv_in": row.visit_uv_in
        };
      }
      if (type == 'list') {
        this.chooseEditProduct.d_date = this.pdata.sdate;
      } else if (type == 'day') {
        this.chooseEditProduct.d_date = row.d_date;
      }
    },
    editChooseProduct: function editChooseProduct() {
      var _this4 = this;

      (0, _api.exchangeDailyEdit)(this.chooseEditProduct, this.$cookie.getCookie("login")).then(function (res) {
        _this4.editDialog = false;
        if (res.code == 200) {
          _this4.$message({ message: "更新换量成功", type: "success" });
          _this4.getList();
        } else if (res.code == 400) {
          _this4.$message({ message: res.msg, type: "warning" });
        } else {
          _this4.$message.error(res.msg);
        }
      });
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['groupid'])),
  mounted: function mounted() {
    this.pdata.company_id = this.$route.params.company_id;
    if (this.$route.query.sdate) {
      this.pdata.sdate = this.$route.query.sdate;
    }
    if (this.$route.query.edate) {
      this.pdata.edate = this.$route.query.edate;
    }
    this.dateVal = [this.pdata.sdate, this.pdata.edate];

    this.getList();
    this.getCompany();
  }
};

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(71);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      chartColumn: null,
      pholder: "",
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_id: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),

        type: "1"
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      list: [],
      isFetch: false,

      batchDialog: false,
      batchForm: [],
      batchTips: '0',
      url: _api.baseUrl + "issuedAldChannelData/preview",
      headers: {
        'token': this.$cookie.getCookie("login")
      },
      form: {},
      height: 900
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.$router.push({ path: '/costDaily/index', query: { sdate: this.pdata.sdate, edate: this.pdata.edate } });

          this.getList();
        }
      },

      deep: true
    }

  },
  methods: {
    nullFormatter: function nullFormatter(row, column, cellValue, index) {
      if (cellValue == '-') {
        return '-';
      } else if (cellValue == 0 || cellValue == null || cellValue == undefined) {
        return '0';
      } else {
        return cellValue;
      }
    },
    fixed2Formatter: function fixed2Formatter(row, column, cellValue, index) {
      if (cellValue == '-') {
        return '-';
      } else if (cellValue == 0 || cellValue == null || cellValue == undefined) {
        return '0.00';
      } else {
        return parseFloat(cellValue).toFixed(2);
      }
    },
    getSummaries: function getSummaries(param) {
      var _this = this;

      var self = this;
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 1) {
          sums[index] = '-';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (_this.dateVal[0] != _this.dateVal[1]) {
            if (index != 3 && index != 5) {
              sums[index] = '￥' + sums[index].toFixed(2);
            }
          }
          if (_this.dateVal[0] == _this.dateVal[1]) {
            if (index != 2 && index != 4) {
              sums[index] = '￥' + sums[index].toFixed(2);
            }
          }
        } else {
          sums[index] = '-';
        }
      });

      return sums;
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return "";
    },
    expands: function expands(r, es) {
      var _this2 = this;

      var isshou = false;
      if (es.length > 0) {
        es.forEach(function (v) {
          if (v.issued_app_id == r.issued_app_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = "issued_app_id=" + r.issued_app_id + "&sdate=" + this.dateVal[0] + "&type=" + this.pdata.type + "&edate=" + this.dateVal[1];

        (0, _api.getcostDailyForDays)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            r.exData = res.data.list;
            _this2.$forceUpdate();
          }
        });
      }
    },
    getList: function getList() {
      var _this3 = this;

      this.isFetch = false;
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getcostDaily)(p, this.$cookie.getCookie("login")).then(function (res) {
        _this3.isFetch = true;
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            res.data.list.forEach(function (x, i) {
              x.keyid = 'key' + i;
              x.exData = [];
            });
            _this3.list = res.data.list;
          } else {
            _this3.list = [];
          }
        }
      });
    },
    typeChange: function typeChange(v) {
      this.pdata.type = v;
      this.list = [];
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10)];
    },
    changeId: function changeId(res) {
      this.pdata.issued_app_id = res;
      this.getList();
    },
    downloadTemp: function downloadTemp() {
      window.location.href = '/static/channel_data_import.csv';
    },
    batchSuccess: function batchSuccess(response, file, fileList) {
      if (response.code == 200) {
        this.batchForm = response.data;
      }
    },
    batchAddProduct: function batchAddProduct() {
      this.batchDialog = true;
    },
    batchCalcel: function batchCalcel() {
      this.batchDialog = false;
      this.batchForm = [];
      this.batchTips = "0";
    },
    deleteBatch: function deleteBatch(index) {
      this.batchForm.splice(index, 1);
    },
    batchSubmit: function batchSubmit() {
      var _this4 = this;

      var p = {
        "overwrite": this.batchTips,
        "data": JSON.parse((0, _stringify2.default)(this.batchForm))
      };
      p.data.forEach(function (v, i) {

        if (v.length > 7) {
          v.pop();
        }
      });
      (0, _api.importAldChannelData)(p, this.$cookie.getCookie("login")).then(function (response) {
        debugger;
        if (response.data.code == 200) {

          if (response.data.data.length > 0) {

            _this4.batchForm = response.data.data;
            _this4.batchForm.unshift(["日期", "发行游戏", "渠道名称", "新增用户", "活跃用户", "单价", "点击单价"]);
            _this4.batchTips = "1";
          } else {
            _this4.$message({ message: "导入成功", type: "success" });
            _this4.batchDialog = false;
            _this4.batchForm = [];
            _this4.batchTips = "0";
            _this4.getList();
          }
        } else {
          _this4.$message.error('导入失败');
        }
      });
    }
  },
  created: function created() {

    console.log((0, _jquery2.default)(window).height() - 200);
    this.height = (0, _jquery2.default)(window).height() - 200;
  },
  mounted: function mounted() {

    if ((0, _keys2.default)(this.$route.params).length > 0) {
      this.pdata.sdate = this.$route.params.sdate;
      this.pdata.edate = this.$route.params.edate;
      this.pdata.app_id = this.$route.params.app_id;
      this.pholder = this.$route.params.name;
    }
    if (this.$route.query.sdate) {
      this.pdata.sdate = this.$route.query.sdate;
    }
    if (this.$route.query.edate) {
      this.pdata.edate = this.$route.query.edate;
    }
    this.dateVal = [this.pdata.sdate, this.pdata.edate];

    this.getList();
  }
};

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(72);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

var _vuex = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      chartColumn: null,
      pholder: "",
      chooseProduct: { name: "", id: '' },
      pdata: {
        issued_app_id: "",
        company: "",
        channel_id: "",
        type: "",
        kw: "",
        real: "0",
        ctype: "",
        data_source: "",
        product_belongs: "",

        sdate: new Date(new Date().getTime() - 3600 * 1000 * 2 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        status: ""
      },
      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 2 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      IssAppList: [],
      list: [],
      companys: [],
      ChannelList: [],
      chooseEditProduct: {
        visit_uv_new_input: '',
        type: '',
        cost_input: '',
        atv: '',
        index_id: '',
        _visit_uv_new_o: '',
        visit_uv_new_o: '',
        buy_source: ''
      },
      toggleRowExpansionNum: '',
      height: 900
    };
  },

  watch: {
    'pdata.channel_id': {
      handler: function handler(n, o) {
        if (n) {
          this.pdata.channel_id = n;
          this.getList();
        }
      },

      deep: true
    },
    'pdata.company': {
      handler: function handler(n, o) {
        if (n) {
          this.pdata.company = n;
          this.getList();
        }
      },

      deep: true
    },
    'pdata.type': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'pdata.ctype': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'pdata.real': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'pdata.data_source': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'pdata.product_belongs': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];

          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    getSummaries: function getSummaries(param) {
      var _this = this;

      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        if (_this.dateVal[0] == _this.dateVal[1]) {
          if (index === 4 || index === 11) {
            sums[index] = '-';
            return;
          }
        } else {
          if (index === 5 || index === 12) {
            sums[index] = '-';
            return;
          }
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {

          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (index === 6 || index === 9 || index === 10) {
            sums[index] = '￥' + sums[index].toFixed(2);
          } else {
            sums[index] = sums[index];
          }
        } else {
          sums[index] = '-';
        }
      });

      return sums;
    },
    fixed2Formatter: function fixed2Formatter(row, column, cellValue, index) {
      if (cellValue == '-') {
        return '-';
      } else if (cellValue == null || cellValue == undefined) {
        return '0.00';
      } else {
        return parseFloat(cellValue).toFixed(2);
      }
    },
    visitUvNewKeyup: function visitUvNewKeyup() {
      var self = this;
      if (self.chooseEditProduct.type != 3 && self.chooseEditProduct.type != 5) {
        if (self.chooseEditProduct._visit_uv_new_o != null && self.chooseEditProduct._visit_uv_new_o != undefined && self.chooseEditProduct._visit_uv_new_o != 0) {
          self.chooseEditProduct.cost_input = (self.chooseEditProduct._visit_uv_new_o * self.chooseEditProduct.atv).toFixed(2);
        } else {
          self.chooseEditProduct.cost_input = (self.chooseEditProduct.visit_uv_new_input * self.chooseEditProduct.atv).toFixed(2);
        }
      }
    },
    atvKeyup: function atvKeyup() {
      var self = this;

      if (self.chooseEditProduct._visit_uv_new_o != null && self.chooseEditProduct._visit_uv_new_o != undefined && self.chooseEditProduct._visit_uv_new_o != 0) {
        self.chooseEditProduct.cost_input = (self.chooseEditProduct._visit_uv_new_o * self.chooseEditProduct.atv).toFixed(2);
      } else {
        if (self.chooseEditProduct.buy_source == '1') {
          self.chooseEditProduct.cost_input = (self.chooseEditProduct.visit_uv_new_input * self.chooseEditProduct.atv).toFixed(2);
        } else if (self.chooseEditProduct.buy_source == '2') {
          self.chooseEditProduct.cost_input = (self.chooseEditProduct.visit_uv_input * self.chooseEditProduct.atv).toFixed(2);
        }
      }
    },
    typeKeyup: function typeKeyup() {
      var self = this;
      self.chooseEditProduct.atv = 0;
      if (self.chooseEditProduct.type == 5) {
        self.chooseEditProduct.cost_input = 0;
      }
    },
    goback: function goback() {

      this.$router.back(-1);
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      if (row.status == 0 || row.status == 2) {
        return 'warning-row';
      }
      return "";
    },
    getIssAPPList: function getIssAPPList() {
      var _this2 = this;

      var p = "";
      (0, _api.getIssuedAppList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this2.IssAppList = res.data;
          _this2.IssAppList.forEach(function (v, i) {
            if (v.id == _this2.pdata.issued_app_id) {
              _this2.chooseProduct.name = v.name;
            }
          });
        }
      });
    },
    statusChange: function statusChange(v) {
      this.pdata.status = v;
      this.list = [];
      this.getList();
    },
    updateCostHander: function updateCostHander() {
      var _this3 = this;

      debugger;
      console.log("issued_app_id:" + this.pdata.issued_app_id);

      this.$confirm('确定更新成本吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {

        var d_date = _this3.pdata.sdate.split("-").join("");
        (0, _api.updateCost)({ "issued_app_id": _this3.pdata.issued_app_id, "d_date": d_date }, _this3.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this3.$message({ message: "更新成本成功", type: "success" });
          } else if (res.code == 400) {
            _this3.$message({ message: res.msg, type: "warning" });
          } else {
            _this3.$message.error(res.msg);
          }
        });
      }).catch(function () {});
    },
    confirmOff: function confirmOff(index, row) {
      var _this4 = this;

      this.$confirm('确定下线吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {

        (0, _api.confirmOff)({ "channel_id": row.channel_id, "status": "2" }, _this4.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this4.$message({ message: "下线成功", type: "success" });

            _this4.getList();
          } else {
            _this4.$message.error('下线失败');
          }
        });
      }).catch(function () {});
    },
    expands: function expands(r, es) {
      var _this5 = this;

      var isshou = false;
      if (es.length > 0) {
        es.forEach(function (v) {
          if (v.issued_app_id == r.issued_app_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = "issued_app_id=" + r.issued_app_id + "&channel_id=" + r.channel_id + "&sdate=" + this.dateVal[0] + "&type=" + this.pdata.type + "&edate=" + this.dateVal[1];

        (0, _api.getcostDailyDetailForDays)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            r.exData = res.data.list;
            _this5.$forceUpdate();
          }
        });
      }
    },
    getList: function getList() {
      var _this6 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getcostDailyDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            res.data.list.forEach(function (x, i) {
              x.keyid = 'key' + i;
              x.exData = [];
              x.ex;
            });
            _this6.list = res.data.list;

            setTimeout(function () {
              if (_this6.toggleRowExpansionNum !== '') {
                document.getElementsByClassName('el-table__expand-icon')[_this6.toggleRowExpansionNum].click();
              }
            }, 500);
          } else {
            _this6.list = [];
          }
        }
      });
    },
    fetchCompany: function fetchCompany() {
      var _this7 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.selectCompany)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          if (res.data && res.data.length > 0) {
            _this7.companys = res.data;
          } else {
            _this7.companys = [];
          }
        }
      });
    },
    fetchIssuedAldChanneList: function fetchIssuedAldChanneList() {
      var _this8 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getIssuedAldChanneList)(p, this.$cookie.getCookie("login")).then(function (res) {

        if (res.code == 200) {

          if (res.data.list && res.data.list.length > 0) {
            _this8.ChannelList = res.data.list;
          } else {
            _this8.ChannelList = [];
          }
        }
      });
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeCom: function changeCom(v) {

      this.getList();
    },
    changeId: function changeId(res) {
      this.pdata.issued_app_id = res;
      this.getList();
    },
    editProduct: function editProduct(row, s) {
      if (s !== '') {
        this.toggleRowExpansionNum = s;
      } else {
        this.toggleRowExpansionNum = '';
      }
      this.editDialog = true;
      this.chooseEditProduct = {
        buy_source: row.buy_source,
        visit_uv_input: row._visit_uv,
        visit_uv_new_input: row._visit_uv_new || row.visit_uv_new,
        _visit_uv_new_o: row._visit_uv_new_o,
        visit_uv_new_o: row._visit_uv_new_o,
        type: row.type,
        cost_input: row._cost,
        atv: row.atv,
        index_id: row.index_id
      };
      switch (row.type) {
        case '阿拉丁':
          this.chooseEditProduct.type = 1;
          break;
        case '微信':
          this.chooseEditProduct.type = 2;
          break;
        case '广点通':
          this.chooseEditProduct.type = 3;
          break;
        case '内部矩阵':
          this.chooseEditProduct.type = 4;
          break;
        case '阿拉丁换量':
          this.chooseEditProduct.type = 5;
          break;
      }
    },
    changeProduct: function changeProduct(res) {
      this.pdata.issued_app_id = res.id;
      this.getList();
      this.fetchIssuedAldChanneList();
      this.fetchCompany();
    },
    getConfig: function getConfig() {
      var _this9 = this;

      if (this.$store.config) {
        this.config = this.$store.config.get_channel_price_type;
      } else {
        setTimeout(function () {
          _this9.getConfig();
        }, 50);
      }
    },
    editChooseProduct: function editChooseProduct() {
      var _this10 = this;

      var p = JSON.parse((0, _stringify2.default)(this.chooseEditProduct));
      if (this.chooseEditProduct.type != 3) {
        p.cost_input = 0;
      }

      (0, _api.visitUVNewEdit)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this10.editDialog = false;
          _this10.$message({ message: "修改成功", type: "success" });

          _this10.getList();
        } else {
          _this10.$message.error('修改失败');
        }
      });
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['groupid'])),
  created: function created() {

    console.log((0, _jquery2.default)(window).height() - 200);
    this.height = (0, _jquery2.default)(window).height() - 200;
  },
  mounted: function mounted() {

    this.pdata.issued_app_id = this.$route.params.issued_app_id;

    if (this.$route.query.sdate) {
      this.pdata.sdate = this.$route.query.sdate;
    }
    if (this.$route.query.edate) {
      this.pdata.edate = this.$route.query.edate;
    }
    if (this.$route.query.channel_id) {
      this.pdata.channel_id.push(this.$route.query.channel_id);
    }
    this.dateVal = [this.pdata.sdate, this.pdata.edate];

    this.getList();
    this.getIssAPPList();
    this.fetchIssuedAldChanneList();
    this.fetchCompany();
    this.getConfig();
  }
};

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  components: {},
  data: function data() {
    return {
      rules: {},
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        bill_issued_data_id: 0,
        bill_date: ''
      },
      plist: [],
      company: '',
      wecompany: [],
      bill: '',
      formLabelWidth: "100px",

      plog: [],
      logDialog: false

    };
  },

  watch: {},
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getBillDataDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.company = res.data.company;
          _this.bill = res.data.bill;
          _this.wecompany = res.data.wecompany;
          if (res.data.list && res.data.list.length > 0) {
            _this.plist = res.data.list;
            _this.plist.sort(_this.compareStatus);
          }
        }
      });
    },

    compareStatus: function compareStatus(val1, val2) {
      return val1.type_val - val2.type_val;
    }
  },
  created: function created() {
    var that = this;
  },
  mounted: function mounted() {

    this.pdata.bill_issued_data_id = this.$route.params.index_id;
    this.pdata.bill_date = this.$route.query.bill_date;
    this.getList();
  }
};

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(72);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(54);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

var _htmlToPdf = __webpack_require__(139);

var _htmlToPdf2 = _interopRequireDefault(_htmlToPdf);

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

var _vuex = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  data: function data() {
    var _ref;

    return _ref = {
      rules: {
        name: [{ required: true, message: "请输入企业/个人名称", trigger: "blur" }],
        opening_bank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        receiving_account: [{ required: true, message: "请输入收款账号", trigger: "blur" }]
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_name: "",
        theme: "",
        status: "0",
        company_id: "",
        sort_field: "",
        sort_by: "",
        placement: "",
        type: [],
        invoice_type: "",
        date: ''
      },
      monthVal: [],
      bdata: {
        company_id: 0,
        bill_date: ''
      },
      plist: [],
      billList: [],
      company: '',
      wecompany: [],
      bill: '',
      companyList: [],
      chooseCompany: '',
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [],
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText: "请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      }
    }, (0, _defineProperty3.default)(_ref, "imageUrl", ""), (0, _defineProperty3.default)(_ref, "isAdd", false), (0, _defineProperty3.default)(_ref, "cP", {
      index_id: "",
      status: "1",
      log: ""
    }), (0, _defineProperty3.default)(_ref, "selectProduct", []), (0, _defineProperty3.default)(_ref, "prWidth", 0), (0, _defineProperty3.default)(_ref, "chooseProduct", {
      "type": "1",
      "name": "",
      "opening_bank": "",
      "receiving_account": "",
      "social_credit_code": "",
      "contact": "",
      "phone": "",
      "invoice_type": "",
      "tax_point": "",
      "company_addr": "",
      "email_addr": "",
      "remark": "",
      "log": ""
    }), (0, _defineProperty3.default)(_ref, "billDialog", false), (0, _defineProperty3.default)(_ref, "height", 710), _ref;
  },

  watch: {
    "pdata.type": {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    "pdata.status": {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    "pdata.company_id": {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    "pdata.date": {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    }

  },
  methods: (_methods = {
    handleDown: function handleDown() {
      _htmlToPdf2.default.downloadPDF(document.querySelector('#ta'), this.company.name + "结算对账单");
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        if (index === 1 || index === 2 || index === 4 || index === 7 || index === 9 || index === 10) {
          sums[index] = '-';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = '-';
        }
      });

      return sums;
    },
    monthValChange: function monthValChange() {

      this.pdata.date = this.monthVal[0] + '-' + this.monthVal[1];
    },
    handleDownload: function handleDownload() {
      var _this = this;

      var that = this;
      var arr = [];
      var arrHd = ["开始日期", "结束日期", "游戏名称", "渠道名称", "平台", "合作方式", "新增人数", "单价(元/个)", "应收金额"];
      var arrFval = ["bill_sdate", "bill_edate", "product_name", "channel_name", "platform", "type", "num", "unit", "bill_amount"];

      that.billList.forEach(function (v, i) {
        v.bill_amount = v.num * v.unit;
      });
      console.log(that.billList);
      if (that.billList == "") {
        return false;
      }

      console.log(arrHd);
      console.log(arrFval);
      __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
        var _require = __webpack_require__(118),
            export_json_to_excel = _require.export_json_to_excel,
            export_table_to_excel = _require.export_table_to_excel;

        var tHeader = arrHd;
        var filterVal = arrFval;
        var list = _this.billList;

        var data = _this.formatJson(filterVal, list);
        data.push([""]);
        data.push([""]);
        data.push(["结算类型", _this.company.type == 1 ? "企业" : "个人"]);
        data.push(["发票类型", _this.bill.invoice_type == 1 ? '普通发票' : '增值发票']);
        data.push(["新增用户", _this.bill.num]);
        data.push(["税点", _this.bill.tax_point + '%']);
        data.push([_this.company.type == 1 ? "结算金额" : "结算金额(扣去税点后金额)", _this.bill.bill_amount]);
        data.push(["结算金额（人民币大写）", _this.bill.big_bill_amount]);
        data.push([""]);
        data.push([""]);
        data.push(["甲方公司:" + _this.company.name, null, null, null, _this.wecompany[0]]);
        data.push(["税号:" + _this.company.social_credit_code, null, null, null, _this.wecompany[3]]);
        data.push(["注册地址:" + _this.company.company_addr, null, null, null, _this.wecompany[4]]);
        data.push(["注册电话:" + _this.company.company_phone, null, null, null, _this.wecompany[8]]);
        data.push(["开户银行:" + _this.company.opening_bank, null, null, null, _this.wecompany[1]]);
        data.push(["银行账号:" + _this.company.receiving_account, null, null, null, _this.wecompany[2]]);
        data.push(["联系人:" + _this.company.contact, null, null, null, _this.wecompany[6]]);
        data.push(["联系电话:" + _this.company.phone, null, null, null, _this.wecompany[7]]);
        data.push(["邮寄地址:" + _this.company.email_addr, null, null, null, _this.wecompany[5]]);

        export_json_to_excel(tHeader, data, _this.company.name + "结算对账单");
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    search: function search() {
      this.getList();
    },
    ChangeBillDataStatus: function ChangeBillDataStatus(id, status) {
      var _this2 = this;

      var log = "";
      if (status == 1) {
        log = '确认审核';
      } else if (status == 2) {
        log = '负责人审核';
      } else if (status == 3) {
        log = '财务审核';
      } else if (status == 4) {
        log = '财务打款';
      } else if (status == -1) {
        log = '确认作废';
      } else if (status == 0) {
        log = '确认恢复';
      }
      this.$prompt("您将" + log + "该账单，是否继续？", log, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "填写备注（可以为空）"
      }).then(function (_ref2) {
        var value = _ref2.value;

        if (value) {
          log = log + '-' + value;
        }

        (0, _api.billDataStatus)({ "bill_issued_data_id": id, "status": status, log: log }, _this2.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this2.billDialog = false;
            _this2.getList();
          }
        });
      });
    },
    billEdit: function billEdit(r) {
      this.bdata.company_id = r.company_id;
      this.bdata.bill_date = r.bill_date;
      this.getBillList(r.status, r.company_id, r.id);
    },
    billOffset: function billOffset(r, offset) {
      var _this3 = this;

      (0, _api.postBillOffset)({ "bill_data_id": r.id, "offset": offset }, this.$cookie.getCookie("login")).then(function (res) {
        if (res.data.code == 200) {
          _this3.editDialog = false;
          _this3.$notify({
            title: "通知",
            message: "成功",
            type: "success"
          });
          _this3.getList();
        } else {

          _this3.$notify.error({
            title: '错误',
            message: res.data.msg
          });
        }
      });
    },
    createBillData: function createBillData() {
      this.editDialog = true;
    },
    buildBillData: function buildBillData() {
      var _this4 = this;

      if (this.chooseCompany.length < 1) {
        this.$message.error("请先选择需要生成账单的公司");
      } else {

        var p = this.chooseCompany;

        p.forEach(function (v, i) {
          (0, _api.billDataAdd)({ "index_id": v }, _this4.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this4.editDialog = false;
              _this4.$notify({
                title: '通知',
                message: res.data.company + "成功",
                type: 'success'
              });
            } else {
              _this4.$message.error(res.msg);
            }
          });
        });
      }
    },
    updateBillData: function updateBillData(s) {
      var _this5 = this;

      (0, _api.billDataAdd)({ "index_id": s.company_id, "bill_sdate": s.bill_sdate, "bill_edate": s.bill_edate, "log": "更新账单" }, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this5.editDialog = false;
          _this5.$notify({
            title: '通知',
            message: res.data.company + "成功",
            type: 'success'
          });
        } else {
          _this5.$message.error(res.msg);
        }
      });
    },
    createBillDataOne: function createBillDataOne() {
      var _this6 = this;

      var arr = [];
      if (this.cP.index_id != '') {
        var arr = this.cP.index_id.split(",");
        console.log(arr);
        arr.forEach(function (v, i) {
          (0, _api.billDataAdd)({ "index_id": v }, _this6.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this6.editDialog = false;
              _this6.$notify({
                title: '通知',
                message: res.data.company + "成功",
                type: 'success'
              });
            }
          });
        });
      } else {
        this.$message.error('请选择需要更新的账单');
        return false;
      }
    },
    createBillDataALl: function createBillDataALl(id) {
      var _this7 = this;

      (0, _api.billDataAdd)({ "index_id": id }, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this7.editDialog = false;
          _this7.$notify({
            title: '通知',
            message: res.data.company + "成功",
            type: 'success'
          });
          if (res.data.index_id !== 0) {
            _this7.createBillDataALl(res.data.index_id);
          }
        }
      });
    },
    getList: function getList() {
      var _this8 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getBillDataList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this8.plist = res.data.list;
            _this8.maxPage = res.data.max_page;
          } else {
            _this8.plist = [];
            _this8.maxPage = 1;
          }
        }
      });
    },
    getBillList: function getBillList(status, company_id, id) {
      var _this9 = this;

      var p = "";
      for (var k in this.bdata) {
        if (this.bdata[k]) p += k + "=" + this.bdata[k] + "&";
      }
      (0, _api.getBillDataDetail)('bill_issued_data_id=' + id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this9.billDialog = true;
          _this9.company = res.data.company;
          _this9.bill = res.data.bill;
          _this9.bill.status = status;
          _this9.bill.id = id;
          _this9.wecompany = res.data.wecompany;
          if (res.data.list && res.data.list.length > 0) {
            _this9.billList = res.data.list;
          } else {
            _this9.billList = [];
          }
        }
      });
    },
    fetchEXCompany: function fetchEXCompany() {
      var _this10 = this;

      (0, _api.getExchangeCompany)('', this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            _this10.companyList = res.data;
          }
        }
      });
    },
    openDealy: function openDealy(id) {
      var _this11 = this;

      var p = 'type=bill_issued_data&index_id=' + id;
      (0, _api.sclog)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this11.logDialog = true;
          _this11.plog = res.data;
        } else {
          _this11.$message.error(res.msg);
        }
      });
    },
    getConfig: function getConfig() {
      var _this12 = this;

      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(function () {
          _this12.getConfig();
        }, 50);
      }
    },
    statueFilter: function statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter: function placementFilter(s) {
      this.pText = s == "" ? "请选择产品投放位置" : s;
      this.pdata.placement = s;
      this.getList();
    }
  }, (0, _defineProperty3.default)(_methods, "search", function search() {
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "SizeChange", function SizeChange(v) {
    this.pdata.perpage = v;
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "CurrentChange", function CurrentChange(v) {
    this.pdata.page = v;
    this.getList();
  }), (0, _defineProperty3.default)(_methods, "changeStatus", function changeStatus(isSingle, s) {
    var _this13 = this;

    if (!isSingle && this.selectProduct.length == 0) {
      this.$message.error("请先选择需要批量操作的数据");
      return;
    }
    if (isSingle) {
      this.cP.index_id = s.id;
      this.cP.status = s.status == 1 ? "0" : "1";
    } else {
      this.cP.status = s;
    }

    if (this.cP.status == 0) {
      this.cP.log = "禁用产品";
    } else if (this.cP.status == 1) {
      this.cP.log = "启用产品";
    } else if (this.cP.status == -1) {
      this.cP.log = "删除产品";
    }
    (0, _api.billDataStatus)(this.cP, this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this13.getList();
        _this13.$message({ message: _this13.cP.log + "成功", type: "success" });
      }
    });
  }), (0, _defineProperty3.default)(_methods, "select", function select(s) {
    this.selectProduct = s;
    var p = "测";
    s.forEach(function (v, i) {
      p += "," + v.company_id;
    });
    this.cP.index_id = p.slice(2);
  }), (0, _defineProperty3.default)(_methods, "handleAvatarSuccess", function handleAvatarSuccess(res, file) {
    this.imageUrl = URL.createObjectURL(file.raw);
  }), (0, _defineProperty3.default)(_methods, "getInfo", function getInfo(s) {
    this.chooseProduct = JSON.parse((0, _stringify2.default)(s));
    delete this.chooseProduct.id;
    this.chooseProduct.path = '';
    this.chooseProduct.placement = '';
    this.chooseProduct.log = "新增复用产品";
    this.chooseTags = this.chooseProduct.tags.split(",");
  }), (0, _defineProperty3.default)(_methods, "base64", function base64(s) {
    return window.btoa(unescape(encodeURIComponent(s)));
  }), (0, _defineProperty3.default)(_methods, "format", function format(s, c) {
    return s.replace(/{(\w+)}/g, function (m, p) {
      return c[p];
    });
  }), (0, _defineProperty3.default)(_methods, "tableToExcel", function tableToExcel() {
    var uri = 'data:application/vnd.ms-excel;base64,';
    var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"' + 'xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>' + '<x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets>' + '</x:ExcelWorkbook></xml><![endif]-->' + ' <style type="text/css">' + 'table td {' + 'border: 2px solid #000000;' + 'width: 200px;' + 'height: 30px;' + ' text-align: center;' + 'background-color: #ffffff;' + 'color: #000000;' + ' }' + 'table th {' + 'border: 2px solid #000000;' + 'width: 200px;' + 'height: 30px;' + ' text-align: center;' + 'background-color: #ffffff;' + 'color: #000000;' + ' }' + '</style>' + '</head><body ><table class="excelTable">{table}</table></body></html>';
    var tableid = document.getElementById('ta');

    var ctx = { worksheet: this.company.name + "结算对账单" || 'Worksheet', table: tableid.innerHTML };
    console.log(uri + this.base64(this.format(template, ctx)));

    this.base64ToFile(uri + this.base64(this.format(template, ctx)));
  }), (0, _defineProperty3.default)(_methods, "base64ToFile", function base64ToFile(base) {
    var arr = base.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    if (window.navigator.msSaveBlob) {
      try {
        var blobObject = new Blob([u8arr], { type: mime });
        window.navigator.msSaveBlob(blobObject, this.company.name + '.xls');
      } catch (e) {
        console.log(e);
      }
    } else {
      var url = window.URL.createObjectURL(new Blob([u8arr], { type: mime }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.company.name + '.xls');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }), _methods),
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['groupid'])),
  created: function created() {

    console.log((0, _jquery2.default)(window).height() - 200);
    this.height = (0, _jquery2.default)(window).height() - 400;
  },
  mounted: function mounted() {
    this.getList();
    this.getConfig();
    this.fetchEXCompany();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(71);

var _keys2 = _interopRequireDefault(_keys);

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      chartColumn: null,
      pholder: "",
      pdata: {
        platform_id: 1,
        page: 1,
        perpage: 20,
        issued_app_id: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      checkDialog: false,
      checklist: [{ "name": "日期", value: "d_date" }, { "name": "换入量", value: "huanliang_in" }, { "name": "换出量", value: "huanliang_out" }, { "name": "矩阵买量", value: "matrix_buy_cost" }, { "name": "矩阵卖量", value: "matrix_sell_income" }, { "name": "流量主", value: "origin_income" }, { "name": "流量主分成", value: "origin_divide_income" }, { "name": "渠道买量", value: "channel_buy_cost" }, { "name": "渠道卖量", value: "channel_sell_income" }, { "name": "广点通", value: "gdt_buy_cost" }, { "name": "收入（含矩阵）", value: "total_income_contain_matrix" }, { "name": "成本（含矩阵）", value: "total_cost_contain_matrix" }, { "name": "利润（含矩阵）", value: "total_profit_contain_matrix" }, { "name": "收入（不含矩阵）", value: "total_income_no_matrix" }, { "name": "成本（不含矩阵）", value: "total_cost_no_matrix" }, { "name": "利润（不含矩阵）", value: "total_profit_no_matrix" }],
      checks: [],
      isIndeterminate: false,
      checkAll: false,
      group: {},

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      list: [],
      loading: false,
      height: 710,
      get_issued_app_platform: []
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    changePlatform: function changePlatform() {
      this.getList();
    },
    getPlatFormList: function getPlatFormList() {
      var _this = this;

      var p = "";
      (0, _api.getValidProductPlatform)(p, this.$cookie.getCookie("login")).then(function (res) {

        if (res.code == 200) {
          _this.get_issued_app_platform = res.data;
        }
      });
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checks = val ? this.checklist : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange: function handleCheckedChange(value) {

      var checkedCount = value.length;
      this.checkAll = checkedCount === this.checklist.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checklist.length;
      this.checks = value;
    },
    exportIncome: function exportIncome() {
      if (this.loading == true) {
        this.$message({ message: "暂时无法导出，请稍后！", type: "warning" });
        return false;
      } else {
        this.checkDialog = true;
      }
    },
    handleDownload: function handleDownload() {
      var _this2 = this;

      var that = this;
      var arr = [];
      var arrHd = this.checks.map(function (v, i) {
        return v.name;
      });
      var arrFval = this.checks.map(function (v, i) {
        return v.value;
      });


      if (that.List == "") {
        return false;
      }

      console.log(arrHd);
      console.log(arrFval);
      __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
        var _require = __webpack_require__(118),
            export_json_to_excel = _require.export_json_to_excel,
            export_table_to_excel = _require.export_table_to_excel;

        var tHeader = arrHd;
        var filterVal = arrFval;
        var list = _this2.list;

        var data = _this2.formatJson(filterVal, list);

        export_json_to_excel(tHeader, data, _this2.pdata.sdate + '~' + _this2.pdata.edate + "收入日报");
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    getHeaderCellClassName: function getHeaderCellClassName(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;


      if (columnIndex == 11 || columnIndex == 14) {
        return 'thRed';
      }
    },
    cellClassName: function cellClassName(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      console.log(column.label, columnIndex);
      if (columnIndex == 12 || columnIndex == 15) {
        return 'cellRed';
      }
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = '￥' + values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0).toFixed(2);
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    getList: function getList() {
      var _this3 = this;

      this.loading = true;
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getIncomeDaily)(p, this.$cookie.getCookie("login")).then(function (res) {
        _this3.loading = false;
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this3.list = res.data.list;
          } else {
            _this3.list = [];
          }
        }
      });
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    changeId: function changeId(res) {
      this.pdata.issued_app_id = res;
      this.getList();
    }
  },

  created: function created() {

    console.log((0, _jquery2.default)(window).height() - 200);
    this.height = (0, _jquery2.default)(window).height() - 200;
  },
  mounted: function mounted() {

    if ((0, _keys2.default)(this.$route.params).length > 0) {
      this.pdata.sdate = this.$route.params.sdate;
      this.pdata.edate = this.$route.params.edate;
      this.pdata.app_id = this.$route.params.app_id;
      this.pholder = this.$route.params.name;
    }
    this.getPlatFormList();
    this.getList();
  }
};

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(54);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      chartColumn: null,
      pholder: "",
      pdata: {
        platform_id: '',
        page: 1,
        perpage: 20,
        issued_app_id: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      checkDialog: false,
      checklist: [{ "name": "发行名称", value: "issued_app_name" }, { "name": "换入量", value: "huanliang_in" }, { "name": "换出量", value: "huanliang_out" }, { "name": "矩阵买量", value: "matrix_buy_cost" }, { "name": "矩阵卖量", value: "matrix_sell_income" }, { "name": "流量主", value: "origin_income" }, { "name": "流量主分成", value: "origin_divide_income" }, { "name": "渠道买量", value: "channel_buy_cost" }, { "name": "渠道卖量", value: "channel_sell_income" }, { "name": "广点通", value: "gdt_buy_cost" }, { "name": "收入（含矩阵）", value: "total_income_contain_matrix" }, { "name": "成本（含矩阵）", value: "total_cost_contain_matrix" }, { "name": "利润（含矩阵）", value: "total_profit_contain_matrix" }, { "name": "收入（不含矩阵）", value: "total_income_no_matrix" }, { "name": "成本（不含矩阵）", value: "total_cost_no_matrix" }, { "name": "利润（不含矩阵）", value: "total_profit_no_matrix" }],
      checks: [],
      isIndeterminate: false,
      checkAll: false,
      group: {},
      get_issued_app_platform: [],
      dateVal: [],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      list: [],
      loading: false,
      height: 710
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          if (this.loading == true) {

            return false;
          }
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];

          this.getList();
        }
      },

      deep: true,
      immediate: false
    }
  },
  methods: (_methods = {
    changePlatform: function changePlatform() {
      this.getList();
    },
    getPlatFormList: function getPlatFormList() {
      var _this = this;

      var p = "";
      (0, _api.getValidProductPlatform)(p, this.$cookie.getCookie("login")).then(function (res) {

        if (res.code == 200) {
          _this.get_issued_app_platform = res.data;
        }
      });
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checks = val ? this.checklist : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange: function handleCheckedChange(value) {

      var checkedCount = value.length;
      this.checkAll = checkedCount === this.checklist.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checklist.length;
      this.checks = value;
    },
    exportIncome: function exportIncome() {
      if (this.loading == true) {
        this.$message({ message: "暂时无法导出，请稍后！", type: "warning" });
        return false;
      } else {
        this.checkDialog = true;
      }
    },
    handleDownload: function handleDownload() {
      var _this2 = this;

      var that = this;
      var arr = [];
      var arrHd = this.checks.map(function (v, i) {
        return v.name;
      });
      var arrFval = this.checks.map(function (v, i) {
        return v.value;
      });


      if (that.List == "") {
        return false;
      }

      console.log(arrHd);
      console.log(arrFval);
      __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
        var _require = __webpack_require__(118),
            export_json_to_excel = _require.export_json_to_excel,
            export_table_to_excel = _require.export_table_to_excel;

        var tHeader = arrHd;
        var filterVal = arrFval;
        var list = _this2.list;

        var data = _this2.formatJson(filterVal, list);

        export_json_to_excel(tHeader, data, _this2.pdata.sdate + '~' + _this2.pdata.edate + "收入日报");
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    getHeaderCellClassName: function getHeaderCellClassName(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;


      if (columnIndex == 11 || columnIndex == 14) {
        return 'thRed';
      }
    },
    cellClassName: function cellClassName(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      console.log(column.label, columnIndex);
      if (columnIndex == 12 || columnIndex == 15) {
        return 'cellRed';
      }
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10)];
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = '￥' + values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0).toFixed(2);
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    getList: function getList() {
      var _this3 = this;

      this.loading = true;
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getIncomeDailyDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
        _this3.loading = false;
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this3.list = res.data.list;
          } else {
            _this3.list = [];
          }
        }
      });
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    }
  }, (0, _defineProperty3.default)(_methods, "changeDate", function changeDate(s) {
    this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
  }), (0, _defineProperty3.default)(_methods, "changeId", function changeId(res) {
    this.pdata.issued_app_id = res;
    this.getList();
  }), _methods),

  created: function created() {

    console.log((0, _jquery2.default)(window).height() - 200);
    this.height = (0, _jquery2.default)(window).height() - 200;
  },
  mounted: function mounted() {},
  activated: function activated() {
    this.getPlatFormList();
    if (this.$route.query.sdate != undefined && this.$route.query.edate != undefined) {
      this.pdata.sdate = this.$route.query.sdate;
      this.pdata.edate = this.$route.query.edate;
      this.dateVal = [this.$route.query.sdate, this.$route.query.edate];
      this.pdata.platform_id = this.$route.query.platform_id;
      this.$forceUpdate();

      this.getList();
    } else {
      this.getList();
    }
  }
};

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(71);

var _keys2 = _interopRequireDefault(_keys);

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(66);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      chartColumn: null,
      pholder: "",
      pdata: {
        page: 1,
        perpage: 20,
        app_id: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chart: {}, list: [], max_page: 1 },
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["访问人数", "新增访问人数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",

          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{ name: "访问人数", type: "line", smooth: true, data: [] }, { name: "新增访问人数", type: "line", smooth: true, data: [] }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      }
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getBasicData)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.cdata = res.data;
          _this.maxPage = res.data.max_page;
          _this.option.xAxis.data = res.data.chart.date;
          _this.option.series[0].data = res.data.chart.visit_uv;
          _this.option.series[1].data = res.data.chart.visit_uv_new;
          _this.drawColumnChart();
        }
      });
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    changeId: function changeId(res) {
      this.pdata.app_id = res;
      this.getList();
    }
  },

  mounted: function mounted() {
    document.getElementById("seven").focus();

    if ((0, _keys2.default)(this.$route.params).length > 0) {
      this.pdata.sdate = this.$route.params.sdate;
      this.pdata.edate = this.$route.params.edate;
      this.pdata.app_id = this.$route.params.app_id;
      this.pholder = this.$route.params.name;
    }
    this.getList();
  }
};

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(66);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      getWhich: "访问分析",
      chartColumn: null,
      pdata: {
        app_id: "",

        sdate: "",
        edate: ""
      },
      plist: [],
      maxPage: 1,
      config: { visit_uv: "访问人数" },
      editDialog: false,
      group: {},

      dateVal: [],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      option: {
        tooltip: { trigger: "axis" },
        legend: { data: ["打开次数"] },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: { type: "category", data: [] },
        yAxis: { type: "value" },
        series: [{ name: "打开次数", type: "line", smooth: true, data: [] }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      },
      option1: {
        tooltip: { trigger: "axis" },
        toolbox: {
          show: true
        },
        xAxis: { type: "category", data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "bar", smooth: true, data: [] }],
        color: ["#61c0a0"]
      },
      option2: {
        tooltip: { trigger: "axis" },
        toolbox: {
          show: true
        },
        xAxis: { type: "category", data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "line", smooth: true, data: [] }],
        color: ["#ec151a"]
      },
      option3: {
        tooltip: { trigger: "axis" },
        toolbox: {
          show: true
        },
        xAxis: { type: "category", data: [] },
        yAxis: { type: "value" },
        series: [{ name: "打开次数", type: "line", smooth: true, data: [] }],
        color: ["#ec151a"]
      },
      option4: {
        tooltip: { trigger: "axis" },
        toolbox: {
          show: true
        },
        xAxis: { type: "category", data: [] },
        yAxis: { type: "value" },
        series: [{ name: "人数", type: "line", smooth: true, data: [] }],
        color: ["#f2e247"]
      },

      o1: {
        tooltip: { trigger: "axis" },
        toolbox: { show: true },
        xAxis: { type: "category", data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "line", smooth: true, data: [] }],
        color: ["#61c0a0"]
      },
      o2: {
        tooltip: { trigger: "axis" },
        toolbox: { show: true },

        xAxis: { type: "category", data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "bar", smooth: true, data: [] }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      },
      o3: {
        tooltip: { trigger: "axis" },
        toolbox: { show: true },
        xAxis: { type: "category", data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "bar", smooth: true, data: [] }],
        color: ["#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      },
      o4: {
        tooltip: { trigger: "axis" },
        toolbox: { show: true },
        xAxis: { type: "category", data: [] },
        yAxis: { type: "value" },
        series: [{ name: "访问人数", type: "bar", smooth: true, data: [] }],
        color: ["#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      }
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      if (this.getWhich == "访问分析") {
        (0, _api.getBasiVisit)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this.cdata = res.data;
            _this.option.xAxis.data = JSON.parse(res.data.chart.dates);
            _this.option.series[0].data = JSON.parse(res.data.chart.data);
            _this.pname = res.data.app_info.name;
            _this.config = res.data.visits;
            _this.drawColumnChart();
          }
        });
      } else if (this.getWhich == "来源分析") {
        if (!this.pdata.source) {
          p += "source=22";
        }
        (0, _api.getBasiFrom)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this.cdata = res.data;
            _this.option1.xAxis.data = JSON.parse(res.data.chart_y1);

            _this.option1.series[0].data = JSON.parse(res.data.chart_x1);
            _this.sources = JSON.parse(res.data.sources);
            _this.option2.xAxis.data = JSON.parse(res.data.chart_x2);
            _this.option2.series[0].data = JSON.parse(res.data.chart_y2);
            _this.option3.xAxis.data = JSON.parse(res.data.chart_y3);
            _this.option3.series[0].data = JSON.parse(res.data.chart_x3);
            _this.option4.xAxis.data = JSON.parse(res.data.chart_y4);
            _this.option4.series[0].data = JSON.parse(res.data.chart_x4);

            _this.pname = res.data.app_info.name;
            _this.config = res.data.visits;
            _this.drawColumnChart1();
          }
        });
      } else {
        (0, _api.getBasiUser)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this.cdata = res.data;
            _this.o1.xAxis.data = JSON.parse(res.data.chart_x1);
            _this.o1.series[0].data = JSON.parse(res.data.chart_y1);
            _this.o2.xAxis.data = JSON.parse(res.data.chart_y4);
            _this.o2.series[0].data = JSON.parse(res.data.chart_x4);
            _this.o3.xAxis.data = JSON.parse(res.data.chart_y5);
            _this.o3.series[0].data = JSON.parse(res.data.chart_x5);
            _this.o4.xAxis.data = JSON.parse(res.data.chart_y6);
            _this.o4.series[0].data = JSON.parse(res.data.chart_x6);
            _this.drawColumnChart2();
          }
        });
      }
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    drawColumnChart1: function drawColumnChart1() {
      this.chartColumn1 = _echarts2.default.init(document.getElementById("chart1"));
      this.chartColumn1.setOption(this.option1);

      this.chartColumn2 = _echarts2.default.init(document.getElementById("chart2"));
      this.chartColumn2.setOption(this.option2);
      this.chartColumn3 = _echarts2.default.init(document.getElementById("chart3"));
      this.chartColumn3.setOption(this.option3);
      this.chartColumn4 = _echarts2.default.init(document.getElementById("chart4"));
      this.chartColumn4.setOption(this.option4);
    },
    drawColumnChart2: function drawColumnChart2() {
      this.chartColumn5 = _echarts2.default.init(document.getElementById("c1"));
      this.chartColumn5.setOption(this.o1);
      this.chartColumn6 = _echarts2.default.init(document.getElementById("c2"));
      this.chartColumn6.setOption(this.o2);
      this.chartColumn7 = _echarts2.default.init(document.getElementById("c3"));
      this.chartColumn7.setOption(this.o3);
      this.chartColumn8 = _echarts2.default.init(document.getElementById("c4"));
      this.chartColumn8.setOption(this.o4);
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = "";
      this.pdata.sdate = new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10);
      this.pdata.edate = new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10);
      this.getList();
    },
    changeGet: function changeGet() {
      this.getList();
    },
    select: function select(ss) {
      this.option.legend.data = [this.config[ss]];
      this.option.series[0].name = this.config[ss];
      this.getList();
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.pdata = this.$route.params;
    this.pdata.type = 1;
    var p = "app_id=" + this.pdata.app_id + "&type=1&visit=visit_uv&sdate=" + this.$route.params.sdate + "&edate=" + this.$route.params.edate;
    (0, _api.getBasiVisit)(p, this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        _this2.cdata = res.data;
        _this2.option.xAxis.data = JSON.parse(res.data.chart.dates);
        _this2.option.series[0].data = JSON.parse(res.data.chart.data);
        _this2.pname = res.data.app_info.name;
        _this2.config = res.data.visits;
        _this2.pdata.visit = "visit_uv";
        _this2.option.legend.data = [_this2.config.visit_uv];
        _this2.option.series[0].name = _this2.config.visit_uv;
        _this2.drawColumnChart();
      }
    });
  }
};

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入渠道名称", trigger: "blur" }],
        channel_id: [{ required: true, message: "请输入渠道号", trigger: "blur" }],
        type: [{ required: true, message: "请选择广告位类型", trigger: "change" }],
        device: [{ required: true, message: "请选择广告位系统", trigger: "change" }],
        issued_app_id: [{ required: true, message: "请选择小程序", trigger: "change" }],
        company: [{ required: true, message: "请输入公司名称", trigger: "change" }],
        ald_channel: [{ required: true, message: "请输入对应渠道，必须与阿拉丁后台填写", trigger: "change" }],
        xsl_from: [{ required: true, message: "请输入xsl_from", trigger: "change" }],
        company_id: [{ required: true, message: "请选择对应公司", trigger: "change" }]
      },
      pdata: {
        page: 1,
        perpage: 20,
        kw: "",
        issued_app_name: "",
        company: ""
      },
      companys: [],
      iname: "",
      pname: "",
      sText: "请选择广告位状态",
      tText: "请选择广告位类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      batchDialog: false,
      form: {
        "log": "新增",
        "issued_app_id": "",
        "xsl_from": "",
        "company": "",
        "company_id": "",
        "atv": "",
        "ald_channel": "",
        "channel_id": "",
        "type": 1,
        "exchange": "0",
        "buy_source": "1",
        "click_price": "",
        "data_source": "1",
        "product_belongs": "1",
        "discount": ""
      },
      batchForm: [],
      batchTips: '导入预览',
      isAdd: false,
      cP: {
        issued_channel_id: "",
        status: "1",
        log: ""
      },
      url: _api.baseUrl + "IssuedAldChannel/preview",
      headers: {
        'token': this.$cookie.getCookie("login")
      }
    };
  },

  methods: {
    downloadTemp: function downloadTemp() {
      window.location.href = '/static/channel.csv';
    },
    batchSuccess: function batchSuccess(response, file, fileList) {

      if (response.code == 200) {
        this.batchForm = response.data;
      }
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getChannelList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.plist = res.data.list;
          _this.maxPage = res.data.max_page;
        }
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.config = this.$store.config.get_channel_price_type;
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    },
    statueFilter: function statueFilter(s) {
      this.sText = s == "" ? "请选择广告位状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择广告位类型" : s;
      this.pdata.type = s;
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editProduct: function editProduct(d) {
      this.editDialog = true;
      this.form = JSON.parse((0, _stringify2.default)(d));
      this.form.channel_id = this.form.id;
      this.form.type = parseInt(this.form.type);
      delete this.form.create_time;
      delete this.form.update_time;
      delete this.form.id;
      this.isAdd = false;
    },
    changeStatus: function changeStatus(isSingle, s) {
      var _this3 = this;

      this.$prompt("请输入编辑原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: "内容不能为空"
      }).then(function (_ref) {
        var value = _ref.value;

        if (isSingle) {
          _this3.cP.channel_id = s.id;
          _this3.cP.status = s.status == 1 ? "0" : "1";
        } else {
          _this3.cP.status = s;
        }
        _this3.cP.log = value;
        (0, _api.getChannelStatus)(_this3.cP, _this3.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this3.getList();
            _this3.$message({ message: "状态修改成功", type: "success" });
          }
        });
      });
    },
    batchProduct: function batchProduct() {
      this.batchDialog = true;
    },
    addProduct: function addProduct() {
      this.form = {
        "issued_app_id": "",
        "xsl_from": "",
        "channel_id": "",
        "company": "",
        "company_id": "",
        "atv": "",
        "type": 1,
        "exchange": "0",
        "buy_source": "1",
        "click_price": "",
        "data_source": "1",
        "product_belongs": "1",
        "discount": ""
      };
      this.isAdd = true;
      this.editDialog = true;
    },
    submit: function submit() {
      var _this4 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          (0, _api.getChannelAdd)(_this4.form, _this4.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this4.getList();
              _this4.editDialog = false;
            } else {
              _this4.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    batchCalcel: function batchCalcel() {
      this.batchDialog = false;
      this.batchForm = [];
      this.batchTips = "导入预览";
    },
    batchSubmit: function batchSubmit() {
      var _this5 = this;

      var p = { "data": (0, _stringify2.default)(this.batchForm) };
      (0, _api.batchAdd)(p, this.$cookie.getCookie("login")).then(function (response) {
        if (response.code == 200) {
          if (response.data.length > 0) {

            _this5.batchForm = response.data;
            _this5.batchTips = "以下数据未成功导入";
          } else {
            _this5.$message({ message: "导入成功", type: "success" });
            _this5.batchDialog = false;
            _this5.batchForm = [];
          }
        } else {
          _this5.$message.error('导入失败');
        }
      });
    },
    select: function select(s) {
      var p = "测";
      s.forEach(function (v, i) {
        p += "," + v.id;
      });
      this.cP.channel_id = p.slice(2);
    },
    getCompany: function getCompany() {
      var _this6 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getIssuedAldCompany)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            _this6.companys = res.data;
          } else {
            _this6.companys = [];
          }
        }
      });
    }
  },

  mounted: function mounted() {
    this.getList();
    this.getCompany();
    this.getConfig();
  },

  watch: {
    'pdata': {
      handler: function handler(n, o) {

        this.pdata = n;
        this.getList();
      },

      deep: true
    }
  }
};

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(54);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(66);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _ref;

    return _ref = {
      chartColumn: null,
      showSelect: true,
      chooseProduct: { name: "", id: '' },
      IssAppList: [],
      pdata: {
        issued_app_id: "",
        page: 1,
        perpage: 20,
        source: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {}
    }, (0, _defineProperty3.default)(_ref, "chooseProduct", { name: "", id: '' }), (0, _defineProperty3.default)(_ref, "pickerOptions", {
      shortcuts: [{
        text: "昨天",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24);
          picker.$emit("pick", [start, start]);
        }
      }, {
        text: "最近一周",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "最近一个月",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "最近三个月",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        }
      }]
    }), (0, _defineProperty3.default)(_ref, "cdata", { total: {}, chat: {}, list: [], max_page: 1 }), (0, _defineProperty3.default)(_ref, "option", {
      tooltip: {
        trigger: "axis"
      },
      legend: {
        data: ["访问人数", "打开次数", "新用户数", "新增授权", "单个用户点击次数"]
      },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: { show: true }
        }
      },
      xAxis: {
        type: "category",

        data: []
      },
      yAxis: {
        type: "value"
      },
      series: [{ name: "访问人数", type: "line", smooth: true, data: [] }, { name: "打开次数", type: "line", smooth: true, data: [] }, { name: "新用户数", type: "line", smooth: true, data: [] }, { name: "新增授权", type: "line", smooth: true, data: [] }, { name: "单个用户点击次数", type: "line", smooth: true, data: [] }],
      color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
    }), _ref;
  },

  watch: {},
  methods: {
    changeProduct: function changeProduct(res) {

      this.$cookie.setCookie("issued_app_id", res.id);
      this.$route.params.issued_app_id = res.id;
      this.pdata.issued_app_id = res.id;
      this.$router.push({
        name: '渠道数据分析列表',
        query: { sdate: this.pdata.sdate, edate: this.pdata.edate }
      });
    },
    getIssAPPList: function getIssAPPList() {
      var _this = this;

      var p = "";
      (0, _api.getIssuedAppList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.IssAppList = res.data;
          _this.IssAppList.forEach(function (v, i) {
            if (v.id == _this.pdata.issued_app_id) {
              _this.chooseProduct.name = v.name;
            }
          });
        }
      });
    },
    selectDate: function selectDate(e) {
      this.pdata.sdate = e;
      this.pdata.edate = e;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getCFXList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this2.cdata.list = res.data.list;
          _this2.maxPage = res.data.max_page;
        }
      });
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.pdata.sdate = new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10);
      this.pdata.edate = new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10);

      this.getList();
    }
  },

  mounted: function mounted() {
    this.getIssAPPList();
    this.pdata.issued_app_id = this.$cookie.getCookie("issued_app_id");
    if (this.pdata.issued_app_id) {
      this.showSelect = false;
      this.$route.params.issued_app_id = this.pdata.issued_app_id;
      this.$router.push({
        name: '渠道数据分析列表',
        query: { sdate: this.pdata.sdate, edate: this.pdata.edate }
      });
    } else {}
  }
};

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(185);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(184);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(66);

var _echarts2 = _interopRequireDefault(_echarts);

var _vuedraggable = __webpack_require__(116);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    draggable: _vuedraggable2.default
  },
  data: function data() {

    return {
      detailDialog: false,
      chartColumn: null,
      pdata: {
        issued_app_id: "",
        page: 1,
        perpage: 20,
        company: "",
        company_id: "",
        source: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),

        status: ''
      },
      chooseAtv: {
        index_id: '',
        atv: '',
        type: ''
      },
      chooseDetailAtv: {
        index_id: '',
        atv: '',
        index: ''
      },
      pDetaildata: {
        issued_app_id: "",
        page: 1,
        perpage: 20,
        source: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      companys: [],
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      editAtvDialog: false,
      editAldChannelDiscountDialog: false,
      editAldChannelDiscountValue: {},
      multipleSelection: [],
      group: {},
      chooseProduct: { name: "", id: '' },
      chooseChannel: { name: "", id: "" },
      IssAppList: [],
      IssuedAldChanneList: [],
      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      dateVal2: [new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      ddata: { total: {}, chat: {}, list: [], max_page: 1 },
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["访问人数", "打开次数", "新用户数", "新增授权", "单个用户点击次数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",

          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{ name: "访问人数", type: "line", smooth: true, data: [] }, { name: "打开次数", type: "line", smooth: true, data: [] }, { name: "新用户数", type: "line", smooth: true, data: [] }, { name: "新增授权", type: "line", smooth: true, data: [] }, { name: "单个用户点击次数", type: "line", smooth: true, data: [] }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      },

      form: {},
      batchDialog: false,
      batchForm: [],
      batchTips: '导入预览',
      batchVal: '',
      url: _api.baseUrl + "/IssuedAldChannel/batchNoticeEnd",
      headers: {
        'token': this.$cookie.getCookie("login")
      },
      drawer: false,
      fieldList: {
        '用户数据': [{
          "name": "uv",
          "key": "visit_uv",
          "isCheck": false
        }, {
          "name": "新增uv",
          "key": "visit_uv_new",
          "isCheck": false
        }, {
          "name": "新增确认点击数",
          "key": "clickok_uv_new",
          "isCheck": false
        }, {
          "name": "活跃确认点击数",
          "key": "clickok_uv",
          "isCheck": false
        }],
        '流量主数据': [{
          "name": "获客单价",
          "key": "atv",
          "isCheck": false
        }, {
          "name": "新增分发arpu",
          "key": "new_arpu_ff",
          "isCheck": false
        }, {
          "name": "新增总arpu",
          "key": "new_arpu",
          "isCheck": false
        }, {
          "name": "活跃分发arpu",
          "key": "uv_arpu_ff",
          "isCheck": false
        }, {
          "name": "活跃总arpu",
          "key": "uv_arpu",
          "isCheck": false
        }],
        '分发数据': [{
          "name": "新增占比",
          "key": "new_per",
          "isCheck": false
        }, {
          "name": "新增跳出",
          "key": "jump_per",
          "isCheck": false
        }, {
          "name": "活跃跳出",
          "key": "uv_jump_per",
          "isCheck": false
        }],
        '收支数据': [{
          "name": "新增回收",
          "key": "new_back_0",
          "isCheck": false
        }, {
          "name": "最高承受单价",
          "key": "hold_price",
          "isCheck": false
        }, {
          "name": "活跃回收",
          "key": "uv_back_0",
          "isCheck": false
        }, {
          "name": "累计回收",
          "key": "total_back_0",
          "isCheck": false
        }],
        '操作': [{
          "name": "下线时间",
          "key": "update_time",
          "isCheck": false

        }]
      },
      selectFieldList: [],
      selectFieldListForModel: {
        '用户数据': [],
        '流量主数据': [],
        '分发数据': [],
        '收支数据': [],
        '操作': []
      },
      showFieldList: [],
      FieldIndex: 0
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    },
    dateVal2: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pDetaildata.sdate = n[0];
          this.pDetaildata.edate = n[1];
          this.showDetail('');
        }
      },

      deep: true
    },
    'pdata.company_id': {
      handler: function handler(n, o) {

        this.pdata.company_id = n;
        this.getList();
      },

      deep: true
    }
  },
  methods: {
    downloadTemp: function downloadTemp(v) {
      if (v == 1) {
        window.location.href = '/static/channel_notice_end.csv';
      } else {
        window.location.href = '/static/channel_end.csv';
      }
    },
    showBatchDialog: function showBatchDialog(v) {
      this.batchDialog = true;
      this.batchTips = '';
      this.batchForm = [];
      this.batchVal = v;
      if (v == 1) {
        this.url = _api.baseUrl + "/IssuedAldChannel/batchNoticeEnd";
      } else if (v == 2) {
        this.url = _api.baseUrl + "/IssuedAldChannel/batchEnd";
      }
    },
    batchSuccess: function batchSuccess(response, file, fileList) {
      debugger;
      if (response.code == 200) {
        this.batchForm = response.data;
        if (this.batchForm.length == 0) {
          this.batchDialog = false;
          this.$message({ message: "批量操作成功！", type: "success" });
        } else {
          this.batchTips = '以下渠道未操作成功';
        }
        this.getList();
      }
    },
    atvDetailEdit: function atvDetailEdit(scope) {

      console.log(scope.$index);
      this.chooseDetailAtv.index = scope.$index;
      this.chooseDetailAtv.index_id = scope.row.index_id;
      this.chooseDetailAtv.atv = scope.row.atv;
      this.ddata.list.map(function (v, i) {
        v.isEdit = false;
      });
      this.ddata.list[scope.$index].isEdit = true;
    },
    fieldListChange: function fieldListChange(tab, event) {
      var _this = this;
      console.log(tab.name);
      this.FieldIndex = tab.name;
      this.setFieldList();
    },
    setFieldList: function setFieldList() {
      var _this = this;
      for (var key in _this.fieldList) {
        _this.fieldList[key].forEach(function (v, i) {
          v.isCheck = false;
        });
      }
      if (this.FieldIndex == 0) {
        this.selectFieldList.forEach(function (vv, ii) {
          for (var key in _this.fieldList) {
            _this.fieldList[key].forEach(function (v, i) {
              if (vv.key == v.key) {
                v.isCheck = true;
              }
            });
          }
        });
        this.showFieldList = JSON.parse((0, _stringify2.default)(this.selectFieldList));
      } else if (this.FieldIndex == 1) {
        for (var key in this.selectFieldListForModel) {

          this.selectFieldListForModel[key].forEach(function (vv, ii) {
            _this.fieldList[key].forEach(function (v, i) {

              if (vv.key == v.key) {

                v.isCheck = true;
              }
            });
          });
        }
        var tempArr = [];
        for (var key in this.selectFieldListForModel) {
          this.selectFieldListForModel[key].forEach(function (v, i) {
            tempArr.push(v);
          });
        }
        this.showFieldList = JSON.parse((0, _stringify2.default)(tempArr));
      }
      this.getList();
    },
    getSelectField: function getSelectField() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var _this, p, data;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this2;
                p = "position=issuedAldData";
                _context.next = 4;
                return getValidProductPlatform(p, _this2.$cookie.getCookie("login"));

              case 4:
                data = _context.sent;

                if (data.code == 200) {
                  if (!_this2.$cookie.getCookie("platform_id")) {
                    _this2.pdata.platform_id = data.data[0].platform_id;
                  }

                  _this2.get_issued_app_platform = data.data;
                }

                _this2.getField();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getField: function getField() {
      var _this3 = this;

      console.log(this.pdata.platform_id);
      var _this = this;
      var p = "position=issuedAldData";
      (0, _api.getfieldFilter)(p, this.$cookie.getCookie("login")).then(function (res) {

        _this3.FieldIndex = res.data.content.FieldIndex;

        console.log(res.data.content);
        if (res.data.content.FieldList == null || res.data.content.FieldList.length == 0) {

          res.data.content.FieldList = ['visit_uv_new', 'visit_uv', 'atv', 'new_per', 'jump_per', 'back_0', 'uv_jump_per', 'uv_back_0', 'total_back_0', 'update_time'];
        }

        _this.selectFieldList = [];
        _this.selectFieldListForModel = {
          '用户数据': [],
          '流量主数据': [],
          '分发数据': [],
          '收支数据': [],
          '操作': []
        };
        _this.showFieldList = [];
        _this.list = [];


        res.data.content.FieldList.forEach(function (vv, ii) {
          for (var key in _this.fieldList) {
            _this.fieldList[key].forEach(function (v, i) {
              if (vv == v.key) {
                v.isCheck = true;
                _this.selectFieldList.push(v);
              }
            });
          }
        });
        for (var key in res.data.content.FieldListForModel) {
          res.data.content.FieldListForModel[key].forEach(function (vv, ii) {
            _this.fieldList[key].forEach(function (v, i) {

              if (vv == v.key) {
                v.isCheck = true;
                _this.selectFieldListForModel[key].push(v);
              }
            });
          });
        }

        if (_this3.FieldIndex == 0) {
          _this3.showFieldList = JSON.parse((0, _stringify2.default)(_this3.selectFieldList));
        } else if (_this3.FieldIndex == 1) {
          var tempArr = [];
          for (var key in _this3.selectFieldListForModel) {

            _this3.selectFieldListForModel[key].forEach(function (v, i) {
              tempArr.push(v);
            });
          }
          _this3.showFieldList = JSON.parse((0, _stringify2.default)(tempArr));
        }
        _this3.getList();
      });
    },
    saveSelectField: function saveSelectField() {
      var _this4 = this;

      var tempArr = [];
      var tempArrModel = {
        '用户数据': [],
        '流量主数据': [],
        '分发数据': [],
        '收支数据': [],
        '操作': []
      };
      this.selectFieldList.forEach(function (v, i) {
        tempArr.push(v.key);
      });

      for (var key in this.selectFieldListForModel) {

        this.selectFieldListForModel[key].forEach(function (v, i) {
          tempArrModel[key].push(v.key);
        });
      }
      var content = {
        FieldIndex: this.FieldIndex,
        FieldList: tempArr,
        FieldListForModel: tempArrModel
      };

      var p = {
        position: 'issuedAldData',
        content: content
      };
      (0, _api.postfieldFilter)(p, this.$cookie.getCookie("login")).then(function (res) {
        _this4.drawer = false;
        _this4.showFieldList = JSON.parse((0, _stringify2.default)(_this4.selectFieldList));
        _this4.getField();
      });
    },
    removeSelectField: function removeSelectField(obj) {
      var _this5 = this;

      this.removeArrForObjName(this.selectFieldList, obj);

      var _loop = function _loop(key) {
        _this5.fieldList[key].some(function (item, index) {
          if (item.name == obj.name) {

            _this5.fieldList[key][index].isCheck = false;
          }
        });
      };

      for (var key in this.fieldList) {
        _loop(key);
      }
    },
    removeSelectFieldForModel: function removeSelectFieldForModel(obj, key) {
      var _this6 = this;

      var _this = this;
      this.removeArrForArrObjName(this.selectFieldListForModel, obj, key);

      this.fieldList[key].some(function (item, index) {
        if (item.name == obj.name) {

          _this6.fieldList[key][index].isCheck = false;
        }
      });
    },
    onMove: function onMove(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedElement = relatedContext.item;
      var draggedElement = draggedContext.item;
    },
    fieldConfig: function fieldConfig() {
      this.drawer = true;
      this.setFieldList();
    },
    fliedTap: function fliedTap(key, index) {
      var _this7 = this;

      this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
      var result = this.selectFieldList.some(function (item) {
        if (item.name == _this7.fieldList[key][index].name) {
          return true;
        }
      });
      if (this.fieldList[key][index].isCheck) {
        if (!result) {
          this.selectFieldList.push(this.fieldList[key][index]);
        }
      } else {
        if (result) {
          this.removeArrForObjName(this.selectFieldList, this.fieldList[key][index]);
        }
      }
    },
    fliedTapForModel: function fliedTapForModel(key, index) {
      var _this8 = this;

      this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
      var result;
      for (var key2 in this.selectFieldListForModel) {
        result = this.selectFieldListForModel[key2].some(function (item) {
          if (item.name == _this8.fieldList[key][index].name) {

            return true;
          }
        });
        if (result) {
          break;
        }
      }

      if (this.fieldList[key][index].isCheck) {
        if (!result) {
          this.selectFieldListForModel[key].push(this.fieldList[key][index]);
        }
      } else {
        if (result) {

          this.removeArrForArrObjName(this.selectFieldListForModel, this.fieldList[key][index], key);
        }
      }
    },
    removeArrForObjName: function removeArrForObjName(_arr, _obj) {
      var length = _arr.length;
      for (var i = 0; i < length; i++) {
        if (_arr[i].name == _obj.name) {
          _arr.splice(i, 1);
          return _arr;
        }
      }
    },
    removeArrForArrObjName: function removeArrForArrObjName(obj, _obj, key) {
      console.log(obj);
      var length = obj[key].length;
      for (var i = 0; i < length; i++) {
        if (obj[key][i].name == _obj.name) {
          obj[key].splice(i, 1);
          console.log(obj);
          return obj;
        }
      }
    },
    getCompany: function getCompany() {
      var _this9 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getIssuedAldCompany)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            _this9.companys = res.data;
          } else {
            _this9.companys = [];
          }
        }
      });
    },
    selectionDisabled: function selectionDisabled(row, index) {
      if (row.pr == '-') {
        return false;
      } else {
        return true;
      }
    },
    handleSelection: function handleSelection(val) {
      this.multipleSelection = val;
    },
    editAldChannelDiscount: function editAldChannelDiscount(row, type) {
      if (row.pr == '-') {
        this.$message({ message: "扣量策略中没有该渠道！", type: "warning" });
        return;
      }
      if (type == 1) {
        this.editAldChannelDiscountValue = {
          issued_app_id: row.issued_app_id,
          channel: row.ald_channel,
          pr: row.pr
        };
      } else if (type == 2) {
        if (row.length <= 0) {
          this.$message({ message: "请选择要批量扣量的行！", type: "warning" });
          return;
        }
        this.editAldChannelDiscountValue = {
          issued_app_id: row[0].issued_app_id,
          channel: row.map(function (item) {
            return item.ald_channel;
          }).join(','),
          pr: row.pr
        };
      }
      this.editAldChannelDiscountDialog = true;
    },
    postAldChannelDiscount: function postAldChannelDiscount() {
      var _this10 = this;

      if (isNaN(this.editAldChannelDiscountValue.pr) || this.editAldChannelDiscountValue.pr > 1 || this.editAldChannelDiscountValue.pr < 0) {
        this.$message({ message: "非法输入值！", type: "warning" });
        return;
      }
      var p = this.editAldChannelDiscountValue;
      (0, _api.PostChannelDiscount)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this10.editAldChannelDiscountDialog = false;
          _this10.$message({ message: "修改成功", type: "success" });
          _this10.getList();
        } else {
          _this10.$message.error('修改失败');
        }
      });
    },
    editAtv: function editAtv(row) {
      this.editAtvDialog = true;
      this.chooseAtv = {
        index_id: row.index_id,
        atv: row.atv,
        type: 1
      };
      switch (row.type) {
        case '阿拉丁':
          this.chooseAtv.type = 1;
          break;
        case '微信':
          this.chooseAtv.type = 2;
          break;
        case '广点通':
          this.chooseAtv.type = 3;
          break;
        case '内部矩阵':
          this.chooseAtv.type = 4;
          break;

      }
      this.$forceUpdate();
    },
    postAtv: function postAtv(type) {
      var _this11 = this;

      if (type == 'detail') {
        var p = this.chooseDetailAtv;
      } else {
        var p = this.chooseAtv;
      }
      (0, _api.AtvEdit)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this11.editAtvDialog = false;
          _this11.$message({ message: "修改成功", type: "success" });
          if (type == 'detail') {
            _this11.ddata.list[_this11.chooseDetailAtv.index].atv = _this11.chooseDetailAtv.atv;
            _this11.ddata.list[_this11.chooseDetailAtv.index].isEdit = false;
          } else {
            _this11.getList();
          }
        } else {
          _this11.$message.error('修改失败');
        }
      });
    },
    tableRowClassName: function tableRowClassName(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;

      if (row.status != 1) {
        return 'warning-row';
      }
      return '';
    },
    selectDate: function selectDate(e) {
      this.pdata.sdate = e;
      this.pdata.edate = e;
      this.getList();
    },
    notifyOff: function notifyOff(index, row, status) {
      var _this12 = this;

      var tip;
      if (status == 0) {
        tip = '通知下线';
      } else if (status == 1) {
        tip = '取消通知下线';
      } else if (status == 2) {
        tip = '截止下线';
      }
      this.$confirm('确定' + tip + '吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {

        (0, _api.notifyOff)({ "channel_id": row.channel_id, "status": status }, _this12.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this12.$message({ message: tip + '成功！', type: "success" });

            _this12.getList();
          } else {
            _this12.$message.error('操作失败');
          }
        });
      }).catch(function () {});
    },
    showDetail: function showDetail(s) {
      var _this13 = this;

      this.detailDialog = true;
      if (s) {
        this.pDetaildata.channel_id = s.channel_id;
        this.pDetaildata.issued_app_id = s.issued_app_id;
      }
      var p = "";
      for (var k in this.pDetaildata) {
        if (this.pDetaildata[k]) p += k + "=" + this.pDetaildata[k] + "&";
      }
      (0, _api.getCFXDataListDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            res.data.list.map(function (v, i) {
              v.isEdit = false;
            });
            _this13.ddata.list = res.data.list;
          } else {
            _this13.ddata.list = [];
          }
        }
      });
    },
    goback: function goback() {
      this.$router.back(-1);
    },
    changeProduct: function changeProduct(res) {
      this.$cookie.setCookie("issued_app_id", res.id);
      this.$route.params.issued_app_id = res.id;
      this.pdata.issued_app_id = res.id;
      this.getList();
      this.getIssuedChanneList();
    },
    changeChannel: function changeChannel(res) {

      this.pdata.kw = res.ald_channel;
      this.getList();
    },
    clearChannel: function clearChannel(res) {
      this.pdata.kw = this.chooseChannel.name;
      this.getList();
    },
    getIssAPPList: function getIssAPPList() {
      var _this14 = this;

      var p = "";
      (0, _api.getIssuedAppList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this14.IssAppList = res.data;
          _this14.IssAppList.forEach(function (v, i) {
            if (v.id == _this14.pdata.issued_app_id) {
              _this14.chooseProduct.name = v.name;
            }
          });
        }
      });
    },
    getIssuedChanneList: function getIssuedChanneList() {
      var _this15 = this;

      var p = "issued_app_id=" + this.pdata.issued_app_id;
      (0, _api.getIssuedAldChanneList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this15.IssuedAldChanneList = res.data.list;
        }
      });
    },
    getConfig: function getConfig() {
      var _this16 = this;

      if (this.$store.config) {
        this.config = this.$store.config.get_channel_price_type;
      } else {
        setTimeout(function () {
          _this16.getConfig();
        }, 50);
      }
    },
    getList: function getList() {
      var _this17 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getCFXDataList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          _this17.cdata.list = res.data.list;
          _this17.cdata.total = res.data.total;
          _this17.maxPage = res.data.max_page;
        }
      });
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    statusChange: function statusChange(v) {
      this.pdata.status = v;
      this.cdata.list = [];
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10)];
    }
  },
  mounted: function mounted() {

    this.pdata.issued_app_id = this.$route.params.issued_app_id;
    if (this.$route.query.sdate != undefined) {
      this.pdata.sdate = this.$route.query.sdate;
    }
    if (this.$route.query.edate != undefined) {
      this.pdata.edate = this.$route.query.edate;
    }
    this.dateVal = [this.pdata.sdate, this.pdata.edate];

    this.getIssAPPList();
    this.getIssuedChanneList();
    this.getConfig();
    this.getCompany();
    this.getField();
    document.getElementById('yesterday').focus();
  }
};

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(66);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      chartColumn: null,
      pdata: {
        issued_app_id: "",
        channel_id: "",
        page: 1,
        perpage: 20,
        source: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["访问人数", "打开次数", "新用户数", "新增授权", "单个用户点击次数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",

          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{ name: "访问人数", type: "line", smooth: true, data: [] }, { name: "打开次数", type: "line", smooth: true, data: [] }, { name: "新用户数", type: "line", smooth: true, data: [] }, { name: "新增授权", type: "line", smooth: true, data: [] }, { name: "单个用户点击次数", type: "line", smooth: true, data: [] }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      }
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    goback: function goback() {

      this.$router.back(-1);
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getCFXDataListDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.cdata.list = res.data.list;
          _this.maxPage = res.data.max_page;
        }
      });
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    }
  },
  mounted: function mounted() {
    this.pdata.issued_app_id = this.$route.params.issued_app_id;
    this.pdata.channel_id = this.$route.params.channel_id;
    if (this.$route.query.sdate != undefined) {
      this.pdata.sdate = this.$route.query.sdate;
    }
    if (this.$route.query.edate != undefined) {
      this.pdata.edate = this.$route.query.edate;
    }
    this.dateVal = [this.pdata.sdate, this.pdata.edate];
    document.getElementById('seven').focus();
  }
};

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(265);

var _assign2 = _interopRequireDefault(_assign);

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(66);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        issued_app_id: "",
        platform_id: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },

      card: {},
      cardParams: [{ "name": "visit_uv_new", "isLoading": true }, { "name": "visit_uv", "isLoading": true }, { "name": "sell_data", "isLoading": true }, { "name": "origin_income", "isLoading": true }, { "name": "buy_data", "isLoading": true }, { "name": "cp_data", "isLoading": true }, { "name": "profit_data", "isLoading": true }, { "name": "profit_rate", "isLoading": true }],
      cardIndex: 0,
      chart: {},
      chartParams: [{ "name": "visit_uv_new", "isLoading": true }, { "name": "visit_uv", "isLoading": true }, { "name": "sell_data", "isLoading": true }, { "name": "origin_income", "isLoading": true }, { "name": "buy_data", "isLoading": true }, { "name": "cp_data", "isLoading": true }, { "name": "profit_data", "isLoading": true }],
      chartIndex: 0,
      loading: false,
      loadingChart: false,

      get_issued_app_platform: [],
      pholder: "",
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},
      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      option: {
        title: {
          text: '折线图堆叠'
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["新增访问人数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{ name: "新增访问人数", type: "line", smooth: true, data: [] }],
        color: ["#ee4f54"]
      },
      color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.chartIndex = 0;
          this.chartParams.map(function (v, i) {
            v.isLoading = true;
            return v;
          });
          this.getDataChart();
        }
      },

      deep: true
    }
  },
  methods: {
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    getDataBorad: function getDataBorad() {
      var _this = this;
      _this.cardParams[_this.cardIndex].isLoading = true;
      var p = "module=card&fragment=" + _this.cardParams[_this.cardIndex].name + "&";
      for (var k in _this.pdata) {
        if (_this.pdata[k]) p += k + "=" + _this.pdata[k] + "&";
      }
      (0, _api.getSummaryIndex)(p, _this.$cookie.getCookie("login")).then(function (res) {

        if (res.code == 200) {
          console.log(_this.card);
          _this.cardParams[_this.cardIndex].isLoading = false;
          (0, _assign2.default)(_this.card, res.data.card);


          _this.cardIndex++;
          if (_this.cardIndex < 8) {
            _this.getDataBorad();
          } else {
            _this.chartIndex = 0;
            _this.chartParams.map(function (v, i) {
              v.isLoading = true;
              return v;
            });
            _this.getDataChart();
          }
        }
      });
    },
    getDataChart: function getDataChart() {
      var _this = this;
      _this.chartParams[_this.chartIndex].isLoading = true;
      var p = "module=chart&fragment=" + _this.chartParams[_this.chartIndex].name + "&";
      for (var k in _this.pdata) {
        if (_this.pdata[k]) p += k + "=" + _this.pdata[k] + "&";
      }
      (0, _api.getSummaryIndex)(p, _this.$cookie.getCookie("login")).then(function (res) {

        _this.chartParams[_this.chartIndex].isLoading = false;
        if (res.code == 200) {
          var option_date = [];
          var option_series_data = [];
          if (res.data.chart) {
            for (var key in res.data.chart[_this.chartParams[_this.chartIndex].name]) {
              option_date.push(key);
              option_series_data.push(res.data.chart[_this.chartParams[_this.chartIndex].name][key]);
            }

            _this.option.xAxis.data = option_date;

            switch (_this.chartParams[_this.chartIndex].name) {
              case 'visit_uv_new':
                _this.option.series[0] = { name: "累计新增", type: "line", smooth: true, data: option_series_data };
                _this.option.title.text = "累计新增";
                _this.option.color[0] = _this.color[0];
                break;
              case 'visit_uv':
                _this.option.series[0] = { name: "活跃", type: "line", smooth: true, data: option_series_data };
                _this.option.title.text = "累计活跃";
                _this.option.color[0] = _this.color[1];
                break;
              case 'origin_income':
                _this.option.series[0] = { name: "广告收入", type: "line", smooth: true, data: option_series_data };
                _this.option.title.text = "广告收入";
                _this.option.color[0] = _this.color[2];
                break;
              case 'buy_data':
                _this.option.series[0] = { name: "买量支出", type: "line", smooth: true, data: option_series_data };
                _this.option.title.text = "买量支出";
                _this.option.color[0] = _this.color[3];
                break;
              case 'cp_data':
                _this.option.series[0] = { name: "CP分成", type: "line", smooth: true, data: option_series_data };
                _this.option.title.text = "CP分成";
                _this.option.color[0] = _this.color[4];
                break;
              case 'profit_data':
                _this.option.series[0] = { name: "发行利润", type: "line", smooth: true, data: option_series_data };
                _this.option.title.text = "发行利润";
                _this.option.color[0] = _this.color[5];
                break;
              case 'sell_data':
                _this.option.series[0] = { name: "卖量含矩阵", type: "line", smooth: true, data: option_series_data };
                _this.option.title.text = "卖量含矩阵";
                _this.option.color[0] = _this.color[6];
                break;
            }

            _this.drawColumnChart(JSON.parse((0, _stringify2.default)(_this.option)), _this.chartParams[_this.chartIndex].name);
            _this.chartIndex++;
          }

          if (_this.chartIndex < 7) {
            _this.getDataChart();
          }
        }
      });
    },
    getSelectField: function getSelectField() {
      var _this2 = this;

      var _this = this;
      var p = "position=product_daily_index";
      (0, _api.getValidProductPlatform)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this2.get_issued_app_platform = res.data;
        }
      });
    },
    drawColumnChart: function drawColumnChart(otpins, string) {
      this.chartColumn = _echarts2.default.init(document.getElementById('option_' + string));
      this.chartColumn.setOption(otpins);
    },
    updateBuy: function updateBuy(id) {
      console.log(id);
    },
    getField: function getField() {
      this.cardIndex = 0;
      this.cardParams.map(function (v, i) {
        v.isLoading = true;
        return v;
      });
      this.getDataBorad();
    },
    changeId: function changeId(res) {
      this.pdata.issued_app_id = res;
      this.cardIndex = 0;
      this.cardParams.map(function (v, i) {
        v.isLoading = true;
        return v;
      });
      this.getDataBorad();
    }
  },
  created: function created() {
    this.getSelectField();
    this.cardIndex = 0;
    this.cardParams.map(function (v, i) {
      v.isLoading = true;
      return v;
    });
    this.getDataBorad();
  },
  update: function update() {},
  mounted: function mounted() {

    var _this = this;
  }
};

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(71);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(54);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _methods;

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

var _vuedraggable = __webpack_require__(116);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

	components: {
		draggable: _vuedraggable2.default
	},
	data: function data() {
		return {
			chartColumn: null,
			pholder: "",
			pdata: {
				page: 1,
				perpage: 20,
				platform_id: 1,
				issued_app_id: "137",
				kw: "",
				sdate: new Date(new Date().getTime() - 3600 * 1000 * 24 * 7).toISOString().slice(0, 10),
				edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
			},
			tText: "请选择创意类型",
			plist: [],
			applist: [],
			maxPage: 1,
			config: [],
			editDialog: false,
			batchForm: [],
			url: _api.baseUrl + "/issuedAldChannelGdt/previewTf",
			headers: {
				'token': this.$cookie.getCookie("login")
			},
			batchDialog: false,
			batchTips: 0,
			importType: '',
			checks: [],
			isIndeterminate: false,
			checkAll: false,
			group: {},

			dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 7).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
			pickerOptions: {
				shortcuts: [{
					text: "昨天",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24);
						picker.$emit("pick", [start, start]);
					}
				}, {
					text: "最近一周",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
						picker.$emit("pick", [start, end]);
					}
				}, {
					text: "最近一个月",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit("pick", [start, end]);
					}
				}, {
					text: "最近三个月",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit("pick", [start, end]);
					}
				}]
			},
			list: [],
			total: {},
			get_issued_app_platform: [],
			height: 900,
			drawer: false,

			fieldList: {
				'用户数据': [{
					"name": "新增",
					"key": "visit_uv_new",
					"isCheck": false
				}, {
					"name": "活跃",
					"key": "visit_uv",
					"isCheck": false
				}, {
					"name": "新增占比",
					"key": "visit_uv_new_per",
					"isCheck": false
				}, {
					"name": "点击数",
					"key": "gdt_click",
					"isCheck": false
				}, {
					"name": "流失",
					"key": "leave",
					"isCheck": false
				}, {
					"name": "新增跳出率",
					"key": "visit_uv_new_jump",
					"isCheck": false
				}, {
					"name": "活跃跳出率",
					"key": "visit_uv_jump",
					"isCheck": false
				}],
				'收支数据': [{
					"name": "获客点击单价",
					"key": "click_price",
					"isCheck": false
				}, {
					"name": "新增单价",
					"key": "visit_uv_new_price",
					"isCheck": false
				}, {
					"name": "活跃单价",
					"key": "visit_uv_price",
					"isCheck": false
				}, {
					"name": "新增arpu",
					"key": "visit_uv_new_arpu",
					"isCheck": false
				}, {
					"name": "活跃arpu",
					"key": "visit_uv_arpu",
					"isCheck": false
				}, {
					"name": "原生收入",
					"key": "origin_income",
					"isCheck": false
				}, {
					"name": "原生arpu",
					"key": "origin_arpu",
					"isCheck": false
				}, {
					"name": "收入",
					"key": "gdt_income",
					"isCheck": false
				}, {
					"name": "花费",
					"key": "gdt_cost",
					"isCheck": false
				}],
				'回收': [{
					"name": "新增当日回收",
					"key": "visit_uv_new_back_0",
					"isCheck": false
				}, {
					"name": "活跃当日回收",
					"key": "visit_uv_back_0",
					"isCheck": false
				}, {
					"name": "累计当日回收",
					"key": "total_back_0",
					"isCheck": false
				}]
			},
			selectFieldList: [],
			showFieldList: []
		};
	},

	watch: {
		dateVal: {
			handler: function handler(n, o) {
				if (n[0]) {
					this.pdata.sdate = n[0];
					this.pdata.edate = n[1];
					this.getField();
				}
			},

			deep: true
		},
		"pdata.issued_app_id": {
			handler: function handler(n, o) {
				debugger;
				this.getField();
			},

			deep: true
		}
	},
	methods: (_methods = {
		expands: function expands(r, es) {
			var _this2 = this;

			var isshou = false;
			if (es.length > 0) {
				es.forEach(function (v) {
					if (v.issued_app_id == r.issued_app_id) {
						isshou = true;
					}
				});
			}
			if (isshou) {
				var p = "issued_app_id=" + r.issued_app_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];

				(0, _api.getGDBackTListChannel)(p, this.$cookie.getCookie("login")).then(function (res) {
					if (res.code == 200) {
						if (res.data.list && res.data.list.length > 0) {
							res.data.list.forEach(function (v, i) {
								v.keyid = 'ckey' + i;
								v.exData = [];
							});
							r.exData = res.data.list;
						} else {
							r.exData = [];
						}

						_this2.$forceUpdate();
					}
				});
			}
		},
		expandsChannel: function expandsChannel(r, es) {
			var _this3 = this;

			var isshou = false;
			if (es.length > 0) {
				es.forEach(function (v) {
					if (v.channel_id == r.channel_id) {
						isshou = true;
					}
				});
			}
			if (isshou) {
				var p = "issued_app_id=" + r.issued_app_id + "&channel_id=" + r.channel_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];

				(0, _api.getGDBackTListChannelDate)(p, this.$cookie.getCookie("login")).then(function (res) {
					if (res.code == 200) {
						res.data.list.forEach(function (v, i) {
							v.keyid = 'dkey' + i;
							v.exData = [];
						});
						r.exData = res.data.list;
						_this3.$forceUpdate();
					}
				});
			}
		},
		downloadTemp: function downloadTemp(type) {
			if (type == 1) {
				window.location.href = '/static/tfdata.csv';
			} else {
				window.location.href = '/static/fxdata.csv';
			}
		},
		importData: function importData(type) {
			this.batchDialog = true;
			this.importType = type;
			if (type == 1) {
				this.url = _api.baseUrl + '/issuedAldChannelGdt/previewTf';
			} else if (type == 2) {
				this.url = _api.baseUrl + '/issuedAldChannelGdt/previewFx';
			}
		},
		batchSuccess: function batchSuccess(response, file, fileList) {
			if (response.code == 200) {
				this.batchForm = response.data;
			}
		},
		batchCalcel: function batchCalcel() {
			this.batchDialog = false;
			this.batchForm = [];
			this.batchTips = 0;
		},
		batchSubmit: function batchSubmit() {
			var _this4 = this;

			var p = {
				"data": this.batchForm
			};
			if (this.importType == 1) {
				(0, _api.batchGDTAddTF)(p, this.$cookie.getCookie("login")).then(function (response) {
					if (response.code == 200) {
						if (response.data.length > 1) {
							_this4.batchForm = response.data;
							_this4.batchTips = "1";
						} else {
							_this4.$message({
								message: "导入成功",
								type: "success"
							});
							_this4.batchDialog = false;
							_this4.batchForm = [];
							_this4.getList();
						}
					} else {

						_this4.$message.error('导入失败');
					}
				});
			} else if (this.importType == 2) {
				(0, _api.batchGDTAddFX)(p, this.$cookie.getCookie("login")).then(function (response) {
					if (response.code == 200) {
						if (response.data.length > 1) {
							_this4.batchForm = response.data;
							_this4.batchTips = "1";
						} else {
							_this4.$message({
								message: "导入成功",
								type: "success"
							});
							_this4.batchDialog = false;
							_this4.batchForm = [];
							_this4.getList();
						}
					} else {
						_this4.$message.error('导入失败');
					}
				});
			}
		},
		getField: function getField() {
			var _this5 = this;

			var _this = this;
			var p = "position=gdt_index";
			(0, _api.getfieldFilter)(p, this.$cookie.getCookie("login")).then(function (res) {
				console.log(res.data.content);
				if (res.data.content.length == 0) {
					res.data.content = ['visit_uv_new', 'visit_uv', 'click_price', 'visit_uv_price', 'visit_uv_jump', 'origin_arpu', 'visit_uv_back_0', 'total_back_0'];
				}
				_this.selectFieldList = [];
				_this.showFieldList = [];
				_this.list = [];
				res.data.content.forEach(function (vv, ii) {
					for (var key in _this.fieldList) {
						_this.fieldList[key].forEach(function (v, i) {

							if (vv == v.key) {
								v.isCheck = true;
								_this.selectFieldList.push(v);
							}
						});
					}
				});
				_this5.showFieldList = JSON.parse((0, _stringify2.default)(_this5.selectFieldList));
				_this5.getList();
			});
		},
		saveSelectField: function saveSelectField() {
			var _this6 = this;

			var tempArr = [];
			this.selectFieldList.forEach(function (v, i) {
				tempArr.push(v.key);
			});
			var p = {
				position: 'gdt_index',
				content: tempArr
			};
			(0, _api.postfieldFilter)(p, this.$cookie.getCookie("login")).then(function (res) {
				_this6.drawer = false;
				_this6.showFieldList = JSON.parse((0, _stringify2.default)(_this6.selectFieldList));
				_this6.getField();
			});
		},
		removeSelectField: function removeSelectField(obj) {
			var _this7 = this;

			this.removeArrForObjName(this.selectFieldList, obj);
			var fieldList_key;
			var fieldList_index;

			var _loop = function _loop(key) {
				_this7.fieldList[key].some(function (item, index) {
					if (item.name == obj.name) {
						fieldList_key = key;
						_this7.fieldList[key][index].isCheck = false;
					}
				});
			};

			for (var key in this.fieldList) {
				_loop(key);
			}
		},
		onMove: function onMove(_ref) {
			var relatedContext = _ref.relatedContext,
			    draggedContext = _ref.draggedContext;

			var relatedElement = relatedContext.item;
			var draggedElement = draggedContext.item;
		},
		fieldConfig: function fieldConfig() {
			this.drawer = true;
		},
		fliedTap: function fliedTap(key, index) {
			var _this8 = this;

			this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
			var result = this.selectFieldList.some(function (item) {
				if (item.name == _this8.fieldList[key][index].name) {
					return true;
				}
			});
			if (this.fieldList[key][index].isCheck) {
				if (!result) {
					this.selectFieldList.push(this.fieldList[key][index]);
				}
			} else {
				if (result) {
					this.removeArrForObjName(this.selectFieldList, this.fieldList[key][index]);
				}
			}
		},
		removeArrForObjName: function removeArrForObjName(_arr, _obj) {
			var length = _arr.length;
			for (var i = 0; i < length; i++) {
				if (_arr[i].name == _obj.name) {
					_arr.splice(i, 1);
					return _arr;
				}
			}
		},
		handleCheckAllChange: function handleCheckAllChange(val) {
			this.checks = val ? this.checklist : [];
			this.isIndeterminate = false;
		},
		handleCheckedChange: function handleCheckedChange(value) {

			var checkedCount = value.length;
			this.checkAll = checkedCount === this.checklist.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.checklist.length;
			this.checks = value;
		},
		changeDate: function changeDate(s) {
			this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10)];
		},
		getSummaries: function getSummaries(param) {
			var columns = param.columns,
			    data = param.data;

			var sums = [];
			columns.forEach(function (column, index) {
				if (index === 0) {
					sums[index] = '合计';
					return;
				}
				if (index === 3 || index === 4 || index === 5 || index === 7 || index == 11 || index === 12 || index === 8) {
					sums[index] = 'N/A';
					return;
				}

				var values = data.map(function (item) {
					return Number(item[column.property]);
				});
				if (!values.every(function (value) {
					return isNaN(value);
				})) {
					if (index === 6 || index === 9 || index === 10 || index === 13 || index === 15 || index === 16) {
						sums[index] = '￥' + values.reduce(function (prev, curr) {
							var value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0).toFixed(2);
					} else {
						sums[index] = values.reduce(function (prev, curr) {
							var value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0).toFixed(2);
					}
				} else {
					sums[index] = 'N/A';
				}
			});

			return sums;
		},
		getList: function getList() {
			var _this9 = this;

			var p = "";
			for (var k in this.pdata) {
				if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
			}
			(0, _api.getGDBackTList)(p, this.$cookie.getCookie("login")).then(function (res) {
				if (res.code == 200) {
					if (res.data.list && res.data.list.length > 0) {
						res.data.list.forEach(function (x, i) {
							x.keyid = 'key' + i;
							x.exData = [];
						});
						_this9.list = res.data.list;
						_this9.total = res.data.total;
						_this9.maxPage = res.data.count;
					} else {
						_this9.list = [];

						_this9.maxPage = 1;
					}
				}
			});
		},
		SizeChange: function SizeChange(v) {
			this.pdata.perpage = v;
			this.getList();
		},
		CurrentChange: function CurrentChange(v) {
			this.pdata.page = v;
			this.getList();
		}
	}, (0, _defineProperty3.default)(_methods, "changeDate", function changeDate(s) {
		this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
	}), (0, _defineProperty3.default)(_methods, "changeId", function changeId(res) {
		this.pdata.issued_app_id = res;
		this.getField();
	}), (0, _defineProperty3.default)(_methods, "getPlatFormList", function getPlatFormList() {
		var _this10 = this;

		var p = '';
		(0, _api.getValidProductPlatform)(p, this.$cookie.getCookie("login")).then(function (res) {
			if (res.code == 200) {
				_this10.get_issued_app_platform = res.data;
			}
		});
	}), (0, _defineProperty3.default)(_methods, "changePlatform", function changePlatform() {
		this.applist = [];
		this.pdata.issued_app_id = '';
		this.getAppList();
		this.getField();
		this.getAppList();
	}), (0, _defineProperty3.default)(_methods, "getAppList", function getAppList() {
		var _this11 = this;

		(0, _api.getIssuedAppList)("page=1&perpage=1000&kw=issued&platform_id=" + this.pdata.platform_id, this.$cookie.getCookie("login")).then(function (res) {

			if (res.code == 200) {
				_this11.applist = res.data;

				_this11.getField();
			}
		});
	}), _methods),

	created: function created() {

		console.log((0, _jquery2.default)(window).height() - 200);
		this.height = (0, _jquery2.default)(window).height() - 200;
	},
	mounted: function mounted() {

		if ((0, _keys2.default)(this.$route.params).length > 0) {
			this.pdata.sdate = this.$route.params.sdate;
			this.pdata.edate = this.$route.params.edate;
		}
		this.getPlatFormList();
		this.getAppList();
	}
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(54);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _api = __webpack_require__(8);

var _uploadImg = __webpack_require__(1119);

var _uploadImg2 = _interopRequireDefault(_uploadImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UploadImg: _uploadImg2.default
  },
  data: function data() {
    var _ref;

    return _ref = {
      rules: {
        name: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
        short_name: [{ required: true, message: "请输入短名称", trigger: "blur" }],
        appid: [{ required: true, message: "请输入产品appid", trigger: "blur" }],
        icon: [{ required: true, message: "请上传产品图片", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],

        appsecret: [{ required: true, message: "请输入appsecret", trigger: "blur" }]
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        type: "",
        source: "",
        kw: ""
      },
      plist: [],
      maxPage: 1,
      product_theme: [],
      app_body: [],
      tags: [],
      issued_app_source: [],
      game_miniprogram_account: [],
      chooseProduct: {},
      editDialog: false,
      formLabelWidth: "120px",
      chooseTags: [],
      plog: [],
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      imageUrl: "",

      headMsg: {
        token: ""
      }
    }, (0, _defineProperty3.default)(_ref, "imageUrl", ""), (0, _defineProperty3.default)(_ref, "isAdd", false), (0, _defineProperty3.default)(_ref, "cP", {
      app_id: "",
      status: "1",
      log: ""
    }), (0, _defineProperty3.default)(_ref, "companyList", []), _ref;
  },

  watch: {
    "chooseTags.length": {
      handler: function handler(n, o) {
        this.chooseProduct.divide = this.chooseTags.join(",");
      },

      deep: true
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      p = p.slice(0, -1);
      (0, _api.getPlist)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.plist = res.data.list;
          _this.maxPage = res.data.max_page;
        }
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;

      if (this.$store.config) {
        this.product_theme = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.app_body = this.$store.config.app_body;
        this.game_miniprogram_account = this.$store.config.game_miniprogram_account;
        this.issued_app_source = this.$store.config.issued_app_source;
        this.get_issued_app_platform = this.$store.config.get_issued_app_platform;
        if (this.game_miniprogram_account.indexOf('无') == -1) {
          this.game_miniprogram_account.unshift('无');
        }
      } else {
        setTimeout(function () {
          _this2.getConfig();
        }, 50);
      }
    },
    statueFilter: function statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter: function themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    search: function search() {
      this.getList();
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editProduct: function editProduct(d) {
      this.editDialog = true;
      this.chooseProduct = JSON.parse((0, _stringify2.default)(d));
      this.chooseProduct.app_id = this.chooseProduct.id;
      this.chooseProduct.game_miniprogram_account = parseInt(this.chooseProduct.game_miniprogram_account);
      this.chooseProduct.platform_id = parseInt(this.chooseProduct.platform_id);
      this.chooseTags = this.chooseProduct.divide.split(",");
      this.isAdd = false;
    },
    changeStatus: function changeStatus(isSingle, s) {
      var _this3 = this;

      this.$prompt("请输入编辑原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: "内容不能为空"
      }).then(function (_ref2) {
        var value = _ref2.value;

        if (isSingle) {
          _this3.cP.app_id = s.id;
          _this3.cP.status = s.status == 1 ? "0" : "1";
        } else {
          _this3.cP.status = s;
        }
        _this3.cP.log = value;
        (0, _api.getPStatus)(_this3.cP, _this3.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this3.getList();
            _this3.$message({ message: "状态修改成功", type: "success" });
          }
        });
      });
    },
    addProduct: function addProduct() {
      this.chooseProduct = {
        name: "",
        short_name: "",
        rename: "",
        icon: "",
        type: "休闲",
        source: "内部游戏",
        cp_company_id: '',
        divide: "原生",
        divide_per: "",
        body: "个人",
        appid: "",
        email: "",
        appsecret: "",
        game_miniprogram_account: 0,
        ald_app_key: "",
        log: "新增产品",
        real_time_chart: "0",
        isbox: "0" };
      this.editDialog = true;
      this.chooseTags = ["原生"];
      this.isAdd = true;
    },
    submit: function submit() {
      var _this4 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (!_this4.isAdd) {
            _this4.chooseProduct.log = "编辑内容";
          }
          (0, _api.getPAdd)(_this4.chooseProduct, _this4.$cookie.getCookie("login")).then(function (res) {
            if (res.code == 200) {
              _this4.getList();
              _this4.editDialog = false;
            } else {
              _this4.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    select: function select(s) {
      var p = "测";
      s.forEach(function (v, i) {
        p += "," + v.id;
      });
      this.cP.app_id = p.slice(2);
    },
    openDealy: function openDealy(id) {
      var _this5 = this;

      splog(id, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this5.logDialog = true;
          _this5.plog = res.data;
        } else {
          _this5.$message.error(res.msg);
        }
      });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getInfo: function getInfo(s) {
      this.chooseProduct = JSON.parse((0, _stringify2.default)(s));
      this.chooseTags = this.chooseProduct.tags.split(",");
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.getList();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    (0, _api.getCPCompanyList)('', this.$cookie.getCookie("login")).then(function (res) {
      if (res.code == 200) {
        if (res.data && res.data.list.length > 0) {
          _this6.companyList = res.data.list;
        }
      }
    });
  }
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(66);

var _echarts2 = _interopRequireDefault(_echarts);

var _vuedraggable = __webpack_require__(116);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    draggable: _vuedraggable2.default
  },
  data: function data() {
    return {
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        page: 1,
        perpage: 20,
        source: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["总访问人数", "总新增访问人数", "总收入", "利润", "买量成本", "ROI"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",

          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{ name: "总访问人数", type: "line", smooth: true, data: [] }, { name: "总新增访问人数", type: "line", smooth: true, data: [] }, { name: "总收入", type: "line", smooth: true, data: [] }, { name: "利润", type: "line", smooth: true, data: [] }, { name: "买量成本", type: "line", smooth: true, data: [] }, { name: "ROI", type: "line", smooth: true, data: [] }],
        color: ["#61c0a0", "#ee4f54", "#8ec1b0", "#a6e8ba", "#ceead4", "#f2e247", "#f6e98b", "#f77b31", "#fc9656", "#ec151a", "#ee4f54", "#ee2159", "#fbaaa6"]
      },
      height: 600,
      drawer: false,
      fieldList: {
        '用户数据': [{
          "name": "活跃用户",
          "key": "visit_uv",
          "isCheck": false
        }, {
          "name": "注册用户",
          "key": "visit_uv_new",
          "isCheck": false
        }],
        '收入数据': [{
          "name": "总流水",
          "key": "total_flow",
          "isCheck": false
        }, {
          "name": "总收入",
          "key": "total_income",
          "isCheck": false
        }, {
          "name": "广告流水",
          "key": "origin_income",
          "isCheck": false
        }, {
          "name": "广告发行分成",
          "key": "origin_divide_income",
          "isCheck": false
        }, {
          "name": "分发矩阵收入",
          "key": "matrix_income",
          "isCheck": false
        }, {
          "name": "分发非矩阵收入",
          "key": "nonmatrix_income",
          "isCheck": false
        }, {
          "name": "分发合计",
          "key": "distribution_income",
          "isCheck": false
        }],
        '支出数据': [{
          "name": "总支出",
          "key": "total_cost",
          "isCheck": false
        }, {
          "name": "cp分成",
          "key": "cp_cost",
          "isCheck": false
        }, {
          "name": "买量",
          "key": "expenses_cost",
          "isCheck": false
        }],
        '分发数据': [{
          "name": "跳出率",
          "key": "jump_per",
          "isCheck": false
        }, {
          "name": "换入活跃",
          "key": "huanliang_in",
          "isCheck": false
        }, {
          "name": "换出活跃",
          "key": "huanliang_out",
          "isCheck": false
        }, {
          "name": "分发收入（含矩阵）",
          "key": "distribution_income",
          "isCheck": false
        }, {
          "name": "arpu（含矩阵）",
          "key": "distribution_day_contribution",
          "isCheck": false
        }, {
          "name": "分发收入（不含矩阵）",
          "key": "nonmatrix_income",
          "isCheck": false
        }, {
          "name": "arpu（不含矩阵）",
          "key": "nonmatrix_day_contribution",
          "isCheck": false
        }, {
          "name": "总arpu",
          "key": "total_day_contribution",
          "isCheck": false
        }],
        '利润': [{
          "name": "利润",
          "key": "profit",
          "isCheck": false
        }, {
          "name": "ROI",
          "key": "roi",
          "isCheck": false
        }, {
          "name": "单个用户价值",
          "key": "arpu",
          "isCheck": false
        }]
      },
      selectFieldList: [],
      showFieldList: []
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    }
  },
  methods: {
    getField: function getField() {
      var _this2 = this;

      console.log(this.pdata.platform_id);

      var _this = this;
      var p = "position=maindata_index";
      (0, _api.getfieldFilter)(p, this.$cookie.getCookie("login")).then(function (res) {
        console.log(res.data.content);
        if (res.data.content == null || res.data.content.length == 0) {

          res.data.content = ['visit_uv', 'visit_uv_new', 'total_income', 'total_cost', 'profit', 'roi', 'arpu'];
        }
        _this.selectFieldList = [];
        _this.showFieldList = [];
        _this.list = [];
        res.data.content.forEach(function (vv, ii) {
          for (var key in _this.fieldList) {
            _this.fieldList[key].forEach(function (v, i) {

              if (vv == v.key) {
                v.isCheck = true;
                _this.selectFieldList.push(v);
              }
            });
          }
        });
        _this2.showFieldList = JSON.parse((0, _stringify2.default)(_this2.selectFieldList));
        _this2.getList();
      });
    },
    saveSelectField: function saveSelectField() {
      var _this3 = this;

      var tempArr = [];
      this.selectFieldList.forEach(function (v, i) {
        tempArr.push(v.key);
      });
      var p = {
        position: 'maindata_index',
        content: tempArr
      };
      (0, _api.postfieldFilter)(p, this.$cookie.getCookie("login")).then(function (res) {
        _this3.drawer = false;
        _this3.showFieldList = JSON.parse((0, _stringify2.default)(_this3.selectFieldList));
        _this3.getField();
      });
    },
    removeSelectField: function removeSelectField(obj) {
      var _this4 = this;

      this.removeArrForObjName(this.selectFieldList, obj);
      var fieldList_key;
      var fieldList_index;

      var _loop = function _loop(key) {
        _this4.fieldList[key].some(function (item, index) {
          if (item.name == obj.name) {
            fieldList_key = key;
            _this4.fieldList[key][index].isCheck = false;
          }
        });
      };

      for (var key in this.fieldList) {
        _loop(key);
      }
    },
    onMove: function onMove(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedElement = relatedContext.item;
      var draggedElement = draggedContext.item;
    },
    fieldConfig: function fieldConfig() {
      this.drawer = true;
    },
    fliedTap: function fliedTap(key, index) {
      var _this5 = this;

      this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
      var result = this.selectFieldList.some(function (item) {
        if (item.name == _this5.fieldList[key][index].name) {
          return true;
        }
      });
      if (this.fieldList[key][index].isCheck) {
        if (!result) {
          this.selectFieldList.push(this.fieldList[key][index]);
        }
      } else {
        if (result) {
          this.removeArrForObjName(this.selectFieldList, this.fieldList[key][index]);
        }
      }
    },
    removeArrForObjName: function removeArrForObjName(_arr, _obj) {
      var length = _arr.length;
      for (var i = 0; i < length; i++) {
        if (_arr[i].name == _obj.name) {
          _arr.splice(i, 1);
          return _arr;
        }
      }
    },
    toogleChart: function toogleChart() {
      debugger;
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(function () {
        that.chartColumn.resize();
      }, 100);
    },
    getList: function getList() {
      var _this6 = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getTotalData)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list != null && res.data.list.length > 0) {
            res.data.list.forEach(function (x, i) {
              x.keyid = 'key' + i;
              x.exData = [];
            });
            _this6.cdata = res.data;
          } else {
            _this6.cdata = res.data;
            _this6.cdata.list = [];
          }


          _this6.maxPage = res.data.max_page;
          _this6.option.xAxis.data = res.data.chart.date;
          _this6.option.series[0].data = res.data.chart.visit_uv;
          _this6.option.series[1].data = res.data.chart.visit_uv_new;
          _this6.option.series[2].data = res.data.chart.total_income;
          _this6.option.series[3].data = res.data.chart.profit;
          _this6.option.series[4].data = res.data.chart.expenses_cost;
          _this6.option.series[5].data = res.data.chart.roi;
        }
      });
    },
    changeId: function changeId(res) {
      this.pdata.issued_app_id = res;
      this.getList();
    },
    tableRowClassName: function tableRowClassName(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;

      return "";
    },
    expands: function expands(r, es) {
      var _this7 = this;

      var isshou = false;
      if (es.length > 0) {
        es.forEach(function (v) {
          if (v.issued_app_id == r.issued_app_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = "issued_app_id=" + r.issued_app_id + "&sdate=" + this.dateVal[0] + "&edate=" + this.dateVal[1];

        (0, _api.getTotalDataDay)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            r.exData = res.data.list;
            _this7.$forceUpdate();
          }
        });
      }
    },
    drawColumnChart: function drawColumnChart() {
      this.chartColumn = _echarts2.default.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    updateBuy: function updateBuy(id) {
      console.log(id);
    }
  },
  created: function created() {

    console.log((0, _jquery2.default)(window).height() - 200);
    this.height = (0, _jquery2.default)(window).height() - 430;
  },
  update: function update() {},
  mounted: function mounted() {

    this.getField();
    document.getElementById("today").focus();

    var _this = this;
  }
};

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _jquery = __webpack_require__(34);

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(66);

var _echarts2 = _interopRequireDefault(_echarts);

var _vuedraggable = __webpack_require__(116);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		draggable: _vuedraggable2.default
	},
	data: function data() {
		return {
			pdata: {
				page: 1,
				perpage: 20,
				issued_app_id: "",
				source: "",
				kw: "",
				sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
				edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
			},
			tText: "请选择创意类型",
			plist: [],
			maxPage: 1,
			config: [],
			editDialog: false,
			group: {},

			dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
			pickerOptions: {
				shortcuts: [{
					text: "昨天",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24);
						picker.$emit("pick", [start, start]);
					}
				}, {
					text: "最近一周",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
						picker.$emit("pick", [start, end]);
					}
				}, {
					text: "最近一个月",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit("pick", [start, end]);
					}
				}, {
					text: "最近三个月",
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit("pick", [start, end]);
					}
				}]
			},
			list: [],
			height: 600,
			drawer: false,
			fieldList: {
				'用户数据': [{
					"name": "活跃用户",
					"key": "visit_uv",
					"isCheck": false
				}, {
					"name": "注册用户",
					"key": "visit_uv_new",
					"isCheck": false
				}],
				'收入数据': [{
					"name": "总流水",
					"key": "total_flow",
					"isCheck": false
				}, {
					"name": "总收入",
					"key": "total_income",
					"isCheck": false
				}, {
					"name": "广告流水",
					"key": "origin_income",
					"isCheck": false
				}, {
					"name": "广告发行分成",
					"key": "origin_divide_income",
					"isCheck": false
				}, {
					"name": "分发矩阵收入",
					"key": "matrix_income",
					"isCheck": false
				}, {
					"name": "分发非矩阵收入",
					"key": "nonmatrix_income",
					"isCheck": false
				}, {
					"name": "分发合计",
					"key": "distribution_income",
					"isCheck": false
				}],
				'支出数据': [{
					"name": "总支出",
					"key": "total_cost",
					"isCheck": false
				}, {
					"name": "cp分成",
					"key": "cp_cost",
					"isCheck": false
				}, {
					"name": "买量",
					"key": "expenses_cost",
					"isCheck": false
				}],
				'分发数据': [{
					"name": "跳出率",
					"key": "jump_per",
					"isCheck": false
				}, {
					"name": "换入活跃",
					"key": "huanliang_in",
					"isCheck": false
				}, {
					"name": "换出活跃",
					"key": "huanliang_out",
					"isCheck": false
				}, {
					"name": "分发收入（含矩阵）",
					"key": "distribution_income",
					"isCheck": false
				}, {
					"name": "arpu（含矩阵）",
					"key": "distribution_day_contribution",
					"isCheck": false
				}, {
					"name": "分发收入（不含矩阵）",
					"key": "nonmatrix_income",
					"isCheck": false
				}, {
					"name": "arpu（不含矩阵）",
					"key": "nonmatrix_day_contribution",
					"isCheck": false
				}, {
					"name": "总arpu",
					"key": "total_day_contribution",
					"isCheck": false
				}],
				'利润': [{
					"name": "利润",
					"key": "profit",
					"isCheck": false
				}, {
					"name": "ROI",
					"key": "roi",
					"isCheck": false
				}, {
					"name": "单个用户价值",
					"key": "arpu",
					"isCheck": false
				}]
			},
			selectFieldList: [],
			showFieldList: []
		};
	},

	watch: {
		dateVal: {
			handler: function handler(n, o) {
				if (n[0]) {
					this.pdata.sdate = n[0];
					this.pdata.edate = n[1];
					this.getField();
				}
			},

			deep: true
		}
	},
	methods: {
		getField: function getField() {
			var _this2 = this;

			console.log(this.pdata.platform_id);

			var _this = this;
			var p = "position=maindata_detail";
			(0, _api.getfieldFilter)(p, this.$cookie.getCookie("login")).then(function (res) {
				console.log(res.data.content);
				if (res.data.content == null || res.data.content.length == 0) {

					res.data.content = ['visit_uv', 'visit_uv_new', 'total_income', 'total_cost', 'profit', 'roi', 'arpu'];
				}
				_this.selectFieldList = [];
				_this.showFieldList = [];
				_this.list = [];
				res.data.content.forEach(function (vv, ii) {
					for (var key in _this.fieldList) {
						_this.fieldList[key].forEach(function (v, i) {

							if (vv == v.key) {
								v.isCheck = true;
								_this.selectFieldList.push(v);
							}
						});
					}
				});
				_this2.showFieldList = JSON.parse((0, _stringify2.default)(_this2.selectFieldList));
				_this2.getList();
			});
		},
		saveSelectField: function saveSelectField() {
			var _this3 = this;

			var tempArr = [];
			this.selectFieldList.forEach(function (v, i) {
				tempArr.push(v.key);
			});
			var p = {
				position: 'maindata_detail',
				content: tempArr
			};
			(0, _api.postfieldFilter)(p, this.$cookie.getCookie("login")).then(function (res) {
				_this3.drawer = false;
				_this3.showFieldList = JSON.parse((0, _stringify2.default)(_this3.selectFieldList));
				_this3.getField();
			});
		},
		removeSelectField: function removeSelectField(obj) {
			var _this4 = this;

			this.removeArrForObjName(this.selectFieldList, obj);
			var fieldList_key;
			var fieldList_index;

			var _loop = function _loop(key) {
				_this4.fieldList[key].some(function (item, index) {
					if (item.name == obj.name) {
						fieldList_key = key;
						_this4.fieldList[key][index].isCheck = false;
					}
				});
			};

			for (var key in this.fieldList) {
				_loop(key);
			}
		},
		onMove: function onMove(_ref) {
			var relatedContext = _ref.relatedContext,
			    draggedContext = _ref.draggedContext;

			var relatedElement = relatedContext.item;
			var draggedElement = draggedContext.item;
		},
		fieldConfig: function fieldConfig() {
			this.drawer = true;
		},
		fliedTap: function fliedTap(key, index) {
			var _this5 = this;

			this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
			var result = this.selectFieldList.some(function (item) {
				if (item.name == _this5.fieldList[key][index].name) {
					return true;
				}
			});
			if (this.fieldList[key][index].isCheck) {
				if (!result) {
					this.selectFieldList.push(this.fieldList[key][index]);
				}
			} else {
				if (result) {
					this.removeArrForObjName(this.selectFieldList, this.fieldList[key][index]);
				}
			}
		},
		removeArrForObjName: function removeArrForObjName(_arr, _obj) {
			var length = _arr.length;
			for (var i = 0; i < length; i++) {
				if (_arr[i].name == _obj.name) {
					_arr.splice(i, 1);
					return _arr;
				}
			}
		},
		getList: function getList() {
			var _this6 = this;

			var p = "";
			var p = "issued_app_id=" + this.pdata.issued_app_id + "&sdate=" + this.pdata.sdate + "&edate=" + this.pdata.edate;

			(0, _api.getTotalDataDay)(p, this.$cookie.getCookie("login")).then(function (res) {
				if (res.code == 200) {
					_this6.list = res.data.list;
					_this6.$forceUpdate();
				}
			});
		},
		tableRowClassName: function tableRowClassName(_ref2) {
			var row = _ref2.row,
			    rowIndex = _ref2.rowIndex;

			return "";
		},
		SizeChange: function SizeChange(v) {
			this.pdata.perpage = v;
			this.getList();
		},
		CurrentChange: function CurrentChange(v) {
			this.pdata.page = v;
			this.getList();
		},
		changeDate: function changeDate(s) {
			this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
		},
		updateBuy: function updateBuy(id) {
			console.log(id);
		},
		changeId: function changeId(res) {
			this.pdata.issued_app_id = res;
			this.getList();
		}
	},
	created: function created() {},
	update: function update() {},
	mounted: function mounted() {

		this.pdata.issued_app_id = this.$route.params.issued_app_id;
		this.dateVal = [this.$route.query.sdate, this.$route.query.edate];
	}
};

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

var _echarts = __webpack_require__(66);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      type: "-1",
      getWhich: "原生广告",
      chartColumn: null,
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_id: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      IssAppList: [],
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 },
      mdata: {},
      bdata: {},
      updateBuyMoney: false,
      updateIndex: "",
      updateGroup: { index_id: "", expenses_cost: "", buy_user: "" },
      chooseProduct: { name: "", id: '' }
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          debugger;
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          if (this.getWhich == "原生广告") {
            this.$route.params.sdate = this.pdata.sdate;
            this.$route.params.edate = this.pdata.edate;
            this.getList();
          } else {
            this.changeGet();
          }
        }
        console.log(11111111111);
      },

      deep: true
    }
  },
  methods: {
    changeProduct: function changeProduct(res) {
      this.$route.params.issued_app_id = res.id;
      this.pdata.issued_app_id = res.id;
      this.getList();
    },
    getIssAPPList: function getIssAPPList() {
      var _this = this;

      var p = "";
      (0, _api.getIssuedAppList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.IssAppList = res.data;
          _this.IssAppList.forEach(function (v, i) {
            if (v.id == _this.pdata.issued_app_id) {
              _this.chooseProduct.name = v.name;
            }
          });
        }
      });
    },
    getList: function getList() {
      var _this2 = this;

      var p = "";

      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getDetailData)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this2.cdata = res.data;
        }
      });
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    changeGet: function changeGet() {
      var _this3 = this;

      var p = "issued_app_id=" + this.pdata.issued_app_id + "&sdate=" + this.pdata.sdate + "&edate=" + this.pdata.edate;
      if (this.getWhich == "分发详情") {
        p += "&issued=" + this.type;
        (0, _api.getMoreDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            _this3.mdata = res.data;
          }
        });
      } else if (this.getWhich == "买量详情") {
        (0, _api.buyDetail)(p, this.$cookie.getCookie("login")).then(function (res) {
          if (res.code == 200) {
            console.log(res);
            _this3.bdata = res.data;
          }
        });
      }
    },
    updateBM: function updateBM(id, index, s) {
      this.updateBuyMoney = true;
      this.updateIndex = index;
      this.updateGroup.index_id = id;
      this.updateGroup.expenses_cost = s.expenses_cost;
      this.updateGroup.buy_user = s.buy_user;
    },
    sUpdate: function sUpdate() {
      var _this4 = this;

      var p = this.updateGroup;
      (0, _api.updateBuy)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this4.bdata.list[_this4.updateIndex].expenses_cost = _this4.updateGroup.expenses_cost;
          _this4.bdata.list[_this4.updateIndex].buy_user = _this4.updateGroup.buy_user;

          _this4.updateBuyMoney = false;
          _this4.updateGroup = { index_id: "", expenses_cost: "", buy_user: "" };
          _this4.updateIndex = "";
        }
      });
    }
  },

  mounted: function mounted() {
    this.pdata.issued_app_id = this.$route.params.issued_app_id;
    if (this.$route.query.sdate != undefined) {
      this.pdata.sdate = this.$route.query.sdate;
    }
    if (this.$route.query.edate != undefined) {
      this.pdata.edate = this.$route.query.edate;
    }
    if (this.$route.query.getWhich != undefined) {
      this.getWhich = this.$route.query.getWhich;
      this.changeGet();
    }

    this.getIssAPPList();
    this.getList();
  },
  created: function created() {
    console.log('created');
  }
};

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(71);

var _keys2 = _interopRequireDefault(_keys);

var _api = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      chartColumn: null,
      pholder: "",
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_id: "",
        kw: "",
        channel_id: '',
        company: '',
        uid: '',

        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      IssAppList: [],

      users: [],
      companys_chiannelList: [],

      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 7 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        shortcuts: [{
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", [start, start]);
          }
        }, {
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      list: [],
      chooseProduct: {}
    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },

      deep: true
    },
    'pdata.issued_app_id': {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    'pdata.company': {
      handler: function handler(n, o) {

        this.getList();
      },

      deep: true
    },
    'pdata.channel_id': {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    },
    'pdata.uid': {
      handler: function handler(n, o) {
        this.getList();
      },

      deep: true
    }
  },
  methods: {
    clear: function clear(str) {
      switch (str) {
        case 'issued_app_id':
          this.pdata.issued_app_id = '';
          break;
        case 'company':
          this.pdata.company = '';
          break;
        case 'channel_id':
          this.pdata.channel_id = '';
          break;
        case 'uid':
          this.pdata.uid = '';
          break;

      }
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        } else if (index === 3) {

          sums[index] = 'N/A';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    getList: function getList() {
      var _this = this;

      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      (0, _api.getLogCost)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            _this.list = res.data.list;
            _this.maxPage = res.data.max_page;
          } else {
            _this.list = [];
          }
        }
      });

      (0, _api.selectUser)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          if (res.data && res.data.length > 0) {
            _this.users = res.data;
          } else {
            _this.users = [];
          }
        }
      });
    },
    getIssAPPList: function getIssAPPList() {
      var _this2 = this;

      var p = "";
      (0, _api.getIssuedAppList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this2.IssAppList = res.data;
          _this2.IssAppList.forEach(function (v, i) {
            if (v.id == _this2.pdata.issued_app_id) {
              _this2.chooseProduct.name = v.name;
            }
          });
        }
      });
      (0, _api.selectC)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {

          if (res.data && res.data.length > 0) {
            _this2.companys_chiannelList = res.data;
          } else {
            _this2.companys_chiannelList = [];
          }
        }
      });
    },
    changeProduct: function changeProduct(res) {

      this.pdata.issued_app_id = res.id;
    },
    SizeChange: function SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange: function CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate: function changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)];
    },
    changeId: function changeId(res) {
      this.pdata.issued_app_id = res;
      this.getList();
    }
  },

  mounted: function mounted() {

    if ((0, _keys2.default)(this.$route.params).length > 0) {
      this.pdata.sdate = this.$route.params.sdate;
      this.pdata.edate = this.$route.params.edate;
      this.pdata.app_id = this.$route.params.app_id;
      this.pholder = this.$route.params.name;
    }
    this.getList();
    this.getIssAPPList();
  }
};

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(8);

exports.default = {
  data: function data() {
    return {
      logDialog: false,
      pdata: {
        _sdate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        _edate: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        _date: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        _app: '0',
        _token: '0',
        _channel: '0',
        type: '',
        _id: '0'
      },
      pdata2: {
        _sdate: new Date(new Date().getTime()).toISOString().slice(0, 10),
        _edate: new Date(new Date().getTime()).toISOString().slice(0, 10),
        _date: new Date(new Date().getTime()).toISOString().slice(0, 10),
        _app: '0',
        _token: '0',
        _channel: '0',
        type: '',
        _id: '0'
      },
      IssAppList: [],
      chooseProduct: { name: "", id: '' },
      chooseProduct2: { name: "", id: '' },
      plog: [],
      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10), new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10)],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 1000 * 60 * 60 * 24;
        }
      },
      errorTime: 0

    };
  },

  watch: {
    dateVal: {
      handler: function handler(n, o) {
        if (n[0]) {
          this.pdata._sdate = n[0];
          this.pdata._edate = n[1];
          this.pdata._date = n[0];
        }
      },

      deep: true
    }

  },
  methods: {
    changeProduct: function changeProduct(res) {
      this.pdata._id = res.id;
    },
    changeProduct2: function changeProduct2(res) {
      this.pdata2._id = res.id;
    },
    getIssAPPList: function getIssAPPList() {
      var _this = this;

      var p = "";
      (0, _api.getIssuedAppList)(p, this.$cookie.getCookie("login")).then(function (res) {
        if (res.code == 200) {
          _this.IssAppList = res.data;
          _this.IssAppList.forEach(function (v, i) {
            if (v.id == _this.pdata.issued_app_id) {
              _this.chooseProduct.name = v.name;
            }
          });
        }
      });
    },
    changeDate: function changeDate(s) {
      this.dateVal = "";
      this.pdata.sdate = new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10);
      this.pdata.edate = new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10);
    },
    cjClick: function cjClick(type, now) {
      var _this2 = this;

      this.pdata._date = this.pdata._sdate;
      this.pdata.type = type;
      this.pdata._token = '0';
      this.pdata._app = "0";
      this.$confirm("确定需要采集吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {

        _this2.logDialog = true;
        _this2.plog = [];
        if (now == 'now') {
          _this2.pdata2._date = _this2.pdata2._sdate;
          _this2.pdata2.type = type;
          _this2.pdata2._token = '0';
          _this2.pdata2._app = "0";

          _this2.diedai(_this2.pdata2);
        } else {
          _this2.diedai(_this2.pdata);
        }
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "已取消采集"
        });
      });
    },
    diedai: function diedai(d) {
      var _this3 = this;

      if (this.logDialog) {
        var newPdata = d;
        newPdata._sdate = newPdata._sdate.replace(/-/g, '');
        newPdata._edate = newPdata._edate.replace(/-/g, '');
        newPdata._date = newPdata._date.replace(/-/g, '');
        var p = "";
        for (var k in newPdata) {
          if (newPdata[k] !== '') p += k + "=" + newPdata[k] + "&";
        }
        console.log(p);

        (0, _api.getPython)(p, this.$cookie.getCookie("login")).then(function (res) {

          if (res) {
            if (res.finish != undefined && res.finish == 1) {
              _this3.plog.unshift(res);
              _this3.$message({ message: "数据采集完成", type: "success" });
              _this3.errorTime = 0;
            } else {
              console.log(_this3);

              _this3.plog.unshift(res);

              res.type = newPdata.type;
              if (res._channel == undefined) {
                res._channel = newPdata._channel;
              }

              newPdata = res;
              console.log(newPdata);
              _this3.diedai(newPdata);
              _this3.errorTime = 0;
            }
          } else {

            if (_this3.errorTime >= 5) {
              _this3.$alert('网络请求失败，请联系管理员', {
                confirmButtonText: '知道了'
              });
            } else {
              setTimeout(function () {
                _this3.diedai(newPdata);
              }, 10000);
              _this3.errorTime++;
            }
          }
        });
      }
    }
  },

  mounted: function mounted() {
    this.getIssAPPList();
  }
};

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['image', 'clearList'],
    data: function data() {
        return {
            uploadUrl: 'https://admin-dist-api.y7y.net/user/upload',
            file: this.image ? this.image : '',
            headMsg: { 'token': '' }
        };
    },

    watch: {
        image: function image(value) {
            this.file = value;
        },
        clearList: function clearList() {
            this.file = '';
        },
        file: function file(value) {
            var list = value;
            this.$emit('update:image', list);
        }
    },
    computed: {
        hideShow: function hideShow() {
            return this.file === '' ? false : true;
        }
    },
    methods: {
        imageUploadSuccess: function imageUploadSuccess(response) {

            if (response.code == 200) {
                this.file = response.data;
            } else if (response.code == 400) {

                this.$message.error(response.msg);
                return false;
            } else {
                this.$message.error(response.msg);
                return false;
            }
        },
        beforeUpload: function beforeUpload(file) {

            var imageSize = file.size / 1024 / 1024 < 1;
            if (!imageSize) {
                this.$message.error('上传封面大小不能超过 1MB!');
            }
            return imageSize;
        },
        handleRemove: function handleRemove() {
            this.file = '';
        }
    },
    mounted: function mounted() {
        this.headMsg.token = this.$cookie.getCookie('login');
    }
};

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(401);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(30);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(407);

var _App2 = _interopRequireDefault(_App);

var _cookie = __webpack_require__(138);

var _elementUi = __webpack_require__(402);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(404);

__webpack_require__(403);

var _searchApp = __webpack_require__(408);

var _searchApp2 = _interopRequireDefault(_searchApp);

var _vueRouter = __webpack_require__(409);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(400);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(62);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(399);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(405);

__webpack_require__(406);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

_vue2.default.component("searchApp", _searchApp2.default);

_vue2.default.prototype.$cookie = { setCookie: _cookie.setCookie, getCookie: _cookie.getCookie, delCookie: _cookie.delCookie };

var router = new _vueRouter2.default({
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
  if (to.path == '/login') {
    (0, _cookie.delCookie)('login');
    (0, _cookie.delCookie)('user');
    (0, _cookie.delCookie)('setGroupId');
  }
  var login = (0, _cookie.getCookie)('login');
  if (!login && to.path != '/login') {
    next({ path: '/login' });
  } else {

    next();
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,
  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setGroupId = exports.decrement = exports.increment = undefined;

var _cookie = __webpack_require__(138);

var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

var setGroupId = exports.setGroupId = function setGroupId(_ref3, groupid) {
    var commit = _ref3.commit;

    (0, _cookie.setCookie)('groupid', groupid, 'Session');
    commit('SETGROUPID', groupid);
};

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

var groupid = exports.groupid = function groupid(state) {
    return state.groupid;
};

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSummaryIndex = exports.getGDBackTListChannelDate = exports.getGDBackTListChannel = exports.getGDBackTList = exports.batchGDTAddFX = exports.batchGDTAddTF = exports.getValidProductPlatform = exports.postfieldFilter = exports.getfieldFilter = exports.getbillCpDatasummaryDetail = exports.getbillCpDataSummary = exports.CPRemark = exports.getCPCompanyList = exports.CPEdit = exports.batchCPAdd = exports.getCPBillDataList = exports.sclog = exports.getBillDataDetail = exports.billDataStatus = exports.billDataAdd = exports.getBillDataList = exports.importAldChannelData = exports.exchangeDailyEdit = exports.getExchangeApp = exports.getIssuedAldCompany = exports.getExchangeCompany = exports.getExchangeDailyDetailDay = exports.getExchangeDailyDetail = exports.getExchangeDailyDay = exports.getExchangeDaily = exports.selectC = exports.selectUser = exports.getLogCost = exports.visitUVNewEdit = exports.selectCompany = exports.PostChannelDiscount = exports.AtvEdit = exports.confirmOff = exports.updateCost = exports.getcostDailyDetailForDays = exports.getcostDailyDetail = exports.getcostDailyForDays = exports.getcostDaily = exports.getIncomeDailyDetail = exports.getIncomeDaily = exports.getProductDailyDetail = exports.getProductDaily = exports.batchAdd = exports.getPython = exports.getIssuedAldChanneList = exports.getIssuedAppList = exports.buyDetail = exports.updateBuy = exports.scpwd = exports.getAppid = exports.getPStatus = exports.getPEdit = exports.getPAdd = exports.getPlist = exports.getChannelUpdate = exports.getCFXDataListDetail = exports.getCFXDataList = exports.getCFXList = exports.getChannelStatus = exports.getChannelEdit = exports.getChannelAdd = exports.notifyOff = exports.getChannelList = exports.getBasiUser = exports.getBasiFrom = exports.getBasiVisit = exports.getBasicData = exports.getMoreDetail = exports.getDetailData = exports.getTotalDataDay = exports.getTotalData = exports.sconfig = exports.smenu = exports.supload = exports.slogin = exports.baseUrl = undefined;

var _axios = __webpack_require__(432);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = 'https://admin-dist-api.y7y.net/';

var baseUrl = exports.baseUrl = base;
var slogin = exports.slogin = function slogin(params) {
    return _axios2.default.post(base + 'user/login', params).then(function (res) {
        return res.data;
    });
};
var supload = exports.supload = function supload(token) {
    return _axios2.default.post(base + 'user/upload', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var smenu = exports.smenu = function smenu(token) {
    return _axios2.default.get(base + 'user/menu?from=32', {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sconfig = exports.sconfig = function sconfig(token) {
    return _axios2.default.get(base + 'setting/index', {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getTotalData = exports.getTotalData = function getTotalData(p, token) {
    return _axios2.default.get(base + 'mainData/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getTotalDataDay = exports.getTotalDataDay = function getTotalDataDay(p, token) {
    return _axios2.default.get(base + 'mainData/day?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var getDetailData = exports.getDetailData = function getDetailData(p, token) {
    return _axios2.default.get(base + 'mainData/detail?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getMoreDetail = exports.getMoreDetail = function getMoreDetail(p, token) {
    return _axios2.default.get(base + 'mainData/creative&' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getBasicData = exports.getBasicData = function getBasicData(p, token) {
    return _axios2.default.get(base + 'baseData/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var getBasiVisit = exports.getBasiVisit = function getBasiVisit(p, token) {
    return _axios2.default.get(base + 'baseData/trend?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var getBasiFrom = exports.getBasiFrom = function getBasiFrom(p, token) {
    return _axios2.default.get(base + 'baseData/distribution?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var getBasiUser = exports.getBasiUser = function getBasiUser(p, token) {
    return _axios2.default.get(base + 'baseData/user?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getChannelList = exports.getChannelList = function getChannelList(p, token) {
    return _axios2.default.get(base + 'IssuedAldChannel/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var notifyOff = exports.notifyOff = function notifyOff(p, token) {
    return _axios2.default.post(base + 'IssuedAldChannel/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getChannelAdd = exports.getChannelAdd = function getChannelAdd(p, token) {
    return _axios2.default.post(base + 'IssuedAldChannel/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var getChannelEdit = exports.getChannelEdit = function getChannelEdit(p, token) {
    return _axios2.default.post(base + 'IssuedAldChannel/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var getChannelStatus = exports.getChannelStatus = function getChannelStatus(p, token) {
    return _axios2.default.post(base + 'IssuedAldChannel/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getCFXList = exports.getCFXList = function getCFXList(p, token) {
    return _axios2.default.get(base + 'IssuedAldData/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getCFXDataList = exports.getCFXDataList = function getCFXDataList(p, token) {
    return _axios2.default.get(base + 'IssuedAldChannelData/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getCFXDataListDetail = exports.getCFXDataListDetail = function getCFXDataListDetail(p, token) {
    return _axios2.default.get(base + 'IssuedAldChannelData/detail?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getChannelUpdate = exports.getChannelUpdate = function getChannelUpdate(p, token) {
    return _axios2.default.post(base + 'issuedChannelData/update', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getPlist = exports.getPlist = function getPlist(p, token) {
    return _axios2.default.get(base + 'issuedApp/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getPAdd = exports.getPAdd = function getPAdd(p, token) {
    return _axios2.default.post(base + 'issuedApp/add', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var getPEdit = exports.getPEdit = function getPEdit(p, token) {
    return _axios2.default.post(base + 'issuedApp/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var getPStatus = exports.getPStatus = function getPStatus(p, token) {
    return _axios2.default.post(base + 'issuedApp/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getAppid = exports.getAppid = function getAppid(p, token) {
    return _axios2.default.get(base + 'app/index?kw=' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var scpwd = exports.scpwd = function scpwd(p, token) {
    return _axios2.default.post(base + 'user/password', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var updateBuy = exports.updateBuy = function updateBuy(p, token) {
    return _axios2.default.post(base + 'MainData/cost', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var buyDetail = exports.buyDetail = function buyDetail(p, token) {
    return _axios2.default.get(base + 'MainData/cost&' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getIssuedAppList = exports.getIssuedAppList = function getIssuedAppList(p, token) {
    return _axios2.default.get(base + 'issuedApp/select?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getIssuedAldChanneList = exports.getIssuedAldChanneList = function getIssuedAldChanneList(p, token) {
    return _axios2.default.get(base + 'IssuedAldChannel/select?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getPython = exports.getPython = function getPython(p, token) {
    return _axios2.default.get(base + 'python/?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var batchAdd = exports.batchAdd = function batchAdd(p, token) {
    return _axios2.default.post(base + 'IssuedAldChannel/batch', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getProductDaily = exports.getProductDaily = function getProductDaily(p, token) {
    return _axios2.default.get(base + 'productDaily/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getProductDailyDetail = exports.getProductDailyDetail = function getProductDailyDetail(p, token) {
    return _axios2.default.get(base + 'productDaily/detail?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getIncomeDaily = exports.getIncomeDaily = function getIncomeDaily(p, token) {
    return _axios2.default.get(base + 'incomeDaily/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getIncomeDailyDetail = exports.getIncomeDailyDetail = function getIncomeDailyDetail(p, token) {
    return _axios2.default.get(base + 'incomeDaily/detail?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getcostDaily = exports.getcostDaily = function getcostDaily(p, token) {
    return _axios2.default.get(base + 'costDaily/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getcostDailyForDays = exports.getcostDailyForDays = function getcostDailyForDays(p, token) {
    return _axios2.default.get(base + 'costDaily/day?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getcostDailyDetail = exports.getcostDailyDetail = function getcostDailyDetail(p, token) {
    return _axios2.default.get(base + 'costDaily/detail?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getcostDailyDetailForDays = exports.getcostDailyDetailForDays = function getcostDailyDetailForDays(p, token) {
    return _axios2.default.get(base + 'costDaily/dday?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var updateCost = exports.updateCost = function updateCost(p, token) {
    return _axios2.default.post(base + 'costDaily/color', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var confirmOff = exports.confirmOff = function confirmOff(p, token) {
    return _axios2.default.post(base + 'IssuedAldChannel/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var AtvEdit = exports.AtvEdit = function AtvEdit(p, token) {
    return _axios2.default.post(base + 'IssuedAldChannelData/atv', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var PostChannelDiscount = exports.PostChannelDiscount = function PostChannelDiscount(p, token) {
    return _axios2.default.post(base + 'IssuedAldChannelData/pr', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var selectCompany = exports.selectCompany = function selectCompany(p, token) {
    return _axios2.default.get(base + 'issuedAldChannel/company?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var visitUVNewEdit = exports.visitUVNewEdit = function visitUVNewEdit(p, token) {
    return _axios2.default.post(base + 'costDaily/update', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getLogCost = exports.getLogCost = function getLogCost(p, token) {
    return _axios2.default.get(base + 'log/cost?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var selectUser = exports.selectUser = function selectUser(p, token) {
    return _axios2.default.get(base + 'user/select?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var selectC = exports.selectC = function selectC(p, token) {
    return _axios2.default.get(base + 'log/select?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getExchangeDaily = exports.getExchangeDaily = function getExchangeDaily(p, token) {
    return _axios2.default.get(base + 'exchange/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getExchangeDailyDay = exports.getExchangeDailyDay = function getExchangeDailyDay(p, token) {
    return _axios2.default.get(base + 'exchange/day?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getExchangeDailyDetail = exports.getExchangeDailyDetail = function getExchangeDailyDetail(p, token) {
    return _axios2.default.get(base + 'exchange/detail?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getExchangeDailyDetailDay = exports.getExchangeDailyDetailDay = function getExchangeDailyDetailDay(p, token) {
    return _axios2.default.get(base + 'exchange/dday?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getExchangeCompany = exports.getExchangeCompany = function getExchangeCompany(p, token) {
    return _axios2.default.get(base + 'exchange/company?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getIssuedAldCompany = exports.getIssuedAldCompany = function getIssuedAldCompany(p, token) {
    return _axios2.default.get(base + 'issuedAldChannel/companys?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getExchangeApp = exports.getExchangeApp = function getExchangeApp(p, token) {
    return _axios2.default.get(base + 'exchange/app?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var exchangeDailyEdit = exports.exchangeDailyEdit = function exchangeDailyEdit(p, token) {
    return _axios2.default.post(base + 'exchange/update', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var importAldChannelData = exports.importAldChannelData = function importAldChannelData(p, token) {
    return _axios2.default.post(base + 'issuedAldChannelData/import', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    });
};

var getBillDataList = exports.getBillDataList = function getBillDataList(p, token) {
    return _axios2.default.get(base + 'billIssuedData/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var billDataAdd = exports.billDataAdd = function billDataAdd(p, token) {
    return _axios2.default.post(base + 'billIssuedData/build', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var billDataStatus = exports.billDataStatus = function billDataStatus(p, token) {
    return _axios2.default.post(base + 'billIssuedData/status', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getBillDataDetail = exports.getBillDataDetail = function getBillDataDetail(p, token) {
    return _axios2.default.get(base + 'billIssuedData/detail?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var sclog = exports.sclog = function sclog(p, token) {
    return _axios2.default.get(base + 'log/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getCPBillDataList = exports.getCPBillDataList = function getCPBillDataList(p, token) {
    return _axios2.default.get(base + 'billCpData/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var batchCPAdd = exports.batchCPAdd = function batchCPAdd(p, token) {
    return _axios2.default.post(base + 'billCpData/import', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var CPEdit = exports.CPEdit = function CPEdit(p, token) {
    return _axios2.default.post(base + 'billCpData/edit', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getCPCompanyList = exports.getCPCompanyList = function getCPCompanyList(p, token) {
    return _axios2.default.get(base + 'cpCompany/select?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var CPRemark = exports.CPRemark = function CPRemark(p, token) {
    return _axios2.default.post(base + 'billCpData/remark', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getbillCpDataSummary = exports.getbillCpDataSummary = function getbillCpDataSummary(p, token) {
    return _axios2.default.get(base + 'billCpData/summary?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getbillCpDatasummaryDetail = exports.getbillCpDatasummaryDetail = function getbillCpDatasummaryDetail(p, token) {
    return _axios2.default.get(base + '/billCpData/summaryDetail?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getfieldFilter = exports.getfieldFilter = function getfieldFilter(p, token) {
    return _axios2.default.get(base + 'user/fieldFilter?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var postfieldFilter = exports.postfieldFilter = function postfieldFilter(p, token) {
    return _axios2.default.post(base + 'user/fieldFilter', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getValidProductPlatform = exports.getValidProductPlatform = function getValidProductPlatform(p, token) {
    return _axios2.default.get(base + 'user/validProductPlatform?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var batchGDTAddTF = exports.batchGDTAddTF = function batchGDTAddTF(p, token) {
    return _axios2.default.post(base + '/issuedAldChannelGdt/batchTf', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var batchGDTAddFX = exports.batchGDTAddFX = function batchGDTAddFX(p, token) {
    return _axios2.default.post(base + '/issuedAldChannelGdt/batchFx', p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getGDBackTList = exports.getGDBackTList = function getGDBackTList(p, token) {
    return _axios2.default.get(base + '/issuedAldChannelGdt/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getGDBackTListChannel = exports.getGDBackTListChannel = function getGDBackTListChannel(p, token) {
    return _axios2.default.get(base + '/issuedAldChannelGdt/channel?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};
var getGDBackTListChannelDate = exports.getGDBackTListChannelDate = function getGDBackTListChannelDate(p, token) {
    return _axios2.default.get(base + '/issuedAldChannelGdt/date?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

var getSummaryIndex = exports.getSummaryIndex = function getSummaryIndex(p, token) {
    return _axios2.default.get(base + 'summary/index?' + p, {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    }).then(function (res) {
        return res.data;
    });
};

/***/ })

},[483]);


// WEBPACK FOOTER //
// static/js/app.42a6a12011293ebd326b.js